import React, { useEffect, useState, useCallback } from "react";
import "./detailpage.scss";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import LineChart from "./LineChart";
import { Accordion, Modal, Offcanvas } from "react-bootstrap";
import axios from "axios";
import {
    api_url,
    twitter_url,
    whatsapp_url,
    facebook_url,
    telegram_url,
    ALCHEMY_API_KEY,
    CREATE_DISPUTE_WINDOW_TIMER,
    share_pool_dapp,
    RAIN_ARBI_CONTRACT_ADDRESS,
    MIN_LIQUIDITY_DISPUTE_CREATION,
    MIN_LIQUIDITY_APPEAL_CREATION,
    BIG_NUMBER_APPROVAL,
    platform_chainId,
    SHARE_MARKET,
    usdr_token,
} from "../../utils/Enviroment";
import { ROUTES } from "../../constants/Routes";
import useWeb3 from "../../hooks/useWeb3";
import UserLiquidity from "../../hooks/dataFetcher/getUserLiquidity";
import Loader from "../../hooks/loader";
import Platformfee from "../../hooks/dataFetcher/platformFee";
import PercentageOptions from "../../hooks/dataFetcher/PercentageOptions";
import ClaimCheck from "../../hooks/dataFetcher/ClaimCheck";
import BalanceOfBatch from "../../hooks/dataFetcher/BalanceOfBatch";
import CurrentPrice from "../../hooks/dataFetcher/getCurrentPrice";
import { isFinite } from "lodash";
import useSocket from "../SocketIo";
import "react-tooltip/dist/react-tooltip.css";
import useCheckTokenExpiration from "../CheckAuth";
import useClaimRewards from "../../hooks/dataFetcher/useClaimRewards";
import PoolTimerUI from "./PoolTimerUI";
import PoolStatusText from "./PoolStatusText";
import {
    formatNumbers,
    isEthereumWalletAddress,
    getBackgroundColor,
    getSellingShares,
    formatPrice,
    extractStreamingId,
    getSocketOrderWithOptionName,
    CalculateTotalSharesandPrice,
    handleToFixedOnDecimals,
    getTxHashAndReceipt,
    sharePoolEmail,
    sharePoolToSocials,
    sendGasFeeAsUsdt,
    handleGasFeeWithBuffer,
    handleGasFeeWithPreparedCalls,
    handleCheckSession,
    preparePreviewPayload,
    shiftStringToSubstring,
    formatNumberWithCommas,
    calculateWinningOptionPayout,
    convertFromWeiEthers,
    getTokenSymbol,
    convertToWeiEthers,
    convertFromWei,
    TitleCaseConversion,
    validateOrderValue,
    formatSmartDecimal,
    checkSufficientBalance,
    getMobileStickyOptionsData,
    getOptionResolvedStatus,
    formatProposerName,
    generatePoolShareMessage,
    getMarketToken,
    getMarketFeeToken,
    getGasFeeToken,
    isSolvencyGateError,
    checkSolvencyGateViaPreview,
} from "../../utils/helpers";
import {
    LIMIT_BUY,
    MARKET_BUY,
    TIMEOUT,
    POOL_ENDED,
    USDT_MOCK_VALUE,
    LIQUIDITY_DISPUTE_CREATION,
    MAX_LIQUIDITY_DISPUTE_CREATION,
    NETWORK_FEES,
    NONE,
    CLOSE_POOL_OPTIONS,
    ONE_MINUTE, APPEAL_WINNER_CAlCULATED, APPEAL_OPENED, APPEAL, DISPUTE, LEX_AI, OLYMPUS_AI, ORACLES, LIGHT_THEME,
    CLOSED,
    UNDER_DISPUTE_STATUS,
    DISPUTE_TIME_EXTENDED,
    PNL_CALCULATION_TIMEOUT,
    RESOLVER,
    RAIN_WALLET_ADDRESS,
    DARK_THEME,
    TOKEN_RAIN, MARKET_TOKEN,
    PRICE_DECIMALS,
    BUY,
    SELL,
    WINNER_PROPOSAL_MODE,
    EVIDENCE_TYPE,
    TRANSACTION_TYPES,
} from "../../utils/constants";
import OrderBook from "./OrderList";
import OpenOrderList from "./OpenOrderList";
import OrderHistory from "./OrderHistory";
import {
    getExtendTimeAndSignature,
    getGeneratedPreview,
    getOrdersListing,
    postClosePool,
    postDisputeMessage,
    postLiveStreaming,
    getPriceData,
    tokenToDollarConvertion,
    getDisputeHistory,
} from "../../utils/services";
import { CalculateFeePreTx, formatDates, formatTimeTo12Hour } from "../../utils/helpers";
import useEscrowOrderSharesHook from "../../hooks/dataSender/EscrowSellOrderShares";
import useResolverBondAmount from "../../hooks/dataFetcher/useResolverBondAmount";
import EntryShares from "../../hooks/dataFetcher/getEntryShares";
import DynamicPayout from "../../hooks/dataFetcher/getDynamicPayout";
import { useTranslation } from "react-i18next";
import usePoolStartCheck from "./PoolStartCheck";
import { encodeFunctionData } from "viem";
import TradePoolAbi from "../../utils/TradePoolAbi.json";
import BalanceOfAbi from "../../utils/BalanceOfAbi.json";
import { useGetAllBalances } from "../AllBalances";
import { userPublicClient, userSmartAccountUsdtBalance, userSmartAccountLegacyUsdtBalance } from "../RecoilAtom";
import { useRecoilValue } from "recoil";
import { userSmartAccount, userSmartAccountClient } from "../RecoilAtom";
import { signPreparedCalls } from "@account-kit/wallet-client";
import { useSessionPermissions } from "../../hooks/checkSessionPermissions";
import { useCheckAllowance } from "../../hooks/dataSender/Allowance";
import { Network, Alchemy } from "alchemy-sdk";
import useClaimEligibility from "../../hooks/dataFetcher/DisputeWindow";
import usePublicPoolResolver from "../../hooks/dataFetcher/PublicPoolResolver";
import useDisputeEndTime from "../../hooks/dataFetcher/DisputeEndTimer";
import OracleAbi from "../../utils/OracleAbi.json";
import WinnerFinalizedBool from "../../hooks/dataFetcher/winnerFinalizedEnvoke";
import OracleWinners from "../../hooks/dataFetcher/getOracleWinner";
import ProgressiveProgressBar from "../ProgressiveProgressBar";
import useOracleTimeExtended from "../../hooks/dataSender/ExtendOracleTime";
import Social from "./Social";
import MyPosition from "./MyPosition";
import { notifyError, notifySuccess } from "../Toast";
import MarketRelated from "../MarketRelated/MarketRelated";
import PoolFinalization from "./PoolFinalization";
import { useTheme } from "../../contexts/ThemeProvider";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import TooltipCustom from "react-bootstrap/Tooltip";
import DateTimePicker from "../common/DateTimePicker";
import CreateDisputeMenu from "./CreateDisputeMenu";
import DisputeOffcanvasMobile from "./DisputeOffcanvasMobile";
import EvidenceFileMenu from "./EvidenceFileMenu";
import { Link } from "react-router-dom";
import SEO from "../SEO";
import Footer from "../landing/footer/Footer";
import { userSmartAccountRainBalance } from "../RecoilAtom";
import WalletConnect from "../WalletConnect/WalletConnect";
import SolvencyLimitModal from "../SolvencyLimitModal/SolvencyLimitModal";
import { DEFAULT_ERROR_HEADING, GAS_FEES_ERROR, TRADE_PLACED_SUCCESS } from "../../utils/ConstantMessages";
import { useEoaAccount } from "../../hooks/useEoaAccount";
import { useChainId, useSwitchChain } from "wagmi";
import PrivateMarketModal from "./PrivateMarketModal";
import ProposedResolutionCanvas from "./ProposedResolutionCanvas";
import PoolFinalizationMobile from "./PoolFinalizationMobile";
import TradePlaceModals from "./TradePlaceModals";
import ProgressModalMobile from "./ProgressModalMobile";
import SuccessModalMobile from "./SuccessModalMobile";
import MarketRulesMobileModal from "./MarketRulesMobileModal";
import OptionDetailMobileModal from "./OptionDetailMobileModal";
import StickyHeadingMobile from "./StickyHeadingMobile";
import ActivityTab from "./ActivityTab";
import TopHolders from "./TopHolders";
import ClaimModal from "./ClaimModal";
import { useSwipeClose } from "../../hooks/useSwipeClose";
import { useScrollLock } from "./useScrollLock";
import MarketOutcomesMobileModal from "./MarketOutcomesMobileModal";

const DetailPage = () => {
    const { theme } = useTheme();
    const {
        messagesocketbuy,
        graph,
        setGraph,
        youTubeId,
        setId,
        id,
        setPoolsDetail,
        poolsdetail,
        getPoolsById,
        closepool,
        winnerdecide,
        setOrdersHistory,
        ordersHistory,
        setOpenOrders,
        openOrders,
        SocketOrderExist,
        exitLiquidityInvestment,
        partiallyFilledOrder,
        disputeEvents,
        decideWinnerTime,
        poolDisputed, isAppealed, appealEvents,
        poolStatus,
        setPoolStatus,
        setClaimCheck,
        claimcheck
    } = useSocket();
    const poolId = poolsdetail?._id;
    const { t } = useTranslation();
    const filteredInvestments = messagesocketbuy
        ?.filter((item) => item.id === poolId)
        ?.map((item) => parseFloat(item.totalInvestment) || 0);
    const totalInvestmentSum = filteredInvestments.reduce((sum, value) => {
        return sum + value;
    }, 0);
    const { disconnectWallet } = useCheckTokenExpiration();
    const web3 = useWeb3();
    const rainWalletFinder = RAIN_WALLET_ADDRESS?.toLowerCase() === poolsdetail?.poolOwnerWalletAddress?.toLowerCase() ? true : false;
    const address = poolsdetail?.contractAddress;
    const [opensocialmodal, setOpenSocialModal] = useState(false);
    const [startProgressBar, setStartProgressBar] = useState(false);
    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [gasFeesSpinner, setGasFeesSpiner] = useState(false);
    const [loadertable, setLoaderTable] = useState(false);
    const [showresubmit, setShowResubmit] = useState(false);
    const [reSubmitOrFinalizeSpinner, setResubmitOrFinalizeSpinner] = useState(false);
    const [poolPnl, setPoolPnl] = useState("N/A");
    const [isCopied, setIsCopied] = useState(false);
    const winnerProposer = poolsdetail?.winnerProposer;
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show1, setShow1] = useState(false);
    const handleClose1 = () => {
        setGasEstimateInUsdt(0);
        setShow1(false);
    };
    const handleShow1 = async () => {
        setShow1(true);
    };
    const [show2, setShow2] = useState(false);
    const { getUserClaimRewards } = useClaimRewards();
    const { getEscrowOrderSharesHook } = useEscrowOrderSharesHook();
    const [userprofile, setUserProfile] = useState([]);
    const handleClose2 = async () => {
        setShow2(false);
        getPoolsById();
        await getPoolActivity();
        await getTopHolders();
        await getPercentagesOption();
        await getSwapBadges();
        await getInvestmentData(id);
    };
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedname, setSelectedName] = useState(null);
    const [show9, setShow9] = useState(false);
    const handleClose9 = () => setShow9(false);
    const handleShow9 = () => setShow9(true);
    const handleShow2 = () => setShow2(true);
    const [show10, setShow10] = useState(false);
    const [successDescription, setSuccessDescription] = useState("");
    const handleClose10 = () => {
        setIsSellTransactionSucceed(false);
        setShow10(false);
        setMessage("");
        setSuccessDescription(null);
        setMblSuccessInfo(null);
        setShowMobileSuccess(false);
        setMblTitle("");
        setMblDescription("");
    };
    const handleShow10 = () => setShow10(true);
    const handleOpenOptionDetail = (optionsMobileData) => {
        setSelectedOptionDetail(optionsMobileData);
    };
    const handlePriceChange = (value) => {
        const priceShare = formatPrice(value);
        setPricePerShare(priceShare);
    };
    const [show8, setShow8] = useState(false);
    const handleClose8 = () => setShow8(false);
    const handleShow8 = () => setShow8(true);
    const [show16, setShow16] = useState(false);
    const handleClose16 = () => {
        setShow16(false);
        getPoolsById();
    };
    const handleShow16 = () => setShow16(true);
    const [show15, setShow15] = useState(false);
    const handleClose15 = () => {
        setShow15(false);
        getPoolsById();
    };
    const handleShow15 = () => setShow15(true);
    const [show14, setShow14] = useState(false);
    const handleClose14 = () => {
        setShow14(false);
        setGasEstimateInUsdt(0);
    };
    const handleShow14 = async () => {
        setShow14(true);
    };
    const [show3, setShow3] = useState(false);
    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);
    const [show33, setShow33] = useState(false);
    const handleClose33 = () => setShow33(false);
    const handleShow33 = () => setShow33(true);
    const [show4, setShow4] = useState(false);
    const handleClose4 = () => setShow4(false);
    const handleShow4 = () => setShow4(true);
    const [show5, setShow5] = useState(false);
    const handleClose5 = () => {
        setShow5(false);
        window.location.reload();
    };
    const handleShow5 = () => setShow5(true);
    const [show11, setShow11] = useState(false);
    const handleClose11 = async () => {
        setShow11(false);
    };
    const handleShow11 = () => setShow11(true);
    const [show12, setShow12] = useState(false);
    const handleClose12 = () => {
        setGasEstimateInUsdt(0);
        setShow12(false);
    };

    useScrollLock(show); // Add Liquidity Modal
    useScrollLock(show1); // Liquidity Finalize Modal

    const handleResolutionSubmit = async () => {
        try {
            const data = new FormData();
            data.append("pool", poolsdetail?._id);
            data.append("role", "proposer");
            data.append("messageType", "mixed");
            const evidenceObj = {
                question: title,
                options: poolsdetail?.options?.map(opt => opt.optionName),
                evidenceType: "mixed",
                description: description,
                source: "creator",
            };
            data.append("evidence", JSON.stringify(evidenceObj));
            files.forEach(file => data.append("files", file));
            await postDisputeMessage(data);
            notifySuccess("Resolution submitted successfully");
            setTitle("");
            setDescription("");
            setFiles([]);
            setEvidenceType(EVIDENCE_TYPE.PHOTO);
        } catch (error) {
            notifyError(DEFAULT_ERROR_HEADING, "Failed to submit resolution");
            console.log("error in handleResolutionSubmit", error);
        }
    };

    const handleConfirmCloseMarket = async () => {
        await killSwitchPool(poolsdetail?.contractAddress);
        setTitle("");
        setDescription("");
        setFiles([]);
        setEvidenceType(EVIDENCE_TYPE.PHOTO);
        setProposedOutcome(null);
        setShowCreateDisputeOffCanvas(false);
        if (winnerProposalMode === WINNER_PROPOSAL_MODE.RESOLUTION) {
            await handleResolutionSubmit();
        }
    };
    const [show13, setShow13] = useState(false);
    const handleClose13 = () => {
        setShow13(false);
        getPoolsById();
    };
    const handleShow13 = () => setShow13(true);
    const [marketinfo, setMarketInfo] = useState(true);
    const [buy, setBuy] = useState("");
    const [showcreatedisputeOffCanvas, setShowCreateDisputeOffCanvas] = useState(false);
    const [winnerProposalMode, setWinnerProposalMode] = useState(WINNER_PROPOSAL_MODE.DISPUTE);
    const [showAiResolutionCanvas, setShowAiResolutionCanvas] = useState(false);
    const [resolutionBondAmount, setResolutionBondAmount] = useState(0);
    const { resolverBond } = useResolverBondAmount();
    const [evidenceType, setEvidenceType] = useState(EVIDENCE_TYPE.PHOTO);
    const [showevidence, setShowEvidence] = useState(false);
    const [showevidenHistory, setShowEvidenceHistory] = useState(false);
    const [hasEvidenHistory, setEvidenHistory] = useState(false);
    const [hasTooEarlyHistory, setHasTooEarlyHistory] = useState(false);
    const [isCreatorResponding, setIsCreatorResponding] = useState(false);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [files, setFiles] = useState([]);
    const [proposedOutcome, setProposedOutcome] = useState(null);
    const [debounce, setDebounce] = useState(buy);
    const [finalDynamicpay, setFinalDynamicPay] = useState("$0");
    const [shareWeReceive, setSharesWeReceive] = useState("0");
    const [buyaddliq, setBuyAddLiq] = useState("");
    const [userliquidity, setUserLiquidity] = useState("");
    const [poolstart, setPoolStart] = useState("");
    const [poolend, setPoolEnd] = useState("");
    const [priceoption, setPriceOption] = useState("");
    const [platformfee, setPlatformFee] = useState("");
    const [percentageoption, setPercentageOption] = useState("");
    const [percentageindiv, setPercentageIndivi] = useState("");
    const [allliquidity, setAllLiquidity] = useState("");
    const [claimvalue, setClaimValue] = useState("");
    const [sumOfClaimvalue, setSumOfClaimValue] = useState("");
    const [swapbalance, setSwapBalance] = useState("");
    const [totalPayout, setTotalPayout] = useState(0);
    const accessToken = localStorage.getItem("accessToken");
    const [activeReplyId, setActiveReplyId] = useState(null);
    const [userPostSellOrderShares, setUserPostSellOrderShares] = useState([]);
    const { entrySharesHook } = EntryShares();
    const CurrentPriceHook = CurrentPrice();
    const { ClaimCheckHook } = ClaimCheck();
    const { PlatformfeeHook, PercentReturnCalculation } = Platformfee();
    const { UserLiquidityHook } = UserLiquidity();
    const { BalanceOfBatchHook } = BalanceOfBatch();
    const { PercentageOptionsHook } = PercentageOptions();
    const [topholders, setTopHolders] = useState([]);
    const [poolactivity, setPoolActivity] = useState([]);
    const [show7, setShow7] = useState(false);
    const { account } = useEoaAccount();
    const handleClose7 = () => {
        setShow7(false);
        setShowMblProgress(false);
        setMblTitle("");
        setMblDescription("");
    };
    const handleShow7 = () => setShow7(true);
    const { DynamicPayoutHook } = DynamicPayout();
    const [volumn, setVolumn] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedToken, setSelectedToken] = useState(null);
    const [comment, setComment] = useState("");
    const [replyComment, setReplyComment] = useState("");
    const [commentlist, setCommentsList] = useState([]);
    const [initialposition, setInitialPosition] = useState("0");
    const [error, setError] = useState(null);
    const [showReplyForm, setShowReplyForm] = useState(false);
    const [parentCommentId, setParentCommentId] = useState(null);
    const [selectedOptionBalancebuy, setSelectedOptionBalanceBuy] =
        useState(null);
    const [selectedswapconversionbuy, setSelectedSwapConversionBuy] =
        useState(null);
    const [gasPrice, setGasPrice] = useState(null);

    const [totalmyposition, setTotalMyPosition] = useState("");
    const [message, setMessage] = useState("");
    const [selectedColor, setSelectedColor] = useState("");
    const [individualShares, setIndividualShares] = useState("");
    const [oraclefixedfee, setOracleFixedFee] = useState("");
    const [creatorfee, setCreatorFee] = useState("");
    const [liquidityfee, setLiquidityFee] = useState("");
    const [ressolvorfee, setResolvorfee] = useState("");
    const [resultfee, setResultfee] = useState("");
    const [resultFeePretx, setResultFeePreTx] = useState("");
    const [isCopiedId, setIsCopiedId] = useState(false);
    const [isCopiedLink, setIsCopiedLink] = useState(false);
    const [isCopiedCode, setIsCopiedCode] = useState(false);
    const [getLiveId, setGetLiveId] = useState(null);
    const smartAccount = useRecoilValue(userSmartAccount);
    const smartAccountClient = useRecoilValue(userSmartAccountClient);
    const [openWalletConnect, setOpenWalletConnect] = useState(null);

    const handlePlaceTradeClick = () => {
        if (!smartAccount) {
            openWalletConnect();
            return;
        }
        if (new Date(poolstart) > new Date()) {
            notifyError(DEFAULT_ERROR_HEADING, t("Market has not started yet."));
            return;
        }
        setSkipPrediction(false);
        setBuyOrSellTabActive(BUY);
        setlimittab(MARKET_BUY);
        setMblTradeModalOpen(true);
    };

    const { grantPermissions } = useSessionPermissions();
    const [currentPage, setCurrentPage] = useState({
        activity: 1,
        topholders: 2,
        comments: 3,
    });
    const [totalPages, setTotalPages] = useState({
        activity: 0,
        topholders: 0,
        comments: 0,
    });
    const [totalCount, setTotalCount] = useState({
        activity: 0,
        topholders: 0,
        comments: 0,
    });
    const [totalParticipants, setTotalParticipants] = useState(0);

    let ownermatch =
        smartAccount?.toLowerCase() === poolsdetail?.poolOwnerWalletAddress.toLowerCase();
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [isSubmittingComment, setIsSubmittingComment] = useState(false);
    const [pollStatus, setPollStatus] = useState("");
    const [isDisabled, setIsDisabled] = useState(false);
    const [selectedOptionSelling, setSelectedOptionSelling] = useState(null);
    const [sharesAmount, setSharesAmount] = useState("");
    const [pricePerShare, setPricePerShare] = useState("");
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [selectedOptionBalancesell, setSelectedOptionBalanceSell] =
        useState(null);
    const [selectedConversionDollarSell, setSelectedDollarConversionSell] =
        useState(null);
    const [key, setKey] = useState("comments");
    const [isSellTransactionSucceed, setIsSellTransactionSucceed] =
        useState(false);
    const [dynamicPayout, setDynamicPayout] = useState([]);
    const [orderBookData, setOrderBookData] = useState([]);
    const [orderFilled, setOrderFilled] = useState([]);
    const [isMobile, setIsMobile] = useState(false);
    const [limittab, setlimittab] = useState("marketbuy");
    const [totalLimitBuying, setTotalLimitBuying] = useState("");
    const [allSharesZero, setAllSharesZero] = useState(false);
    const poolStartCheck = usePoolStartCheck(poolsdetail?.startDate);
    const smartAccountUsdrBalance = useRecoilValue(userSmartAccountUsdtBalance);
    const smartAccountLegacyUsdtBalance = useRecoilValue(userSmartAccountLegacyUsdtBalance);
    const getAllBalances = useGetAllBalances();
    const publicClient = useRecoilValue(userPublicClient);
    const { checkAllowance, getAllowanceByAddress } = useCheckAllowance();
    const isPoolPrivate = poolsdetail?.isPrivate;
    const poolQuestion = poolsdetail?.question;
    const poolOptions = poolsdetail?.options;
    const poolAccessCode = poolsdetail?.accessCode;
    const isNotPoolOwner =
        smartAccount?.toLowerCase() !== poolsdetail?.poolOwnerWalletAddress;
    const [gasEstimateInUsdt, setGasEstimateInUsdt] = useState("");
    const [isSolvencyLimitReached, setIsSolvencyLimitReached] = useState(false);
    const [showSolvencyModal, setShowSolvencyModal] = useState(false);
    const [updatedShares, setUpdatedShares] = useState([]);
    const settings = {
        apiKey: ALCHEMY_API_KEY,
        network: Network.ARB_MAINNET,
    };
    const alchemy = new Alchemy(settings);
    const [selectedClosePoolOption, setSelectedClosePoolOption] = useState(
        CLOSE_POOL_OPTIONS.INSTANT
    );
    const [resolutionTime, setResolutionTime] = useState(null);
    const [showendpool, setShowEndPool] = useState(false);
    const connectedChainId = useChainId()
    const switchChain = useSwitchChain()
    const [isMblTradeModalOpen, setMblTradeModalOpen] = useState(false);
    const [skipPrediction, setSkipPrediction] = useState(false);
    const [showClaimModal, setShowClaimModal] = useState(false);
    const [showMarketRulesModal, setShowMarketRulesModal] = useState(false);
    const [mblSuccessInfo, setMblSuccessInfo] = useState(null);
    const [showMblProgress, setShowMblProgress] = useState(false);
    const [mblTitle, setMblTitle] = useState("");
    const [mblDescription, setMblDescription] = useState("");
    const [showMobileSuccess, setShowMobileSuccess] = useState(false);
    const [selectedOptionDetail, setSelectedOptionDetail] = useState(null);
    const handleCloseEndPool = () => setShowEndPool(false);
    const [showcreatedispute, setShowCreateDispute] = useState(false);

    const gasEstimationDispute = async () => {
        setGasFeesSpiner(true);
        const bigNumberApproval = BIG_NUMBER_APPROVAL;
        const usdtAllowance = await getAllowanceByAddress(marketFeeToken.address, address)
        const rainAllowance = await getAllowanceByAddress(RAIN_ARBI_CONTRACT_ADDRESS, address)
        const requiredDisputeAmountToWei = convertToWeiEthers(requiredDisputeAmount, tokenDecimals)
        const isUsdtApprovalNeeded = +usdtAllowance < +requiredDisputeAmountToWei;
        const isRainApprovalNeeded = +rainAllowance < +requiredDisputeAmountToWei;
        const isAnyApprovalNeeded = isUsdtApprovalNeeded || isRainApprovalNeeded;

        const callArgs = [];
        if (isUsdtApprovalNeeded) {
            callArgs.push({
                to: marketFeeToken.address,
                data: encodeFunctionData({
                    abi: BalanceOfAbi,
                    functionName: "approve",
                    args: [address, bigNumberApproval],
                }),
            });
        }
        if (isRainApprovalNeeded) {
            callArgs.push({
                to: RAIN_ARBI_CONTRACT_ADDRESS,
                data: encodeFunctionData({
                    abi: BalanceOfAbi,
                    functionName: "approve",
                    args: [address, bigNumberApproval],
                }),
            });
        }
        callArgs.push({
            to: address,
            data: encodeFunctionData({
                abi: TradePoolAbi,
                functionName: "openDispute",
            }),
        });
        callArgs.push(...gasFeeCallArg(USDT_MOCK_VALUE));
        await getEstimatedTxGasFee(callArgs, isAnyApprovalNeeded);
    };

    const handleShowCreateDispute = async () => {
        if (!smartAccount) {
            openWalletConnect();
            return;
        }
        if (!checkSufficientBalance(marketTokenBalance, requiredDisputeAmount, tokenSymbol)) return;
        if (disputeOrAppealText === APPEAL) {
            setShowCreateDispute(true);
            setShowCreateDisputeOffCanvas(false);
        }
        await gasEstimationDispute();
    };
    const handleCloseCreateDispute = () => setShowCreateDispute(false);

    const [showresolveearly, setShowResolveEarly] = useState(false);
    const handleShowResolveEarly = () => setShowResolveEarly(true);
    const handleCloseResolveEarly = () => setShowResolveEarly(false);


    const [showpoolclosed, setShowPoolClosed] = useState(false);
    const handleShowPoolClosed = () => setShowPoolClosed(true);
    const handleClosePoolClosed = () => setShowPoolClosed(false);
    const [showdisputecreated, setShowDisputeCreated] = useState(false);
    const handleShowDisputeCreated = () => setShowDisputeCreated(true);
    const handleCloseDisputeCreated = () => setShowDisputeCreated(false);
    const [showclaimedsuccess, setShowClaimedSuccess] = useState(false);
    const handleCloseClaimedSuccess = () => {
        setShowClaimedSuccess(false);
    };
    const handleShowClaimedSuccess = () => setShowClaimedSuccess(true);
    const [showplacing, setShowPlacing] = useState(false);
    const handleClosePlacing = () => {
        setShowPlacing(false);
    };
    const handleShowPlacing = () => setShowPlacing(true);
    const [claimEligibility, setClaimEligibility] = useState("");
    const [publicPoolResolverAddress, setPublicPoolResolverAddress] = useState("");
    const [winnerFinalizedBool, setWinnerFinalizedBool] = useState(null);
    const [poolDisputedWinner, setPoolDisputedWinner] = useState("");
    const [disputeTimer, setDisputeTimer] = useState();
    const { checkClaimEligibility } = useClaimEligibility();
    const publicPoolResolver = usePublicPoolResolver();
    const disputeEndTime = useDisputeEndTime();
    const { WinnerFinalizedBoolHook } = WinnerFinalizedBool();
    const { OracleWinnerHook } = OracleWinners();
    const [isClaimWindowOpen, setIsClaimWindowOpen] = useState(false);
    const [claimNotDisputed, setClaimNotDisputed] = useState(false);
    const [buyOrSellTabActive, setBuyOrSellTabActive] = useState(BUY);
    const [oracleExtendedTimeNo, setOracleExtendedTimeNo] = useState(null);
    const { getNoOfTimeExtended } = useOracleTimeExtended();
    const [showreasoning, setShowReasoning] = useState(false);
    const handleShowReasoning = () => setShowReasoning(true);
    const handleCloseReasoning = () => setShowReasoning(false);
    const [showPrivatePollModal, setShowPrivatePollModal] = useState(false);
    const [showOutcomesModal, setShowOutcomesModal] = useState(false);
    const [hasAccess, setHasAccess] = useState(false);
    const poolUnderDisputeUi = poolDisputed && isAppealed && disputeTimer > 0 && !poolsdetail?.isAppealWinnerAvailable
    const timeExtendUi = disputeTimer === 0 && !poolsdetail?.isAppealWinnerAvailable && oracleExtendedTimeNo !== null && +oracleExtendedTimeNo < 7;
    const revealWinnerUi = poolsdetail?.isAppealWinnerAvailable && winnerFinalizedBool === false;
    const disputeOrAppealText = !isAppealed && poolDisputed ? APPEAL : DISPUTE
    const isUnderDispute = poolDisputed && !isAppealed && poolsdetail?.status === UNDER_DISPUTE_STATUS;
    const isDisputeWinnerDecided = poolDisputed && !isAppealed && poolsdetail?.status === CLOSED;

    const publicPoolResolverText =
        isUnderDispute
            ? <img src={theme === LIGHT_THEME ? "/assets/olympuslogolight.svg" : "/assets/olympuslogo.svg"} alt="img" className='img-fluid' />
            : !isAppealed && poolsdetail?.winnerOption?.decidedBy === OLYMPUS_AI
                ? <img src={theme === LIGHT_THEME ? "/assets/olympuslogolight.svg" : "/assets/olympuslogo.svg"} alt="img" className='img-fluid' />
                : poolDisputed && poolsdetail?.winnerOption?.decidedBy === LEX_AI
                    ? <img src={theme === LIGHT_THEME ? "/assets/olympuslogolight.svg" : "/assets/olympuslogo.svg"} alt="img" className='img-fluid' />
                    : poolDisputed && winnerFinalizedBool && poolsdetail?.winnerOption?.decidedBy === ORACLES
                        ? <img src={theme === LIGHT_THEME ? "/assets/olympuslogolight.svg" : "/assets/olympuslogo.svg"} alt="img" className='img-fluid' />
                        : poolsdetail?.winnerOption?.decidedBy === RESOLVER
                            ? "creator"
                            : null;

    const decidedByText = isUnderDispute ? t("Deciding winner from") : t("Decided By");
    const isPublicPoolResolverAi = poolsdetail?.isAiResolver;
    const smartAccountRainBalance = useRecoilValue(userSmartAccountRainBalance)
    const tokenSymbol = poolsdetail?.token?.tokenSymbol
    // Each market trades in its own token; approvals and network fees use its stablecoin
    const marketToken = getMarketToken(poolsdetail?.token)
    const marketFeeToken = getMarketFeeToken(poolsdetail?.token)
    const gasFeeToken = getGasFeeToken()
    const isUsdrMarket = marketToken === MARKET_TOKEN.USDR
    const marketStableBalance = marketToken === MARKET_TOKEN.USDT ? smartAccountLegacyUsdtBalance : smartAccountUsdrBalance
    // Gas fee call arg — only for USDR markets; USDT and RAIN markets skip gas deduction
    const gasFeeCallArg = (amount) => isUsdrMarket ? [{ to: gasFeeToken.address, data: sendGasFeeAsUsdt(amount) }] : []
    const tokenLogo = poolsdetail?.token?.tokenLogo
    const tokenAddress = poolsdetail?.token?.tokenAddress
    const tokenName = poolsdetail?.token?.tokenName
    const tokenDecimals = poolsdetail?.token?.tokenDecimals
    const tokenToDisplay = marketToken.label
    const marketTokenBalance = marketToken.isStable ? +(marketStableBalance) : +(smartAccountRainBalance)
    const [tokenPriceToUsdt, setTokenPriceToUsd] = useState()
    const [orderValueError, setOrderValueError] = useState(null)
    const canShowProposeResolutionButton =
        (
            poolsdetail?.version > 2 &&
            !poolsdetail?.poolFinalized &&
            new Date() > new Date(poolstart) &&
            pollStatus !== POOL_ENDED
        )
        ||
        (
            poolsdetail?.version <= 2 &&
            ownermatch &&
            !poolsdetail?.poolFinalized &&
            new Date() > new Date(poolstart) &&
            pollStatus !== POOL_ENDED
        );

    const getRequiredDisputeAmount = () => {
        const isAppeal = !isAppealed && poolDisputed;
        const minAmount = isAppeal ? MIN_LIQUIDITY_APPEAL_CREATION : MIN_LIQUIDITY_DISPUTE_CREATION;
        const adjustedMinAmount = !marketToken.isStable && tokenPriceToUsdt
            ? minAmount / tokenPriceToUsdt
            : minAmount;

        const adjustedMaxAmount = !marketToken.isStable && tokenPriceToUsdt
            ? MAX_LIQUIDITY_DISPUTE_CREATION / tokenPriceToUsdt
            : MAX_LIQUIDITY_DISPUTE_CREATION;

        return Math.min(
            Math.max(
                allliquidity * LIQUIDITY_DISPUTE_CREATION,
                adjustedMinAmount
            ),
            adjustedMaxAmount
        );
    };
    const requiredDisputeAmount = getRequiredDisputeAmount();

    useEffect(() => {
        const fetchBondAmount = async () => {
            const bondAmountRes = await resolverBond(poolsdetail?.contractAddress);
            const convertedBondAmountRes = convertFromWeiEthers(bondAmountRes, poolsdetail?.token?.tokenDecimals);
            setResolutionBondAmount(Number(convertedBondAmountRes));
        };
        const isManualResolutionOpen = showcreatedisputeOffCanvas && winnerProposalMode === WINNER_PROPOSAL_MODE.RESOLUTION;
        const isDisputeOrAppealOpen = showcreatedisputeOffCanvas && (winnerProposalMode === WINNER_PROPOSAL_MODE.DISPUTE || winnerProposalMode === WINNER_PROPOSAL_MODE.APPEAL);
        if ((showAiResolutionCanvas || isManualResolutionOpen || isDisputeOrAppealOpen) && poolsdetail?.contractAddress) {
            poolsdetail?.version > 2 && fetchBondAmount();
        }
    }, [showAiResolutionCanvas, showcreatedisputeOffCanvas, winnerProposalMode, poolsdetail?.contractAddress]);

    useEffect(() => {
        if (!poolId) return;
        const fetchHistory = async () => {
            try {
                const data = await getDisputeHistory(poolId);
                setEvidenHistory(Array.isArray(data) && data.length > 0);
                const tooEarlyFound = Array.isArray(data) && data.some(group =>
                    (group?.events || []).some(e => e?.type === "resolution" && e?.stage === "too-early")
                );
                setHasTooEarlyHistory(tooEarlyFound);
            } catch {
                setEvidenHistory(false);
                setHasTooEarlyHistory(false);
            }
        };
        fetchHistory();
    }, [poolId]);

    const getPublicPoolResolver = async () => {
        try {
            const poolResolver = await publicPoolResolver(address);
            setPublicPoolResolverAddress(poolResolver);
        } catch (error) {
            console.log("poolResolverError: ", error);
        }
    };

    const getDisputeWindowTimer = async () => {
        try {
            const windowTimer = await checkClaimEligibility(address);
            setClaimEligibility(windowTimer);
        } catch (error) {
            console.log("claimEligibilitError: ", error);
        }
    };



    const getWinnerFinalizedBool = async () => {
        try {
            const winnerBool = await WinnerFinalizedBoolHook(
                publicPoolResolverAddress
            );
            setWinnerFinalizedBool(winnerBool);
            if (winnerBool) {
                const oracleWinner = await OracleWinnerHook(publicPoolResolverAddress);
                setPoolDisputedWinner(oracleWinner);
            }
        } catch (error) {
            console.error("poolDisputedWinnerError: ", error);
        }
    };

    const getDisputeEndTime = async () => {
        try {
            const newEndTime = await disputeEndTime(publicPoolResolverAddress);
            const now = Math.floor(Date.now() / 1000);
            setDisputeTimer(newEndTime > now ? newEndTime : 0);
            return newEndTime;
        } catch (error) {
            console.error("Error refreshing dispute end time: ", error);
        }
    };

    useEffect(() => {
        if (isAppealed && winnerFinalizedBool === null) return;
        if (isAppealed && disputeTimer === 0 && oracleExtendedTimeNo === null) return;
        if (!decideWinnerTime || claimEligibility == null) return;
        const decideWinnerTimestamp = Math.floor(
            new Date(decideWinnerTime).getTime() / 1000
        );
        const currentTime = Math.floor(Date.now() / 1000);
        const secondsSincePoolEnd = currentTime - decideWinnerTimestamp;
        const claimEligibilityBool =
            secondsSincePoolEnd >=
            (Number(claimEligibility) || CREATE_DISPUTE_WINDOW_TIMER);
        const isUnderDisputeStatus = poolDisputed && !isAppealed && poolsdetail?.status === UNDER_DISPUTE_STATUS;

        if (isAppealed && poolsdetail?.isAppealWinnerAvailable && winnerFinalizedBool) {
            setIsClaimWindowOpen(true);
            setClaimNotDisputed(false);
        } else if (claimEligibilityBool && !isAppealed) {
            if (isUnderDisputeStatus) {
                setIsClaimWindowOpen(false);
                setClaimNotDisputed(false);
            } else {
                setIsClaimWindowOpen(true);
                setClaimNotDisputed(false);
            }
        } else if (!claimEligibilityBool && !isAppealed) {
            if (isUnderDisputeStatus) {
                setIsClaimWindowOpen(false);
                setClaimNotDisputed(false);
            } else {
                setIsClaimWindowOpen(true);
                setClaimNotDisputed(true);
            }
        } else if (+oracleExtendedTimeNo >= 7 && isAppealed && disputeTimer === 0) {
            setIsClaimWindowOpen(true);
        } else {
            setIsClaimWindowOpen(false);
        }
    }, [
        claimEligibility,
        decideWinnerTime,
        isAppealed,
        winnerFinalizedBool,
        oracleExtendedTimeNo,
        poolDisputed,
        poolsdetail,
        disputeTimer,
    ]);

    const getWinnerOption = () => {
        const winnerIndex = winnerFinalizedBool
            ? Number(poolDisputedWinner)
            : poolsdetail?.winnerOption?.choiceIndex;
        const winner = poolsdetail?.options?.find(
            (option) => option?.choiceIndex === winnerIndex
        );
        return { winnerOption: winner?.optionName, winnerId: winner?._id };
    };

    const winnerData = getWinnerOption();

    useEffect(() => {
        if (poolDisputed && isAppealed && publicPoolResolverAddress) {
            getDisputeEndTime();
        }
    }, [poolDisputed, isAppealed, publicPoolResolverAddress]);

    useEffect(() => {
        const extendData = async () => {
            const oracleExtendTimeCount = await getNoOfTimeExtended(
                publicPoolResolverAddress
            );
            setOracleExtendedTimeNo(oracleExtendTimeCount);
        };
        if (poolDisputed && disputeTimer === 0 && publicPoolResolverAddress) {
            extendData();
        }
    }, [poolDisputed, publicPoolResolverAddress, disputeTimer]);

    useEffect(() => {
        const publicPoolData = async () => {
            if (address) {
                await getDisputeWindowTimer();
                await getPublicPoolResolver();
                if ((appealEvents?.eventType === APPEAL_OPENED) || (disputeEvents?.eventType === DISPUTE_TIME_EXTENDED)) {
                    await getDisputeEndTime();
                }
            }
        };
        poolsdetail && publicPoolData();
    }, [smartAccount, address, appealEvents, disputeEvents]);

    useEffect(() => {
        const disputedWinner = async () => {
            if (isDisputeWinnerDecided) {
                await getDisputeWindowTimer();
            }
        }
        disputedWinner()
    }, [isDisputeWinnerDecided]);

    useEffect(() => {
        const resolveData = async () => {
            if (publicPoolResolverAddress) {
                await getWinnerFinalizedBool();
                if (appealEvents?.eventType === APPEAL_WINNER_CAlCULATED) {
                    setWinnerFinalizedBool(appealEvents?.winnerFinalized);
                    setPoolDisputedWinner(appealEvents?.winnerOption?.choiceIndex);
                }
            }
        };
        publicPoolResolverAddress && appealEvents && resolveData();
    }, [
        isPoolPrivate,
        publicPoolResolverAddress,
        smartAccount,
        appealEvents,
    ]);

    useEffect(() => {
        setLoader(true);
        setTimeout(() => {
            setLoader(false);
        }, 3000);
    }, []);

    const handleContinue = async () => {
        const currentTimestamp = Math.floor(Date.now() / 1000);

        if (!selectedOption) {
            notifyError(DEFAULT_ERROR_HEADING, t("Please select an option."));
            return;
        }

        if (!smartAccount) {
            openWalletConnect();
            return;
        }

        if (isUsdrMarket && +gasEstimateInUsdt > +smartAccountUsdrBalance) {
            notifyError(DEFAULT_ERROR_HEADING, "Insufficient balance to resolve market");
            return;
        }
        if (isUsdrMarket && USDT_MOCK_VALUE > +smartAccountUsdrBalance) {
            notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
            return;
        }
        setStartProgressBar(true);
        handleClose3();
        handleShow7();
        const isSessionExists = await handleCheckSession();
        setMessage(
            isSessionExists
                ? "Confirm the transaction in your wallet"
                : t("Deciding Winner")
        );
        handleClose14();
        try {
            const { userPermissions: permissions, userSessionKey: sessionKey } =
                await grantPermissions();
            setMessage(t("Deciding Winner"));

            const callArgs = [
                {
                    to: address,
                    data: encodeFunctionData({
                        abi: TradePoolAbi,
                        functionName: "chooseWinner",
                        args: [selectedOption],
                    }),
                },
                ...gasFeeCallArg(gasEstimateInUsdt),
            ];
            const preparedCalls = await smartAccountClient.prepareCalls({
                calls: callArgs,
                from: smartAccount,
                capabilities: {
                    permissions,
                },
            });
            const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
            const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
                ...signedCalls,
                capabilities: {
                    permissions,
                },
            });
            const txHash = await getTxHashAndReceipt({
                preparedCallId: preparedCallIds[0],
                smartAccountClient,
                publicClient,
            });
            if (txHash) {
                setStartProgressBar(false);
                setTimeout(() => {
                    handleClose7();
                    handleShow15();
                    setMessage("");
                    setGasEstimateInUsdt(0);
                    return txHash;
                }, TIMEOUT);
            }
        } catch (error) {
            if (error.status === 401) {
                notifyError(DEFAULT_ERROR_HEADING,
                    t("Session expired. Please log in again.")
                );
                await disconnectWallet();
            } else {
                notifyError(DEFAULT_ERROR_HEADING, t("Transaction failed. Please try again."));
            }
            handleClose7();
            setMessage("");
        }
    };

    useEffect(() => {
        const calculateShareValue = async () => {
            if (buyOrSellTabActive !== SELL) return;
            if (selectedOptionBalancesell && pricePerShare && sharesAmount) {
                const optionToSell = selectedOptionSelling?.choiceIndex;
                const totalofPriceandShare = sharesAmount * pricePerShare
                setTotalLimitBuying(totalofPriceandShare);
                if (+selectedOptionBalancesell >= +sharesAmount && optionToSell) {
                    if (
                        sharesAmount != "" &&
                        pricePerShare != "" &&
                        +pricePerShare > 0 &&
                        +sharesAmount > 0
                    ) {
                        const error = validateOrderValue(
                            sharesAmount,
                            tokenPriceToUsdt,
                            tokenSymbol,
                            SELL,
                            totalofPriceandShare
                        );
                        setOrderValueError(error);
                        if (error) {
                            setGasEstimateInUsdt(0);
                            return;
                        }
                        setGasFeesSpiner(true);
                        const pricePerShareInWei = convertToWeiEthers(
                            pricePerShare,
                            PRICE_DECIMALS
                        );
                        const amountSharesWei = convertToWeiEthers(sharesAmount, tokenDecimals);
                        const callArgs = [];
                        callArgs.push({
                            to: address,
                            data: encodeFunctionData({
                                abi: TradePoolAbi,
                                functionName: "placeSellOrder",
                                args: [optionToSell, pricePerShareInWei, amountSharesWei],
                            }),
                        });
                        callArgs.push(...gasFeeCallArg(USDT_MOCK_VALUE));
                        await getEstimatedTxGasFee(callArgs, false);
                    }
                } else {
                    setGasEstimateInUsdt(0);
                }
            }
        };
        calculateShareValue();
    }, [selectedOptionSelling, pricePerShare, sharesAmount]);

    const handlePlaceSellOrder = async () => {
        const optionToSell = selectedOptionSelling?.choiceIndex;
        const selectedOptionBalancesellNumber = Number(selectedOptionBalancesell);
        const sharesAmountInNum = Number(sharesAmount);
        const pricePerShareInNum = Number(pricePerShare);

        if (!smartAccount) {
            openWalletConnect();
            return;
        } else if (!optionToSell) {
            notifyError(DEFAULT_ERROR_HEADING, t("Please select an option."));
            return;
        } else if (selectedOptionBalancesellNumber === 0) {
            notifyError(DEFAULT_ERROR_HEADING, t("You don't have any shares to sell."));
            return;
        } else if (selectedOptionBalancesellNumber < sharesAmountInNum) {
            notifyError(DEFAULT_ERROR_HEADING, t("Order size exceeds available shares."));
            return;
        } else if (sharesAmountInNum <= 0) {
            notifyError(DEFAULT_ERROR_HEADING, t("Amount of shares must be a valid number greater than 0"));
            return;
        } else if (pricePerShareInNum < 0.01) {
            notifyError(DEFAULT_ERROR_HEADING,
                t("Minimum price per share is $0.01.")
            );
            return;
        } else if (pricePerShareInNum > 0.99) {
            notifyError(DEFAULT_ERROR_HEADING, t("Maximum price per share is $0.99. $0.99"));
            return;
        } else if (
            pricePerShareInNum?.toString() > pricePerShareInNum?.toFixed(2)
        ) {
            notifyError(DEFAULT_ERROR_HEADING,
                t("Price per share must not have more than two decimal places")
            );
            return;
        } else if (isUsdrMarket && +gasEstimateInUsdt > +smartAccountUsdrBalance) {
            notifyError(DEFAULT_ERROR_HEADING, "Insufficient balance for Selling");
            return;
        } else if (isUsdrMarket && USDT_MOCK_VALUE > +smartAccountUsdrBalance) {
            notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
            return;
        } else if (+gasEstimateInUsdt <= 0) {
            notifyError(DEFAULT_ERROR_HEADING,
                `Error in estimating ${NETWORK_FEES} with this amount. Please try again.`
            );
            return;
        }

        setMblTradeModalOpen(false);
        setShowMblProgress(true);
        const amountSharesWei = convertToWeiEthers(sharesAmount, tokenDecimals);
        const pricePerShareInWei = convertToWeiEthers(pricePerShare, PRICE_DECIMALS);
        setStartProgressBar(true);
        handleShow7();
        const isSessionExists = await handleCheckSession();
        setMessage(
            isSessionExists
                ? "Confirm the transaction in your wallet"
                : t("Placing Sell Order")
        );
        let transactionResponse;

        try {
            const { userPermissions: permissions, userSessionKey: sessionKey } =
                await grantPermissions();
            setMessage(t("Placing Sell Order"));

            const callArgs = [
                {
                    to: address,
                    data: encodeFunctionData({
                        abi: TradePoolAbi,
                        functionName: "placeSellOrder",
                        args: [optionToSell, pricePerShareInWei, amountSharesWei],
                    }),
                },
                ...gasFeeCallArg(gasEstimateInUsdt),
            ];
            const preparedCalls = await smartAccountClient.prepareCalls({
                calls: callArgs,
                from: smartAccount,
                capabilities: {
                    permissions,
                },
            });
            const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
            const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
                ...signedCalls,
                capabilities: {
                    permissions,
                },
            });
            const transactionResponse = await getTxHashAndReceipt({
                preparedCallId: preparedCallIds[0],
                smartAccountClient,
                publicClient,
            });
            if (transactionResponse) {
                setStartProgressBar(false);
                setTimeout(async () => {
                    handleClose7();
                    setMessage(isMobile ? "Trade Placed" : t("Sell Order Successfully Placed"));
                    setIsSellTransactionSucceed(true);
                    setSharesAmount("");
                    setPricePerShare("");
                    setGasEstimateInUsdt(0);
                    handleShow10();
                    return;
                }, TIMEOUT);
            }
            return transactionResponse;
        } catch (error) {
            if (error?.status === 401) {
                notifyError(DEFAULT_ERROR_HEADING,
                    t("Session expired. Please log in again.")
                );
                await disconnectWallet();
            } else {
                setStartProgressBar(false);
                handleClose7();
                handleClose10();
                setMessage("");
                notifyError(DEFAULT_ERROR_HEADING, t("Transaction failed or rejected."));
            }
        }
    };

    const handleCancelAll = async () => {
        const sellOrders = openOrders.filter((order) => order.orderType === SELL);
        const buyOrders = openOrders.filter((order) => order.orderType === BUY);
        if (isUsdrMarket && USDT_MOCK_VALUE > +smartAccountUsdrBalance) {
            notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
            return;
        }
        handleShow7();

        if (sellOrders.length > 0) {
            const options = sellOrders.map((order) => order.orderOption);
            const prices = sellOrders.map((order) => order.pricePerShare);
            const ids = sellOrders.map((order) => order.externalID);

            await CancelingPoolOrders({
                optionNumber: options,
                PriceofShares: prices,
                OrderId: ids,
                orderType: SELL,
                isMultiple: sellOrders.length > 1 || buyOrders.length > 0,
                showSuccess: buyOrders.length === 0,
            });
        }

        if (buyOrders.length > 0) {
            const options = buyOrders.map((order) => order.orderOption);
            const prices = buyOrders.map((order) => order.pricePerShare);
            const ids = buyOrders.map((order) => order.externalID);

            await CancelingPoolOrders({
                optionNumber: options,
                PriceofShares: prices,
                OrderId: ids,
                orderType: BUY,
                isMultiple: buyOrders.length > 1 || sellOrders.length > 0,
                showSuccess: true,
            });
        }
    };

    const CancelingPoolOrders = async ({
        optionNumber,
        PriceofShares,
        OrderId,
        orderType,
        isMultiple = false,
        showSuccess = true,
    }) => {
        if (isUsdrMarket && USDT_MOCK_VALUE > +smartAccountUsdrBalance) {
            notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
            return;
        }
        const optionNumbers = isMultiple ? optionNumber : [optionNumber];
        const pricePerShareInWeiArray = isMultiple
            ? PriceofShares.map((price) => convertToWeiEthers(price, PRICE_DECIMALS))
            : [convertToWeiEthers(PriceofShares, PRICE_DECIMALS)];
        const orderIds = isMultiple ? OrderId : [OrderId];
        let transactionResponse;
        setStartProgressBar(true);
        handleShow7();
        const actionText = isMultiple
            ? t(`Cancelling all ${orderType.toUpperCase()} Orders`)
            : t(`Cancelling ${orderType.toUpperCase()} Order`);
        const successText = isMultiple
            ? t(`All Orders Cancelled`)
            : t(`${orderType.toUpperCase()} Order Cancelled`);
        setMessage(actionText);

        try {
            const { userPermissions: permissions, userSessionKey: sessionKey } =
                await grantPermissions();
            const callArgs = [
                {
                    to: address,
                    data: encodeFunctionData({
                        abi: TradePoolAbi,
                        functionName:
                            orderType === SELL ? "cancelSellOrders" : "cancelBuyOrders",
                        args: [optionNumbers, pricePerShareInWeiArray, orderIds],
                    }),
                },
                ...gasFeeCallArg(USDT_MOCK_VALUE),
            ];
            const gasFee = await handleGasFeeWithBuffer(
                smartAccount,
                callArgs,
                alchemy
            );
            if (isUsdrMarket && +gasFee > +smartAccountUsdrBalance) {
                notifyError(DEFAULT_ERROR_HEADING,
                    t(`Insufficient balance Need $${gasFee?.toFixed(4)} to cancel the orders`)
                );
                return;
            }
            const callArgsWithGasFees = [
                {
                    to: address,
                    data: encodeFunctionData({
                        abi: TradePoolAbi,
                        functionName:
                            orderType === SELL ? "cancelSellOrders" : "cancelBuyOrders",
                        args: [optionNumbers, pricePerShareInWeiArray, orderIds],
                    }),
                },
                ...gasFeeCallArg(gasFee),
            ];
            const preparedCalls = await smartAccountClient.prepareCalls({
                calls: callArgsWithGasFees,
                from: smartAccount,
                capabilities: {
                    permissions,
                },
            });
            const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
            const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
                ...signedCalls,
                capabilities: {
                    permissions,
                },
            });
            const transactionResponse = await getTxHashAndReceipt({
                preparedCallId: preparedCallIds[0],
                smartAccountClient,
                publicClient,
            });
            if (transactionResponse) {
                if (showSuccess) {
                    setStartProgressBar(false);
                    setTimeout(async () => {
                        handleClose7();
                        setMessage(successText);
                        handleShow10();
                        setGasEstimateInUsdt(0);
                    }, TIMEOUT);
                }
                return;
            }
        } catch (error) {
            if (error?.status === 401) {
                notifyError(DEFAULT_ERROR_HEADING,
                    t("Session expired. Please log in again.")
                );
            } else {
                setStartProgressBar(false);
                handleClose7();
                handleClose10();
                setMessage("");
                notifyError(DEFAULT_ERROR_HEADING, t("Transaction denied"));
            }
        }
    };

    const killSwitchPool = async (address) => {
        if (selectedClosePoolOption === CLOSE_POOL_OPTIONS.SCHEDULE) {
            const selectedDateTime = new Date(resolutionTime);
            const endDate = new Date(poolend);
            const minAllowedTime = new Date(endDate.getTime() + ONE_MINUTE);
            if (selectedDateTime.getTime() <= endDate.getTime()) {
                notifyError(DEFAULT_ERROR_HEADING,
                    t("Selected date and time must be after the market end time.")
                );
                return;
            } else if (selectedDateTime.getTime() < minAllowedTime.getTime()) {
                notifyError(DEFAULT_ERROR_HEADING,
                    t(
                        "Selected time must be at least 1 minute after the market end time."
                    )
                );
                return;
            }
        }

        if (isUsdrMarket && USDT_MOCK_VALUE > +smartAccountUsdrBalance) {
            notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
            return;
        }
        setStartProgressBar(true);
        if (isMobile) {
            setShowMblProgress(true);
            setMblTitle("Submitting Proposal");
            setMblDescription("Please wait while your proposal is being processed.");
        }
        handleShow7();
        handleClose12();
        handleCloseResolveEarly();
        handleCloseEndPool();
        const callArgs = [];

        try {
            const accessToken = localStorage.getItem("accessToken");
            const tokenCheckRes = await fetch(
                `${api_url}/users/check-token-expiration?token=${accessToken}`,
                {
                    method: "GET",
                }
            );
            const tokenCheckData = await tokenCheckRes.json();

            if (!tokenCheckRes.ok || tokenCheckData.isExpired) {
                setLoader(false);
                setMessage("");
                notifyError(DEFAULT_ERROR_HEADING, "Access token expired or invalid. Please log in again.");
                await disconnectWallet();
                return;
            }

            if (isUsdrMarket && +gasEstimateInUsdt > +smartAccountUsdrBalance) {
                notifyError(DEFAULT_ERROR_HEADING, t(`Insufficient balance to close the pool`));
                return;
            }
            const isSessionExists = await handleCheckSession();
            setMessage(
                isSessionExists
                    ? "Confirm the transaction in your wallet"
                    : t("Proposing Resolution")
            );
            if (
                selectedClosePoolOption === CLOSE_POOL_OPTIONS?.INSTANT
            ) {
                await postClosePool(id);
            } else if (
                selectedClosePoolOption === CLOSE_POOL_OPTIONS?.SCHEDULE &&
                resolutionTime
            ) {
                const resolutionTimeISO = resolutionTime.toISOString();
                await postClosePool(id, resolutionTimeISO);
            }
            const { userPermissions: permissions, userSessionKey: sessionKey } =
                await grantPermissions();
            setMessage(t("Proposing Resolution"));
            if (poolsdetail?.version <= 2) {
                const closePoolData = encodeFunctionData({ abi: TradePoolAbi, functionName: "closePool" });
                callArgs.push({ to: address, data: closePoolData });
                if (!isPublicPoolResolverAi) {
                    const chooseWinnerData = encodeFunctionData({ abi: TradePoolAbi, functionName: "chooseWinner", args: [proposedOutcome?.choiceIndex] });
                    callArgs.push({ to: address, data: chooseWinnerData });
                }
                callArgs.push(...gasFeeCallArg(USDT_MOCK_VALUE));
            }

            else {
                const bigNumberApproval = BIG_NUMBER_APPROVAL;
                const bondInWei = convertToWeiEthers(resolutionBondAmount, tokenDecimals);
                const usdtAllowance = await getAllowanceByAddress(marketFeeToken.address, address);
                const rainAllowance = await getAllowanceByAddress(RAIN_ARBI_CONTRACT_ADDRESS, address);
                const isUsdtApprovalNeeded = +usdtAllowance < +bondInWei;
                const isRainApprovalNeeded = +rainAllowance < +bondInWei;

                if (isUsdtApprovalNeeded) {
                    callArgs.push({
                        to: marketFeeToken.address,
                        data: encodeFunctionData({ abi: BalanceOfAbi, functionName: "approve", args: [address, bigNumberApproval] }),
                    });
                }
                if (isRainApprovalNeeded) {
                    callArgs.push({
                        to: RAIN_ARBI_CONTRACT_ADDRESS,
                        data: encodeFunctionData({ abi: BalanceOfAbi, functionName: "approve", args: [address, bigNumberApproval] }),
                    });
                }
                const closePoolData = isPublicPoolResolverAi
                    ? encodeFunctionData({ abi: TradePoolAbi, functionName: "closePool" })
                    : encodeFunctionData({ abi: TradePoolAbi, functionName: "closePool", args: [proposedOutcome?.choiceIndex] });
                callArgs.push({ to: address, data: closePoolData });
                callArgs.push(...gasFeeCallArg(USDT_MOCK_VALUE));
            }
            const preparedCalls = await smartAccountClient.prepareCalls({
                calls: callArgs,
                from: smartAccount,
                capabilities: {
                    permissions,
                },
            });
            const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
            const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
                ...signedCalls,
                capabilities: {
                    permissions,
                },
            });
            const txHash = await getTxHashAndReceipt({
                preparedCallId: preparedCallIds[0],
                smartAccountClient,
                publicClient,
            });
            if (txHash) {
                setStartProgressBar(false);
                setTimeout(() => {
                    handleClose12();
                    handleClose7();
                    if (isMobile) {
                        setMblTitle("Proposal Submitted!");
                        setMblDescription("The market remains open for the duration of the dispute window.");
                        setShowMobileSuccess(true);
                        handleShow10();
                    } else {
                        handleShow13();
                    }
                    setMessage("");
                    setGasEstimateInUsdt(0);
                }, TIMEOUT);
                return txHash;
            }
        } catch (error) {
            setStartProgressBar(false);
            handleClose7();
            setMessage("");
            notifyError(DEFAULT_ERROR_HEADING, "Unable to close market. Please try again.");
        }
    };


    const handleSelectOption = (
        option,
        index,
        background,
        totalSupplyLP,
        PriceConversion
    ) => {
        setSelectedSwapConversionBuy(PriceConversion);
        setSelectedOption(option);
        setSelectedOptionBalanceBuy(swapbalance[option._id] || 0);
        setSelectedIndex(index);
        setSelectedColor(background);
        setIndividualShares(totalSupplyLP);
        handleClose33();
    };

    const handleSelecttoken = (token) => {
        setSelectedToken(token);
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const idFromQuery = searchParams.get("id");
        if (idFromQuery) {
            setId(idFromQuery);
        }
    }, [id]);

    const getEscrowOrderShares = async () => {
        const optionsInPool = poolsdetail?.options;
        const optionsIdsInPool = optionsInPool?.map((option) => option.choiceIndex);
        try {
            const userPostSellOrderSharesBigNumbers = await getEscrowOrderSharesHook(
                address,
                optionsIdsInPool
            );
            const userPostSellOrderShares = userPostSellOrderSharesBigNumbers.map(bn => {
                return Number(convertFromWeiEthers(bn, tokenDecimals));
            });
            setUserPostSellOrderShares(userPostSellOrderShares);
            return userPostSellOrderShares;
        } catch (error) {
            console.error("error: ", error);
        }
    };

    useEffect(() => {
        const escrowShares = async () => {
            await getEscrowOrderShares();
        };
        if (smartAccount && poolsdetail) {
            escrowShares();
        }
    }, [poolsdetail, smartAccount]);

    const tokens = [{ id: 2, name: marketToken.label, imgSrc: marketToken.icon }];

    const getTotalVolumn = async (id) => {
        try {
            const url = `${api_url}/investments/options-total-volume?poolId=${id}`;

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            setVolumn(response?.data?.data);
        } catch (error) {
            console.error("Error fetching pools volumn:", error);
        }
    };

    useEffect(() => {
        if (id) {
            getTotalVolumn(id);
        }
    }, [id]);

    const getPoolActivity = async (offset = 1, section = "activity") => {
        setLoaderTable(true);
        const params = {
            offset,
            limit: 10,
        };
        try {
            const url = `${api_url}/investments/${id}/pool-activity`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
                params: params,
            });
            setPoolActivity(response?.data?.data?.activities);
            setTotalPages((prev) => ({
                ...prev,
                [section]: response.data.data.pages,
            }));
            setTotalCount((prev) => ({
                ...prev,
                [section]: response.data.data.total,
            }));
            setLoaderTable(false);
        } catch (error) {
            console.error("Error fetching pools:", error);
            setLoaderTable(false);
        }
    };

    useEffect(() => {
        if (id) {
            getPoolActivity(currentPage.activity, "activity");
        }
    }, [id, currentPage.activity]);

    const getTopHolders = async (choiceIndexes = 1) => {
        if (choiceIndexes !== undefined) {
            try {
                const url = `${api_url}/investments/${id}/top-holders?option=${choiceIndexes}`;
                const response = await axios.get(url, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "multipart/form-data",
                    },
                });
                setTopHolders(response?.data?.data);
                // setLoaderTable(false);
            } catch (error) {
                console.error("Error fetching top holders:", error);
                // setLoaderTable(false);
            }
        }
    };

    useEffect(() => {
        if (poolsdetail?.options) {
            const choiceIndexes = 1;
            getTopHolders(choiceIndexes);
        }
    }, [poolsdetail]);

    const getPoolPnl = async (id) => {
        try {
            const url = `${api_url}/investments/pnl/${id}`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            const res = response?.data?.data[0]?.pnl;
            const resfromwei = convertFromWeiEthers(res, tokenDecimals);
            setPoolPnl(resfromwei);
        } catch (error) {
            console.error("Error fetching pools:", error);
        }
    };

    const getPoolsByIdOnlyliquidity = async (id) => {
        try {
            const url = `${api_url}/pools/pool/${id}`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            const liquidityres = response?.data?.data;
            const LiquidtyFromWei = convertFromWeiEthers(
                liquidityres.totalLiquidity,
                liquidityres?.token?.tokenDecimals
            );
            setAllLiquidity(LiquidtyFromWei);
        } catch (error) {
            console.error("Error fetching pools:", error)
        }
    };

    useEffect(() => {
        if (id) {
            getPoolsByIdOnlyliquidity(id);
            accessToken && tokenDecimals && getPoolPnl(id);
        }
    }, [id, accessToken, tokenDecimals]);

    const getSignOfBuy = async (limittab) => {
        if (isButtonDisabled) return;
        setIsButtonDisabled(true);
        setTimeout(() => {
            setIsButtonDisabled(false);
        }, 5000);
        if (!smartAccount) {
            openWalletConnect();
            return;
        }
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) {
            notifyError(DEFAULT_ERROR_HEADING, t("Session expired. Please log in again."));
            await disconnectWallet();
            return;
        }
        try {
            const tokenCheckRes = await axios.get(
                `${api_url}/users/check-token-expiration?token=${accessToken}`
            );
            const tokenCheckData = tokenCheckRes.data;

            if (tokenCheckData.isExpired) {
                notifyError(DEFAULT_ERROR_HEADING, t("Session expired. Please log in again."));
                await disconnectWallet();
                return;
            }

            const currentTimeUTC = new Date();
            const poolStartDate = new Date(poolstart);

            if (poolStartDate > currentTimeUTC) {
                notifyError(DEFAULT_ERROR_HEADING, t("Market has not started yet."));
                return;
            } else if (!selectedOption) {
                notifyError(DEFAULT_ERROR_HEADING, t("Please select an option"));
                return;
            } else if (
                limittab === MARKET_BUY &&
                (parseFloat(buy) <= 0 || isNaN(parseFloat(buy)))
            ) {
                notifyError(DEFAULT_ERROR_HEADING, t("Please enter an amount."));
                return;
            } else if (
                limittab === MARKET_BUY &&
                +buy > marketTokenBalance
            ) {
                notifyError(DEFAULT_ERROR_HEADING, t("Insufficient balance to complete this transaction."));
                return;
            } else if (
                limittab === MARKET_BUY &&
                +buy >= marketTokenBalance
            ) {
                notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
                return;
            } else if (
                limittab === MARKET_BUY &&
                ((poolsdetail?.poolFinalized === true) || (poolend &&
                    new Date(poolend) < new Date())) &&
                orderBookData.length === 0
            ) {
                notifyError(DEFAULT_ERROR_HEADING, t("There is no sell order to Buy!"));
                return;
            } else if (
                limittab === LIMIT_BUY &&
                Number(pricePerShare?.length === 0)
            ) {
                notifyError(DEFAULT_ERROR_HEADING, t("Please enter a price per share."));
                return;
            } else if (limittab === LIMIT_BUY && Number(sharesAmount?.length === 0)) {
                notifyError(DEFAULT_ERROR_HEADING, t("Amount of shares cannot be empty."));
                return;
            } else if (limittab === LIMIT_BUY && pricePerShare < 0.01) {
                notifyError(DEFAULT_ERROR_HEADING,
                    t("Minimum price per share is $0.01.")
                );
                return;
            } else if (limittab === LIMIT_BUY && pricePerShare > 0.99) {
                notifyError(DEFAULT_ERROR_HEADING, t("Maximum price per share is $0.99. $0.99"));
                return;
            } else if (
                limittab === LIMIT_BUY &&
                +sharesAmount > marketTokenBalance
            ) {
                notifyError(DEFAULT_ERROR_HEADING, t("Insufficient balance to complete this transaction."));
                return;
            } else if (
                limittab === LIMIT_BUY &&
                +sharesAmount >= marketTokenBalance
            ) {
                notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
                return;
            } else if (
                limittab === LIMIT_BUY &&
                isUsdrMarket && +gasEstimateInUsdt > +smartAccountUsdrBalance
            ) {
                notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
                return;
            } else if (
                limittab === MARKET_BUY &&
                isUsdrMarket && +gasEstimateInUsdt > +smartAccountUsdrBalance
            ) {
                notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
                return;
            } else if (+gasEstimateInUsdt <= 0) {
                if (isSolvencyLimitReached) {
                    setShowSolvencyModal(true);
                } else {
                    notifyError(DEFAULT_ERROR_HEADING, `Error in estimating ${NETWORK_FEES} with this amount. Please try again.`);
                }
                return;
            }

            setMblTradeModalOpen(false);
            const buyInWei = convertToWeiEthers(
                (limittab === MARKET_BUY ? buy : sharesAmount),
                tokenDecimals
            );
            await getBuyTrade(buyInWei, limittab);
        } catch (error) {
            console.error("Error in getSignOfBuy:", error);
            let isSolvency = isSolvencyGateError(error);
            if (!isSolvency && publicClient) {
                try { isSolvency = await checkSolvencyGateViaPreview(publicClient, usdr_token); }
                catch { }
            }
            if (isSolvency) setShowSolvencyModal(true);
            else notifyError(DEFAULT_ERROR_HEADING, "An error occurred. Please try again.");
        } finally {
            setLoader(false);
        }
    };

    const getEstimatedTxGasFee = async (callArgs, isAllowanceNeeded) => {
        setIsSolvencyLimitReached(false);
        if (!isUsdrMarket || smartAccountUsdrBalance > 0) {
            if (isUsdrMarket && USDT_MOCK_VALUE > +smartAccountUsdrBalance) {
                notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
                setGasEstimateInUsdt(0);
                setGasFeesSpiner(false);
                return;
            }
        }
        try {
            if (isAllowanceNeeded) {
                const gasFee = await handleGasFeeWithPreparedCalls(
                    smartAccountClient,
                    smartAccount,
                    callArgs
                );
                setGasEstimateInUsdt(gasFee);
                setGasFeesSpiner(false);
                return gasFee;
            } else {
                const gasFee = await handleGasFeeWithBuffer(
                    smartAccount,
                    callArgs,
                    alchemy
                );
                setGasEstimateInUsdt(gasFee);
                setGasFeesSpiner(false);
                return gasFee;
            }
        } catch (error) {
            let isSolvency = isSolvencyGateError(error);
            if (!isSolvency && publicClient) {
                try { isSolvency = await checkSolvencyGateViaPreview(publicClient, usdr_token); }
                catch { /* fall through to generic */ }
            }
            setIsSolvencyLimitReached(isSolvency);
            setGasEstimateInUsdt(0);
            setGasFeesSpiner(false);
        }
    };

    const getBuyTrade = async (buyInWei, limittab) => {
        if (connectedChainId !== platform_chainId) {
            await switchChain.mutateAsync({ chainId: platform_chainId })
        }
        const selectedoption = selectedOption?.choiceIndex;
        try {
            setStartProgressBar(true);
            handleShow7();
            const isSessionExists = await handleCheckSession();
            setMessage(
                isSessionExists
                    ? "Confirm the transaction in your wallet"
                    : t("Placing your order")
            );
            const { userPermissions: permissions, userSessionKey: sessionKey } =
                await grantPermissions();
            setMessage(t("Placing your order"));
            const bigNumberApproval = BIG_NUMBER_APPROVAL;
            const usdtAllowance = await getAllowanceByAddress(marketFeeToken.address, address)
            const rainAllowance = await getAllowanceByAddress(RAIN_ARBI_CONTRACT_ADDRESS, address)
            const isUsdtApprovalNeeded = +usdtAllowance < +buyInWei;
            const isRainApprovalNeeded = +rainAllowance < +buyInWei;

            const callArgs = [];
            if (isUsdtApprovalNeeded) {
                callArgs.push({
                    to: marketFeeToken.address,
                    data: encodeFunctionData({
                        abi: BalanceOfAbi,
                        functionName: "approve",
                        args: [address, bigNumberApproval],
                    }),
                });
            }
            if (isRainApprovalNeeded) {
                callArgs.push({
                    to: RAIN_ARBI_CONTRACT_ADDRESS,
                    data: encodeFunctionData({
                        abi: BalanceOfAbi,
                        functionName: "approve",
                        args: [address, bigNumberApproval],
                    }),
                });
            }
            if (limittab === LIMIT_BUY) {
                const pricePerSharetoEther = convertToWeiEthers(
                    pricePerShare,
                    PRICE_DECIMALS
                );
                callArgs.push({
                    to: address,
                    data: encodeFunctionData({
                        abi: TradePoolAbi,
                        functionName: "placeBuyOrder",
                        args: [selectedoption, pricePerSharetoEther, buyInWei],
                    }),
                });
                callArgs.push(...gasFeeCallArg(gasEstimateInUsdt));
            } else {
                callArgs.push({
                    to: address,
                    data: encodeFunctionData({
                        abi: TradePoolAbi,
                        functionName: "enterOption",
                        args: [selectedoption, buyInWei],
                    }),
                });
                callArgs.push(...gasFeeCallArg(gasEstimateInUsdt));
            }
            const preparedCalls = await smartAccountClient.prepareCalls({
                calls: callArgs,
                from: smartAccount,
                capabilities: { permissions },
            });
            const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
            const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
                ...signedCalls,
                capabilities: { permissions },
            });
            const receipt = await getTxHashAndReceipt({
                preparedCallId: preparedCallIds[0],
                smartAccountClient,
                publicClient,
            });

            if (receipt) {
                setStartProgressBar(false);
                setTimeout(async () => {
                    handleClose7();
                    setMessage(isMobile ? "Trade Placed" : t(TRADE_PLACED_SUCCESS));
                    handleShow10();
                    setBuy("");
                    await getTotalParticipants();
                    await getAllBalances();
                    await getPoolActivity();
                    await getTopHolders();
                    setSelectedOption("");
                    setTotalLimitBuying("");
                    setSharesAmount("");
                    setPricePerShare("");
                    setGasEstimateInUsdt(0);
                    setBuy("");
                }, TIMEOUT);
            }

            return receipt;
        } catch (error) {
            console.error("Buy Error:", error);
            let isSolvency = isSolvencyGateError(error);
            if (!isSolvency && publicClient) {
                try { isSolvency = await checkSolvencyGateViaPreview(publicClient, usdr_token); }
                catch { /* fall through */ }
            }
            if (isSolvency) setShowSolvencyModal(true);
            else notifyError(DEFAULT_ERROR_HEADING, t("Transaction failed or rejected."));
            setStartProgressBar(false);
            handleClose7();
        }
    };

    const getUserLiquidity = async () => {
        try {
            const liquidityRes = await UserLiquidityHook(address);
            const convertfromwei = convertFromWeiEthers(liquidityRes, tokenDecimals);
            setUserLiquidity(convertfromwei);
        } catch (error) {
            console.error("Failed to fetch balance.");
        }
    };

    const getClaimValues = async () => {
        try {
            const claimRewardsValues = await getUserClaimRewards(poolsdetail?.contractAddress, tokenDecimals, poolsdetail?.poolOwnerWalletAddress, poolsdetail?.winnerOption?.choiceIndex);
            setClaimValue(claimRewardsValues?.eligibleRewards);
            setSumOfClaimValue(claimRewardsValues?.totalClaimable);
        } catch (error) {
            console.error("Failed to fetch claim values.");
        }
    };

    useEffect(() => {
        if (poolsdetail && smartAccount && isClaimWindowOpen) {
            getClaimValues();
        }
    }, [smartAccount, poolsdetail, isClaimWindowOpen]);

    useEffect(() => {
        if (poolsdetail && claimvalue && percentageindiv && swapbalance) {
            const winningOption = poolsdetail?.options?.find((option) => {
                let isWinningOption;
                if (Number(poolDisputedWinner)) {
                    isWinningOption = Number(poolDisputedWinner) === option?.choiceIndex;
                } else {
                    isWinningOption = poolsdetail?.winnerOption?.choiceIndex === option?.choiceIndex;
                }
                return isWinningOption;
            });

            if (!winningOption) {
                setTotalPayout(0);
                return;
            }

            const winningIndex = poolsdetail?.options?.findIndex(opt => opt._id === winningOption._id);

            if (winningIndex === -1) {
                setTotalPayout(0);
                return;
            }

            const indivdualpercent = !isNaN(parseFloat(percentageindiv[winningIndex]))
                ? (parseFloat(convertFromWeiEthers((parseFloat(percentageindiv[winningIndex])), tokenDecimals)))
                : 0;
            if (indivdualpercent === 0) {
                setTotalPayout(0);
                return;
            }

            const payout = calculateWinningOptionPayout({
                swapbalance,
                optionId: winningOption._id,
                individualPercent: indivdualpercent,
                claimvalue
            });
            setTotalPayout(payout);
        }
    }, [poolsdetail, poolDisputedWinner, percentageindiv, web3, swapbalance, claimvalue]);

    const handlePageChange = (section, pageNumber) => {
        setCurrentPage((prev) => ({
            ...prev,
            [section]: pageNumber,
        }));
    };

    const ClaimsCheck = async () => {
        try {
            const res = await ClaimCheckHook(address);
            setClaimCheck(res);
            return res;
        } catch (error) {
            console.error("Failed to check claim.");
        }
    };

    const openClaimModal = () => {
        if (openOrders?.length > 0) {
            notifyError(DEFAULT_ERROR_HEADING, t("Please cancel all open orders first."));
            return
        }
        setShowClaimModal(true);
        estimateClaimGas();
    };

    const estimateClaimGas = async () => {
        setGasFeesSpiner(true);
        try {
            const callArgs = [
                {
                    to: poolsdetail?.contractAddress,
                    data: encodeFunctionData({
                        abi: TradePoolAbi,
                        functionName: "claim",
                    }),
                },
                ...gasFeeCallArg(USDT_MOCK_VALUE),
            ];
            await getEstimatedTxGasFee(callArgs, false);
        } catch (err) {
            console.error('Error estimating claim gas:', err);
            setGasFeesSpiner(false);
        }
    };

    const getClaims = async (address) => {
        if (openOrders?.length > 0) {
            notifyError(DEFAULT_ERROR_HEADING, t("Please cancel any open orders before claiming"));
            return;
        }
        if (isUsdrMarket && USDT_MOCK_VALUE > +smartAccountUsdrBalance) {
            notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
            return;
        }
        const investedAmount = `${formatNumbers(+initialposition)} ${tokenToDisplay}`;
        const amountMade = tokenToDisplay === TOKEN_RAIN
            ? `$${formatNumbers(+sumOfClaimvalue * +tokenPriceToUsdt)}`
            : `$${formatNumbers(+sumOfClaimvalue)}`;
        try {
            setStartProgressBar(true);
            if (isMobile) {
                setShowMblProgress(true);
                setMblTitle("Claiming Reward");
                setMblDescription("Please wait while your reward is being claimed.");
            }
            handleShow7();
            setMessage(t(`Estimating ${NETWORK_FEES}`));
            const accessToken = localStorage.getItem("accessToken");
            const tokenCheckRes = await fetch(
                `${api_url}/users/check-token-expiration?token=${accessToken}`,
                {
                    method: "GET",
                }
            );
            const tokenCheckData = await tokenCheckRes.json();
            if (!tokenCheckRes.ok || tokenCheckData.isExpired) {
                setLoader(false);
                setMessage("");
                notifyError(DEFAULT_ERROR_HEADING, t("Access token expired or invalid. Please log in again."));
                handleClose7()
                setStartProgressBar(false);
                await disconnectWallet();
                return;
            }
            const isSessionExists = await handleCheckSession();
            setMessage(
                isSessionExists
                    ? "Confirm the transaction in your wallet"
                    : t("Transferring rewards to your wallet")
            );
            const { userPermissions: permissions, userSessionKey: sessionKey } =
                await grantPermissions();
            setMessage(t("Transferring rewards to your wallet"));
            const callArgs = [
                {
                    to: address,
                    data: encodeFunctionData({
                        abi: TradePoolAbi,
                        functionName: "claim",
                    }),
                },
                ...gasFeeCallArg(USDT_MOCK_VALUE),
            ];
            const gasFee = await handleGasFeeWithBuffer(
                smartAccount,
                callArgs,
                alchemy
            );
            if (isUsdrMarket && +gasFee > +smartAccountUsdrBalance) {
                notifyError(DEFAULT_ERROR_HEADING,
                    t(`Insufficient balance Need $${gasFee?.toFixed(4)} to claim the Rewards`)
                );
                return;
            }
            const callArgsWithGasFees = [
                {
                    to: address,
                    data: encodeFunctionData({
                        abi: TradePoolAbi,
                        functionName: "claim",
                    }),
                },
                ...gasFeeCallArg(gasFee),
            ];
            const preparedCalls = await smartAccountClient.prepareCalls({
                calls: callArgsWithGasFees,
                from: smartAccount,
                capabilities: {
                    permissions,
                },
            });
            const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
            const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
                ...signedCalls,
                capabilities: {
                    permissions,
                },
            });
            const txHash = await getTxHashAndReceipt({
                preparedCallId: preparedCallIds[0],
                smartAccountClient,
                publicClient,
            });
            if (txHash) {
                setStartProgressBar(false);
                setTimeout(async () => {
                    handleClose7();
                    setLoader(false);
                    setGasEstimateInUsdt(0);
                    setMessage("");
                    if (isMobile) {
                        setMblTitle("Congratulations");
                        setMblSuccessInfo({
                            transactionType: TRANSACTION_TYPES.CLAIM,
                            invested: investedAmount,
                            made: amountMade,
                            winnerOption: winnerData?.winnerOption,
                            winnerColor: getBackgroundColor(
                                poolsdetail?.options?.findIndex(opt => opt._id === winnerData?.winnerId),
                                theme,
                                poolsdetail?.options?.length
                            ),
                        });
                        setShowMobileSuccess(true);
                        handleShow10();
                    } else {
                        handleShowClaimedSuccess();
                    }
                    await ClaimsCheck();
                    await getPoolPnl(id);
                    return txHash;
                }, PNL_CALCULATION_TIMEOUT);
            } else {
                setStartProgressBar(false);
                handleClose7();
                setMessage("");
                setLoader(false);
            }
        } catch (error) {
            console.error(
                "Failed to check token expiration or claim rewards:",
                error
            );
            setStartProgressBar(false);
            handleClose7();
            setLoader(false);
            setMessage("");
            setTimeout(async () => {
                try {
                    const claimResult = await ClaimsCheck();
                    if (claimResult) {
                        if (isMobile) {
                            setMblTitle("Congratulations");
                            setMblSuccessInfo({
                                transactionType: TRANSACTION_TYPES.CLAIM,
                                invested: investedAmount,
                                made: amountMade,
                                winnerOption: winnerData?.winnerOption,
                                winnerColor: getBackgroundColor(
                                    poolsdetail?.options?.findIndex(opt => opt._id === winnerData?.winnerId),
                                    theme,
                                    poolsdetail?.options?.length
                                ),
                            });
                            setShowMobileSuccess(true);
                            handleShow10();
                        } else {
                            handleShowClaimedSuccess();
                        }
                        await getPoolPnl(id);
                    } else {
                        notifyError(DEFAULT_ERROR_HEADING, t("Transaction failed or rejected."));
                    }
                } catch (error) {
                    console.error("Error in delayed claim check:", error);
                    notifyError(DEFAULT_ERROR_HEADING, t("Transaction failed or rejected."));
                }
            }, 3000);
        }
    };

    const getPlatformfee = async () => {
        setIsDataLoaded(false);
        try {
            const onlyOracleFeesNeeded = false;
            const platformFees = await PlatformfeeHook(address);
            const userDeductionFees = await PercentReturnCalculation(
                address,
                onlyOracleFeesNeeded
            );
            setPlatformFee(platformFees);
            setOracleFixedFee(userDeductionFees?.oraclefixedfee);
            setCreatorFee(userDeductionFees?.creatorfee);
            setLiquidityFee(userDeductionFees?.liquidityfee);
            setResolvorfee(userDeductionFees?.resolverfee);
            return true;
        } catch (error) {
            console.error("Failed to fetch platform fee.");
            return false;
        }
    };

    const getCalculateFeePreTx = (preTxLiquidity) => {
        const resPreTx = CalculateFeePreTx(
            preTxLiquidity,
            platformfee,
            creatorfee,
            liquidityfee,
            ressolvorfee
        );
        setResultFeePreTx(resPreTx);
        return resPreTx;
    };

    useEffect(() => {
        const preTxLiquidity = totalInvestmentSum + Number(allliquidity);
        if (preTxLiquidity && totalInvestmentSum != 0) {
            getCalculateFeePreTx(preTxLiquidity);
        }
    }, [platformfee, totalInvestmentSum]);

    const CalculateFee = () => {
        const platformFee = parseFloat(((platformfee / 10) * allliquidity) / 100);
        const creatorFee = parseFloat(((creatorfee / 10) * allliquidity) / 100);
        const liquidityFee = parseFloat(((liquidityfee / 10) * allliquidity) / 100);
        const resolverFee = parseFloat(((ressolvorfee / 10) * allliquidity) / 100);
        const result = parseFloat(
            platformFee + creatorFee + liquidityFee + resolverFee
        );
        setResultfee(result);
        return result;
    };

    useEffect(() => {
        CalculateFee();
    }, [
        web3,
        platformfee,
        creatorfee,
        liquidityfee,
        ressolvorfee,
        allliquidity,
        poolsdetail?.isPrivate,
    ]);

    const getPercentagesOption = async () => {
        setIsDataLoaded(false);
        try {
            const address = poolsdetail?.contractAddress;
            const selectedChoiceIndexes = poolsdetail?.options?.map((option) =>
                option.choiceIndex.toString()
            );
            const response = await PercentageOptionsHook(
                address,
                selectedChoiceIndexes
            );
            if (Array.isArray(response) && response.length > 0) {
                const individualTotalSupplyLP = [];
                const totalSupplyLPSum = response.reduce((sum, entry) => {
                    const currentTotalSupplyLP = parseFloat(entry.percentageOption || 0);
                    individualTotalSupplyLP.push(currentTotalSupplyLP);
                    return sum + currentTotalSupplyLP;
                }, 0);
                setPercentageOption(totalSupplyLPSum);
                setPercentageIndivi(individualTotalSupplyLP);
            } else {
                setPercentageOption(0);
                setPercentageIndivi(0);
            }
            return true;
        } catch (error) {
            console.error("Failed to fetch percentages:", error.message || error);
            setPercentageOption(0);
            setPercentageIndivi(0);
            return false;
        }
    };


    const AddLiquidity = async () => {
        if (isButtonDisabled) return;
        if (isSolvencyLimitReached) {
            setShowSolvencyModal(true);
            return;
        }
        setIsButtonDisabled(true);
        setTimeout(() => {
            setIsButtonDisabled(false);
        }, 5000);
        if (!smartAccount) {
            openWalletConnect();
            return;
        }
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) {
            notifyError(DEFAULT_ERROR_HEADING, t("Session expired. Please log in again."));
            await disconnectWallet();
            return;
        }

        try {
            const tokenCheckRes = await fetch(
                `${api_url}/users/check-token-expiration?token=${accessToken}`,
                {
                    method: "GET",
                }
            );
            const tokenCheckData = await tokenCheckRes.json();
            if (tokenCheckData.isExpired) {
                notifyError(DEFAULT_ERROR_HEADING, t("Session expired. Please log in again."));
                await disconnectWallet();
                return;
            }
            const buyInWei = convertToWeiEthers(buyaddliq, tokenDecimals);
            const currentTimestamp = Math.floor(Date.now() / 1000);
            const payload = {
                walletAddress: account,
                totalAmount: buyInWei,
                timestamp: currentTimestamp,
                contractAddress: address,
            };
            if (+gasEstimateInUsdt + +buyaddliq > marketTokenBalance) {
                notifyError(DEFAULT_ERROR_HEADING, t(`Insufficient balance to add the liquidity`));
                return;
            }
            handleClose1();
            await getAddLiquidiyUser(buyInWei);
            setLoader(false);

            return buyInWei;
        } catch (error) {
            setLoader(false);
            console.error("Error adding liquidity:", error);
            let isSolvency = isSolvencyGateError(error);
            if (!isSolvency && publicClient) {
                try { isSolvency = await checkSolvencyGateViaPreview(publicClient, usdr_token); }
                catch { /* fall through */ }
            }
            if (isSolvency) setShowSolvencyModal(true);
            else notifyError(DEFAULT_ERROR_HEADING, "An error occurred. Please try again.");
        }
    };

    const getAddLiquidiyUser = async (buyInWei) => {
        const bigNumberApproval = BIG_NUMBER_APPROVAL;
        try {
            setStartProgressBar(true);
            if (isMobile) {
                setShowMblProgress(true);
                setMblTitle("Adding Liquidity");
                setMblDescription("Please wait...");
            }
            handleShow7();
            const isSessionExists = await handleCheckSession();
            setMessage(
                isSessionExists
                    ? "Confirm the transaction in your wallet"
                    : t("Adding Liquidity Please wait")
            );
            const { userPermissions: permissions, userSessionKey: sessionKey } =
                await grantPermissions();
            setMessage(t("Adding Liquidity Please wait"));
            const usdtAllowance = await getAllowanceByAddress(marketFeeToken.address, address)
            const rainAllowance = await getAllowanceByAddress(RAIN_ARBI_CONTRACT_ADDRESS, address)
            const isUsdtApprovalNeeded = +usdtAllowance < +buyInWei;
            const isRainApprovalNeeded = +rainAllowance < +buyInWei;
            const callArgs = [];
            if (isUsdtApprovalNeeded) {
                callArgs.push({
                    to: marketFeeToken.address,
                    data: encodeFunctionData({
                        abi: BalanceOfAbi,
                        functionName: "approve",
                        args: [address, bigNumberApproval],
                    }),
                });
            }
            if (isRainApprovalNeeded) {
                callArgs.push({
                    to: RAIN_ARBI_CONTRACT_ADDRESS,
                    data: encodeFunctionData({
                        abi: BalanceOfAbi,
                        functionName: "approve",
                        args: [address, bigNumberApproval],
                    }),
                });
            }
            callArgs.push({
                to: address,
                data: encodeFunctionData({
                    abi: TradePoolAbi,
                    functionName: "enterLiquidity",
                    args: [buyInWei],
                }),
            });
            callArgs.push(...gasFeeCallArg(gasEstimateInUsdt));
            const preparedCalls = await smartAccountClient.prepareCalls({
                calls: callArgs,
                from: smartAccount,
                capabilities: { permissions },
            });
            const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
            const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
                ...signedCalls,
                capabilities: { permissions },
            });
            const txHash = await getTxHashAndReceipt({
                preparedCallId: preparedCallIds[0],
                smartAccountClient,
                publicClient,
            });
            if (txHash) {
                setStartProgressBar(false);
                setTimeout(async () => {
                    if (isMobile) {
                        setMblTitle("Liquidity Added");
                        setMblSuccessInfo({
                            transactionType: TRANSACTION_TYPES.ENTER_LIQUIDITY,
                            amount: buyaddliq,
                            tokenDisplay: tokenToDisplay,
                        });
                        setShowMobileSuccess(true);
                        setShowMblProgress(false);
                        handleShow10();
                    } else {
                        handleShow2();
                    }
                    handleClose7();
                    setBuyAddLiq("");
                    setMessage("");
                    setGasEstimateInUsdt(0);
                    await getAllBalances();
                    await getPoolActivity();
                    await getTopHolders();
                    await getTotalParticipants();
                    await getUserLiquidity();
                }, TIMEOUT);
            }
            return txHash;
        } catch (error) {
            console.error("Error in adding liquidity", error);
            let isSolvency = isSolvencyGateError(error);
            if (!isSolvency && publicClient) {
                try { isSolvency = await checkSolvencyGateViaPreview(publicClient, usdr_token); }
                catch { /* fall through */ }
            }
            if (isSolvency) setShowSolvencyModal(true);
            else notifyError(DEFAULT_ERROR_HEADING, t("Transaction failed. Please try again."));
            setStartProgressBar(false);
            setShowMblProgress(false);
            handleClose7();
        }
    };

    const CheckAmount = async () => {
        if (buyaddliq.length === 0 || buyaddliq === "0" || buyaddliq === 0) {
            notifyError(DEFAULT_ERROR_HEADING, t("Liquidity amount is Required!"));
        } else if (+(buyaddliq) > +(marketTokenBalance)) {
            notifyError(DEFAULT_ERROR_HEADING, t("Amount is greater than your balance."));
            return;
        }
        if (isUsdrMarket && USDT_MOCK_VALUE > +smartAccountUsdrBalance) {
            notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
            return;
        } else {
            handleClose();
            handleShow1();
            setGasFeesSpiner(true);
            const bigNumberApproval = BIG_NUMBER_APPROVAL;
            const buyInWei = convertToWeiEthers(buyaddliq, tokenDecimals);
            const usdtAllowance = await getAllowanceByAddress(marketFeeToken.address, address)
            const rainAllowance = await getAllowanceByAddress(RAIN_ARBI_CONTRACT_ADDRESS, address)
            const isUsdtApprovalNeeded = +usdtAllowance < +buyInWei;
            const isRainApprovalNeeded = +rainAllowance < +buyInWei;
            const isAnyApprovalNeeded = isUsdtApprovalNeeded || isRainApprovalNeeded;
            const callArgs = [];
            if (isUsdtApprovalNeeded) {
                callArgs.push({
                    to: marketFeeToken.address,
                    data: encodeFunctionData({
                        abi: BalanceOfAbi,
                        functionName: "approve",
                        args: [address, bigNumberApproval],
                    }),
                });
            }
            if (isRainApprovalNeeded) {
                callArgs.push({
                    to: RAIN_ARBI_CONTRACT_ADDRESS,
                    data: encodeFunctionData({
                        abi: BalanceOfAbi,
                        functionName: "approve",
                        args: [address, bigNumberApproval],
                    }),
                });
            }
            callArgs.push({
                to: address,
                data: encodeFunctionData({
                    abi: TradePoolAbi,
                    functionName: "enterLiquidity",
                    args: [buyInWei],
                }),
            });
            callArgs.push(...gasFeeCallArg(USDT_MOCK_VALUE));
            await getEstimatedTxGasFee(callArgs, isAnyApprovalNeeded);
        }
    };

    const getCurrentPricesOptions = async () => {
        const options = poolsdetail?.options;
        const address = poolsdetail?.contractAddress;
        try {
            const updatedPrice = {};
            for (let i = 0; i < options.length; i++) {
                const choiceIndex = options[i].choiceIndex;
                const price = await CurrentPriceHook(address, choiceIndex);
                const balanceprice = convertFromWeiEthers(price, PRICE_DECIMALS);
                updatedPrice[options[i]._id] = balanceprice;
            }
            setPriceOption(updatedPrice);
        } catch (error) {
            console.error("Failed to fetch price.");
        }
    };

    const getSwapBadges = async () => {
        setIsDataLoaded(false);
        const options = poolsdetail?.options;
        const address = poolsdetail?.contractAddress;
        try {
            const updatedBalances = {};
            let totalBalance = 0;
            for (let i = 0; i < options?.length; i++) {
                const choiceIndex = options[i].choiceIndex;
                const balances = await BalanceOfBatchHook(address, choiceIndex);

                const balance = convertFromWeiEthers(balances, tokenDecimals);
                totalBalance += parseFloat(balance);
                updatedBalances[options[i]._id] = balance;
            }
            setTotalMyPosition(handleToFixedOnDecimals(totalBalance));
            setSwapBalance(updatedBalances);
            return true;
        } catch (error) {
            console.error("Failed to fetch balance:", error);
            return false;
        }
    };

    const SellOrdersByType = async (...types) => {
        if (!poolId) return;
        try {
            for (const type of types) {
                const ordersListingData = await getOrdersListing(
                    poolId,
                    accessToken,
                    type,
                    tokenDecimals
                );
                if (type === "open") {
                    setOpenOrders(ordersListingData);
                } else {
                    setOrdersHistory(ordersListingData);
                }
            }
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    };

    useEffect(() => {
        if ((poolId, accessToken)) {
            SellOrdersByType("open", "orderHistory");
        }
    }, [poolId, accessToken]);

    useEffect(() => {
        const UpdatePrices = async () => {
            if (SocketOrderExist !== "") {
                await getEscrowOrderShares();
                await getCurrentPricesOptions();
            }
        };
        UpdatePrices();
    }, [SocketOrderExist]);

    useEffect(() => {
        const updateDynamicPayout = async () => {
            if (smartAccount) {
                const results = await Promise.all([
                    getSwapBadges(),
                    getPercentagesOption(),
                ]);
                if (results.every((result) => result)) {
                    setIsDataLoaded(true);
                }
            }
        };
        smartAccount && poolsdetail && updateDynamicPayout();
    }, [smartAccount, poolsdetail]);

    useEffect(() => {
        if (smartAccount) {
            getUserLiquidity();
            ClaimsCheck();
        }
        if (poolsdetail) {
            setPoolStart(poolsdetail?.startDate);
            setPoolEnd(poolsdetail?.endDate);
            getPlatformfee();
            getCurrentPricesOptions();
            if (!marketToken.isStable) {
                getTokenToDollarPrice()
            }
        }
    }, [smartAccount, poolsdetail]);

    const handleCommentChange = (e) => {
        const newComment = e.target.value;
        if (newComment.length <= 300) {
            setComment(newComment);
        }
    };

    const handleReplyCommentChange = (e) => {
        const newReply = e.target.value;
        if (newReply.length <= 300) {
            setReplyComment(newReply);
        }
    };

    const handleReplyClick = (parentId) => {
        setShowReplyForm(!showReplyForm);
        setActiveReplyId(parentId);
        setComment("");
    };

    const submitComment = async () => {
        const commentText = activeReplyId ? replyComment : comment;
        if (isSubmittingComment) {
            return;
        }
        if (!smartAccount) {
            notifyError(DEFAULT_ERROR_HEADING, "Connect Your Wallet");
            return;
        } else if (!commentText) {
            notifyError(DEFAULT_ERROR_HEADING, t("Comment cannot be empty"));
            return;
        }
        setIsSubmittingComment(true);
        const payload = {
            comment: commentText,
            poolId: poolsdetail?._id,
        };
        if (activeReplyId) {
            payload.parentCommentId = activeReplyId;
        }

        try {
            const response = await axios.post(
                `${api_url}/comments/create-comment`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            // toast.success('Comment posted successfully!');
            setComment("");
            setReplyComment("");
            setShowReplyForm(false);
            setActiveReplyId(null);
            setParentCommentId(null);
            getComments();
            setIsSubmittingComment(false);
        } catch (err) {
            setIsSubmittingComment(false);
            console.error("Error posting comment:", err);
            notifyError(DEFAULT_ERROR_HEADING, t("Unable to post comment. Please try again."));
        }
    };

    const getTotalParticipants = async () => {
        try {
            const url = `${api_url}/pools/pool-total-participants?poolId=${poolsdetail?._id}`;

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            setTotalParticipants(response?.data?.data?.totalParticipants);
        } catch (error) {
            console.error("Error fetching pools:", error);
        }
    };

    const getComments = async () => {
        try {
            const url = `${api_url}/comments/comments-listing?poolId=${poolsdetail?._id}`;

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            setCommentsList(response?.data?.data?.comments);
        } catch (error) {
            console.error("Error fetching pools:", error);
        }
    };

    useEffect(() => {
        if (poolsdetail?._id) {
            getComments(poolsdetail?._id);
            getTotalParticipants();
        }
    }, [poolsdetail?._id]);

    const formatTimeAgo = (createdAt) => {
        const now = new Date();
        const commentDate = new Date(createdAt); // This is in UTC, but JavaScript will convert it to local time
        const timeDiff = now - commentDate; // Difference in milliseconds
        // Calculate time differences in different units
        const seconds = Math.floor(timeDiff / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const weeks = Math.floor(days / 7);
        const months = Math.floor(days / 30);
        const years = Math.floor(days / 365);
        if (years > 0) {
            return `${years} year${years > 1 ? "s" : ""} ago`;
        } else if (months > 0) {
            return `${months} month${months > 1 ? "s" : ""} ago`;
        } else if (weeks > 0) {
            return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
        } else if (days > 0) {
            return `${days} day${days > 1 ? "s" : ""} ago`;
        } else if (hours > 0) {
            return `${hours} hour${hours > 1 ? "s" : ""} ago`;
        } else if (minutes > 0) {
            return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
        } else {
            return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
        }
    };

    const handleLikeUnlike = async (commentId, isLiked) => {
        const url = isLiked
            ? `${api_url}/comments/unlike/${commentId}`
            : `${api_url}/comments/like/${commentId}`;

        try {
            const response = await axios.post(
                url,
                { commentid: commentId },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            getComments();
        } catch (error) {
            console.error(
                isLiked ? "Failed to remove like" : "Failed to add like",
                error
            );
        }
    };

    const CheckPoolTime = useCallback(() => {
        try {
            if (!smartAccount) {
                openWalletConnect();
                return;
            }
            const currentTimeUTC = new Date();
            const poolStartDate = new Date(poolstart);
            const poolEndDate = new Date(poolend);
            if (poolStartDate > currentTimeUTC) {
                notifyError(DEFAULT_ERROR_HEADING, t(t("Market has not started yet.")));
                return;
            } else if (poolEndDate < currentTimeUTC) {
                notifyError(DEFAULT_ERROR_HEADING, t("Market has ended."));
                return;
            } else {
                handleShow();
            }
        } catch (error) {
            console.error("Error comparing start time:", error.message || error);
            notifyError(DEFAULT_ERROR_HEADING, t("Error checking Market start time."));
        }
    }, [poolstart, poolend, smartAccount]);

    useEffect(() => {
        const fetchGasPrice = async () => {
            try {
                let gasPriceInWei = await web3.eth.getGasPrice();
                let gasPriceInGwei = convertFromWei(gasPriceInWei, "gwei");
                gasPriceInGwei = handleToFixedOnDecimals(gasPriceInGwei);

                setGasPrice(gasPriceInGwei);
            } catch (error) {
                console.error("Error fetching gas price: ", error);
            }
        };

        fetchGasPrice();
    }, []);

    const getGraphData = async (contractaddress, filter = null) => {
        try {
            const dataByPair = await getPriceData(contractaddress, filter);
            setGraph(dataByPair);
        } catch (error) {
            console.error("Error fetching Markets:", error);
        }
    };

    useEffect(() => {
        if (poolsdetail?.contractAddress) {
            getGraphData(poolsdetail?.contractAddress);
        }
    }, [poolsdetail?.contractAddress]);

    const getInvestmentData = async (id) => {
        try {
            const url = `${api_url}/investments/user-total-investment?poolId=${id}`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            const res = response?.data?.details?.totalInvestment;
            const totalinvestments = convertFromWeiEthers(res, tokenDecimals);
            setInitialPosition(totalinvestments);
        } catch (error) {
            console.error("Error fetching Markets:", error);
            setInitialPosition("0");
        }
    };

    useEffect(() => {
        const getMyInvestment = async () => {
            const token = localStorage.getItem("accessToken");
            if (id && smartAccount && token && tokenDecimals) {
                await getInvestmentData(id);
            }
        };
        getMyInvestment();
    }, [id, smartAccount, tokenDecimals]);

    const lastApiEntry = graph?.[graph.length - 1];
    const pair = parseInt(lastApiEntry?.pair, 10);
    const price = parseFloat(lastApiEntry?.price);
    const swapBalanceValues = Object.values(swapbalance).map((value) =>
        parseFloat(value)
    );

    let swapBalance = 0;
    if (pair >= 1 && pair <= swapBalanceValues.length) {
        swapBalance = swapBalanceValues[pair - 1];
    }

    const totalVolumereduce = volumn.reduce(
        (sum, entry) => sum + entry.totalVolume,
        0
    );
    const totalVolume = convertFromWeiEthers(totalVolumereduce, tokenDecimals);

    useEffect(() => {
        let interval;
        const timer = setTimeout(() => {
            if (totalVolumereduce === 0 && Number(allliquidity) === 0) {
                getPoolsByIdOnlyliquidity(id);
                getTotalVolumn(id);
            }
        }, 10000);
        return () => {
            clearTimeout(timer);
            clearInterval(interval);
        };
    }, [id]);

    const getOptionsDynamicPayout = async () => {
        try {
            const dynamicPayout = await DynamicPayoutHook(address);
            const converted = dynamicPayout
                .slice(1)
                .map(value => Number(convertFromWeiEthers(value, tokenDecimals)));
            setDynamicPayout(converted);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const fetchNewPayout = async () => {
            setTimeout(async () => {
                await getOptionsDynamicPayout();
            }, 3000);
        };
        smartAccount && poolsdetail && fetchNewPayout();
    }, [totalInvestmentSum, poolsdetail, smartAccount]);

    const getCalculateResult = async () => {
        try {
            const amountinWei = convertToWeiEthers(buy, tokenDecimals);
            const selectionOptionIndex = selectedIndex + 1;
            const calculateFeeDynamic = await entrySharesHook(
                address,
                selectionOptionIndex,
                amountinWei
            )
            if (debounce && calculateFeeDynamic) {
                const returnedSharesInMwei = convertFromWeiEthers(
                    String(calculateFeeDynamic.returnedShares || "0"),
                    tokenDecimals
                );
                const expectedRewardInMwei = convertFromWeiEthers(
                    String(calculateFeeDynamic.expectedReward || "0"),
                    tokenDecimals
                );
                setFinalDynamicPay(expectedRewardInMwei);
                setSharesWeReceive(returnedSharesInMwei);

            } else {
                setFinalDynamicPay("0");
                setSharesWeReceive("0");
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (limittab === LIMIT_BUY) {
            setBuy("");
        } else if (limittab === MARKET_BUY && buyOrSellTabActive === BUY) {
            setSharesAmount("");
            setPricePerShare("");
        }
        const eventHandler = setTimeout(() => {
            if (limittab === LIMIT_BUY) {
                setDebounce(`${sharesAmount}${pricePerShare}`);
            } else {
                setDebounce(buy);
            }
        }, 1000);
        return () => clearTimeout(eventHandler);
    }, [buy, sharesAmount, pricePerShare, limittab, selectedOptionBalancebuy]);

    useEffect(() => {
        const calculateShareValue = async () => {
            if (+marketTokenBalance < +buy) {
                notifyError(DEFAULT_ERROR_HEADING, t(`Insufficient ${TitleCaseConversion(tokenToDisplay)} balance to complete this transaction.`));
                return;
            }
            else if (debounce > 0 && selectedOption && limittab !== LIMIT_BUY) {
                await getCalculateResult();
                if (smartAccount) {
                    setGasFeesSpiner(true);
                    const callArgs = [];
                    const selectedoption = selectedOption?.choiceIndex;
                    const buyInWei = convertToWeiEthers(buy, tokenDecimals);
                    const bigNumberApproval = BIG_NUMBER_APPROVAL;
                    const usdtAllowance = await getAllowanceByAddress(marketFeeToken.address, address)
                    const rainAllowance = await getAllowanceByAddress(RAIN_ARBI_CONTRACT_ADDRESS, address)
                    const isUsdtApprovalNeeded = +usdtAllowance < +buyInWei;
                    const isRainApprovalNeeded = +rainAllowance < +buyInWei;
                    const isAnyApprovalNeeded = isUsdtApprovalNeeded || isRainApprovalNeeded;

                    if (isUsdtApprovalNeeded) {
                        callArgs.push({
                            to: marketFeeToken.address,
                            data: encodeFunctionData({
                                abi: BalanceOfAbi,
                                functionName: "approve",
                                args: [address, bigNumberApproval],
                            }),
                        });
                    }
                    if (isRainApprovalNeeded) {
                        callArgs.push({
                            to: RAIN_ARBI_CONTRACT_ADDRESS,
                            data: encodeFunctionData({
                                abi: BalanceOfAbi,
                                functionName: "approve",
                                args: [address, bigNumberApproval],
                            }),
                        });
                    }
                    callArgs.push({
                        to: address,
                        data: encodeFunctionData({
                            abi: TradePoolAbi,
                            functionName: "enterOption",
                            args: [selectedoption, buyInWei],
                        }),
                    });
                    callArgs.push(...gasFeeCallArg(USDT_MOCK_VALUE));
                    await getEstimatedTxGasFee(callArgs, isAnyApprovalNeeded);
                } else {
                    setGasEstimateInUsdt(0);
                }
            } else {
                setGasEstimateInUsdt(0);
                setFinalDynamicPay("0");
                setSharesWeReceive("0");
            }
        };
        calculateShareValue();
    }, [debounce, selectedOptionBalancebuy, selectedOption, smartAccount]);

    const handleCopyClickId = () => {
        const textToCopy = poolsdetail?._id || "";
        copyToClipboard(textToCopy);
        setIsCopiedId(true);
        setTimeout(() => setIsCopiedId(false), 1000);
    };

    const handleCopyClickLink = async () => {
        const textToCopy = `${SHARE_MARKET}/?id=${poolsdetail?._id}&theme=${theme}`;
        copyToClipboard(textToCopy);
        setIsCopiedLink(true);
        await getGeneratedPreviewData();
        setTimeout(() => setIsCopiedLink(false), 1000);
    };

    const handleCopyClickCode = () => {
        const textToCopy = poolsdetail?.accessCode || "";
        copyToClipboard(textToCopy);
        setIsCopiedCode(true);
        setTimeout(() => setIsCopiedCode(false), 1000);
    };

    const copyToClipboard = (text) => {
        const tempTextArea = document.createElement("textarea");
        tempTextArea.value = text;
        document.body.appendChild(tempTextArea);
        tempTextArea.select();
        document.execCommand("copy");
        document.body.removeChild(tempTextArea);
    };


    const copyPoolLinks = async () => {
        await getGeneratedPreviewData();
        const message = generatePoolShareMessage(
            poolQuestion,
            poolId,
            poolAccessCode,
            isPoolPrivate,
            theme,
            totalVolume,
            tokenLogo
        );
        navigator.clipboard
            .writeText(message)
            .then(() => {
                setIsCopied(true);
                setTimeout(() => setIsCopied(false), 1000);
            })
            .catch((err) => {
                notifyError(DEFAULT_ERROR_HEADING, t("Unable to copy to clipboard."));
                console.error("Copy error:", err);
            });
    };

    const userId = localStorage.getItem("userId");
    const totalSumLiquidityCal = Number(totalInvestmentSum || 0);
    const exitLiquidity = Number(exitLiquidityInvestment || 0);
    const totalSumLiquidity = totalSumLiquidityCal - exitLiquidity;
    const totalSumVolumnCal = (
        +(totalVolume || 0) + +(totalInvestmentSum || 0)
    )?.toFixed(3);
    const parsedPoolVolumn = Number(totalSumVolumnCal) + exitLiquidity;
    const totalSumVolumn = isNaN(parsedPoolVolumn)
        ? "0.00"
        : formatNumberWithCommas(parsedPoolVolumn);

    const handleOptionClick = async (optionindex, name) => {
        setGasFeesSpiner(true);
        setSelectedOption(optionindex);
        setSelectedName(name);
        const callArgs = [
            {
                to: address,
                data: encodeFunctionData({
                    abi: TradePoolAbi,
                    functionName: "chooseWinner",
                    args: [optionindex],
                }),
            },
            ...gasFeeCallArg(USDT_MOCK_VALUE),
        ];
        await getEstimatedTxGasFee(callArgs, false);
    };

    const getUsersProfile = async () => {
        try {
            const response = await axios.get(`${api_url}/users/user-profile`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setUserProfile(response?.data?.data);
        } catch (error) {
            console.log("error in getting user profile", error)
        }
    };

    useEffect(() => {
        if (accessToken) {
            getUsersProfile();
        }
    }, [accessToken]);

    useEffect(() => {
        const socketRes = async () => {
            if (totalInvestmentSum != 0) {
                await getPoolsById();
                await getCurrentPricesOptions();
                await getSwapBadges();
                await getPercentagesOption();
                setTimeout(async () => {
                    await getInvestmentData(id);
                }, 3000);
                await getTotalParticipants();
                await getAllBalances();
            }
        };
        socketRes();
    }, [totalInvestmentSum, id]);

    useEffect(() => {
        if (closepool || winnerdecide != []) {
            getPoolsById();
        }
    }, [closepool, winnerdecide]);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);
        return () => window.removeEventListener("resize", checkScreenSize);
    }, []);

    const handleSelectOptionSelling = (
        option,
        index,
        background,
        totalSupplyLP,
        PriceConversion,
        updatedShares
    ) => {
        setSelectedDollarConversionSell(PriceConversion);
        setSelectedOptionSelling(option);
        setSelectedOptionBalanceSell(updatedShares);
        setSelectedIndex(index);
        setSelectedColor(background);
        setIndividualShares(totalSupplyLP);
        handleClose33();
    };

    const scrollToSellOrders = () => {
        handleClose10();
        const mainTabsContainer = document.querySelector(".bottom-tabs");
        if (mainTabsContainer) {
            mainTabsContainer.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        setKey("sellorders");
    };

    const handleOrderFilled = (newOrder) => {
        setOrderFilled((prevOrders) => [...prevOrders, newOrder]);
    };

    useEffect(() => {
        if (orderFilled.length === 0) return;
        setOpenOrders((prevOpenOrders) => {
            const updatedOrders = prevOpenOrders.filter(
                (order) => !orderFilled?.some((filled) => filled._id === order._id)
            );
            const filledOrders = orderFilled
                .filter((filledOrder) =>
                    prevOpenOrders?.some((order) => order._id === filledOrder._id)
                )
                .map((filled) => {
                    const updated = getSocketOrderWithOptionName(filled, {
                        options: poolsdetail.options,
                    });
                    updated.quantity = convertFromWeiEthers(
                        updated.quantity.toString(),
                        tokenDecimals
                    );
                    return updated;
                });
            setOrdersHistory((prevHistory) => [...filledOrders, ...prevHistory]);
            return updatedOrders;
        });
    }, [orderFilled]);

    useEffect(() => {
        if (!partiallyFilledOrder?.pendingOrder) return;
        if (
            !partiallyFilledOrder?.filledOrder ||
            partiallyFilledOrder.filledOrder.user !== userId
        )
            return;
        const partiallyFilledOrderFilled = partiallyFilledOrder.filledOrder;
        const filledQuantityFromWei = convertFromWeiEthers(
            String(partiallyFilledOrderFilled.quantity || "0"),
            tokenDecimals
        );
        const matchedOrderNameId = getSocketOrderWithOptionName(
            partiallyFilledOrderFilled,
            { options: poolsdetail?.options }
        );
        if (!matchedOrderNameId) return;
        matchedOrderNameId.quantity = filledQuantityFromWei;
        setOpenOrders((prevOpenOrders) => {
            const updatedOrders = [...prevOpenOrders];
            const index = updatedOrders.findIndex((order) => order.user === userId);
            if (index !== -1) {
                const currentQuantity = Number(updatedOrders[index].quantity || 0);
                const newQuantity = (
                    currentQuantity - Number(filledQuantityFromWei)
                ).toString();
                updatedOrders[index] = {
                    ...updatedOrders[index],
                    quantity: newQuantity,
                };
            }
            return updatedOrders;
        });
        setOrdersHistory((prevHistory) => [matchedOrderNameId, ...prevHistory]);
    }, [partiallyFilledOrder]);

    const handleLiveStream = async (action) => {
        let payload;

        if (action === "start") {
            const youTubeStreamId = extractStreamingId(getLiveId);
            if (!youTubeStreamId) {
                console.error("Could not extract YouTube ID");
                return;
            }
            payload = {
                poolId: id,
                action: action,
                videoStreamingID: youTubeStreamId,
            };
        } else {
            payload = {
                poolId: id,
                action: action,
                videoStreamingID: youTubeId,
            };
        }

        try {
            await postLiveStreaming(payload);
            window?.scroll(0, 0);
            setGetLiveId("");
        } catch (error) {
            console.error("Error posting live stream:", error);
        }
    };

    useEffect(() => {
        setGasEstimateInUsdt("");
        setPricePerShare("");
        setSharesAmount("");
        setOrderValueError(null)
    }, [buyOrSellTabActive, limittab]);

    useEffect(() => {
        const calculateShareValue = async () => {
            if (buyOrSellTabActive !== BUY) return;
            const selectedoption = selectedOption?.choiceIndex;
            if (
                debounce != "" &&
                sharesAmount != "" &&
                pricePerShare != "" &&
                +pricePerShare > 0 &&
                +sharesAmount > 0 &&
                limittab === LIMIT_BUY &&
                selectedoption
            ) {
                const error = validateOrderValue(sharesAmount, tokenPriceToUsdt, tokenSymbol, BUY);
                setOrderValueError(error);

                if (error) {
                    setTotalLimitBuying("");
                    setGasEstimateInUsdt(0);
                    return;
                }

                setGasFeesSpiner(true);
                const callArgs = [];
                const buyInWei = convertToWeiEthers(sharesAmount, tokenDecimals);
                const bigNumberApproval = BIG_NUMBER_APPROVAL;
                const usdtAllowance = await getAllowanceByAddress(marketFeeToken.address, address)
                const rainAllowance = await getAllowanceByAddress(RAIN_ARBI_CONTRACT_ADDRESS, address)
                const isUsdtApprovalNeeded = +usdtAllowance < +buyInWei;
                const isRainApprovalNeeded = +rainAllowance < +buyInWei;
                const isAnyApprovalNeeded = isUsdtApprovalNeeded || isRainApprovalNeeded;

                if (isUsdtApprovalNeeded) {
                    callArgs.push({
                        to: marketFeeToken.address,
                        data: encodeFunctionData({
                            abi: BalanceOfAbi,
                            functionName: "approve",
                            args: [address, bigNumberApproval],
                        }),
                    });
                }
                if (isRainApprovalNeeded) {
                    callArgs.push({
                        to: RAIN_ARBI_CONTRACT_ADDRESS,
                        data: encodeFunctionData({
                            abi: BalanceOfAbi,
                            functionName: "approve",
                            args: [address, bigNumberApproval],
                        }),
                    });
                }
                const pricePerSharetoEther = convertToWeiEthers(
                    pricePerShare,
                    PRICE_DECIMALS
                );
                callArgs.push({
                    to: address,
                    data: encodeFunctionData({
                        abi: TradePoolAbi,
                        functionName: "placeBuyOrder",
                        args: [selectedoption, pricePerSharetoEther, buyInWei],
                    }),
                });
                callArgs.push(...gasFeeCallArg(USDT_MOCK_VALUE));
                await getEstimatedTxGasFee(callArgs, isAnyApprovalNeeded);
                const totalofPriceandShare = CalculateTotalSharesandPrice(
                    sharesAmount,
                    pricePerShare
                );
                setTotalLimitBuying(totalofPriceandShare);
            } else {
                setTotalLimitBuying("");
                setGasEstimateInUsdt(0);
            }
        };
        calculateShareValue();
    }, [debounce, selectedOption, limittab]);

    useEffect(() => {
        if (poolsdetail?.options?.length) {
            const result = poolsdetail.options.every((option, index) => {
                const sharesBuying = swapbalance[option._id];
                const updatedShares = getSellingShares(
                    sharesBuying,
                    userPostSellOrderShares,
                    index
                );
                return handleToFixedOnDecimals(updatedShares) === 0;
            });
            const sellShares = poolsdetail.options.map((option, index) => {
                const sharesBuying = swapbalance[option._id];
                const updatedShares = getSellingShares(
                    sharesBuying,
                    userPostSellOrderShares,
                    index
                );
                return Number(updatedShares);
            });
            setUpdatedShares(sellShares);
            setAllSharesZero(result);
        }
    }, [poolsdetail, swapbalance, userPostSellOrderShares]);

    const createPublicPoolDispute = async () => {
        let disputeResponse;
        try {
            handleCloseCreateDispute();
            setStartProgressBar(true);
            if (isMobile) {
                setShowMblProgress(true);
                if (disputeOrAppealText === APPEAL) {
                    setMblTitle("Submitting Appeal");
                    setMblDescription("Please wait while your appeal is being processed.");
                } else {
                    setMblTitle("Submitting Dispute");
                    setMblDescription("Please wait while your dispute is being processed.");
                }
            }
            handleShow7();
            setMessage(t(`Creating ${disputeOrAppealText}`))
            if (disputeOrAppealText === DISPUTE) {
                const data = new FormData();
                data.append("pool", poolsdetail?._id);
                data.append("role", "disputer");
                data.append("messageType", "mixed");
                const evidenceObj = {
                    question: title,
                    options: poolsdetail?.options?.map(opt => opt.optionName),
                    evidenceType: "mixed",
                    description: description,
                    source: "Buyer",
                };
                data.append("evidence", JSON.stringify(evidenceObj));
                files.forEach(file => data.append("files", file));
                disputeResponse = await postDisputeMessage(data)
            }
            if (disputeResponse || disputeOrAppealText !== DISPUTE) {
                const isSessionExists = await handleCheckSession();
                setMessage(isSessionExists ? 'Confirm the transaction in your wallet' : t(`Creating ${disputeOrAppealText}`))
                const { userPermissions: permissions, userSessionKey: sessionKey } =
                    await grantPermissions();
                const bigNumberApproval = BIG_NUMBER_APPROVAL;
                const usdtAllowance = await getAllowanceByAddress(marketFeeToken.address, address)
                const rainAllowance = await getAllowanceByAddress(RAIN_ARBI_CONTRACT_ADDRESS, address)
                const isUsdtApprovalNeeded = +usdtAllowance < +requiredDisputeAmount;
                const isRainApprovalNeeded = +rainAllowance < +requiredDisputeAmount;

                const callArgs = [];
                if (isUsdtApprovalNeeded) {
                    callArgs.push({
                        to: marketFeeToken.address,
                        data: encodeFunctionData({
                            abi: BalanceOfAbi,
                            functionName: "approve",
                            args: [address, bigNumberApproval],
                        }),
                    });
                }
                if (isRainApprovalNeeded) {
                    callArgs.push({
                        to: RAIN_ARBI_CONTRACT_ADDRESS,
                        data: encodeFunctionData({
                            abi: BalanceOfAbi,
                            functionName: "approve",
                            args: [address, bigNumberApproval],
                        }),
                    });
                }
                callArgs.push({
                    to: address,
                    data: encodeFunctionData({
                        abi: TradePoolAbi,
                        functionName: "openDispute",
                    }),
                });
                callArgs.push(...gasFeeCallArg(gasEstimateInUsdt));
                const preparedCalls = await smartAccountClient.prepareCalls({
                    calls: callArgs,
                    from: smartAccount,
                    capabilities: { permissions },
                });
                const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
                const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
                    ...signedCalls,
                    capabilities: { permissions },
                });
                const txHash = await getTxHashAndReceipt({
                    preparedCallId: preparedCallIds[0],
                    smartAccountClient,
                    publicClient,
                });
                if (txHash) {
                    setStartProgressBar(false);
                    setTimeout(() => {
                        setTitle("");
                        setDescription("");
                        setFiles([]);
                        handleClose7();
                        if (isMobile) {
                            if (disputeOrAppealText === APPEAL) {
                                setMblTitle("Appeal Submitted");
                                setMblDescription("The market will be temporarily locked while the appeal is being reviewed by the human oracles.");
                            } else {
                                setMblTitle("Dispute Submitted!");
                                setMblDescription(
                                    <>
                                        Your dispute against{" "}
                                        <span className="bold-text">{winnerData?.winnerOption}</span>{" "}
                                        has been submitted. <br /> The bond has been locked.
                                    </>
                                );
                            }
                            setShowMobileSuccess(true);
                            handleShow10();
                        } else {
                            setMessage(t(`${disputeOrAppealText} ${disputeOrAppealText === APPEAL ? "Submitted" : "created"}`));
                            setSuccessDescription(disputeOrAppealText === APPEAL ? t("The market will be temporarily locked while the appeal is being reviewed by the human oracles. ") : <>
                                Your dispute against{" "}
                                <span className="bold-text">{winnerData?.winnerOption}</span>{" "}
                                has been submitted. <br /> The bond has been locked.
                            </>);
                            handleShow10();
                        }
                    }, TIMEOUT);
                }
            } else {
                setStartProgressBar(false);
                let isSolvency = isSolvencyGateError(error);
                if (!isSolvency && publicClient) {
                    try { isSolvency = await checkSolvencyGateViaPreview(publicClient, usdr_token); }
                    catch { /* fall through */ }
                }
                if (isSolvency) setShowSolvencyModal(true);
                else notifyError(DEFAULT_ERROR_HEADING, t(`Unable to create${disputeOrAppealText.toLowerCase()}.Please try again.`));
                handleClose7();
                setMessage("");
            }
        } catch (error) {
            console.log("error: ", error);
            setStartProgressBar(false);
            let isSolvency = isSolvencyGateError(error);
            if (!isSolvency && publicClient) {
                try { isSolvency = await checkSolvencyGateViaPreview(publicClient, usdr_token); }
                catch { /* fall through */ }
            }
            if (isSolvency) setShowSolvencyModal(true);
            else notifyError(DEFAULT_ERROR_HEADING, t(`Unable to create${disputeOrAppealText.toLowerCase()}.Please try again.`));
            handleClose7();
            setMessage("");
        }
    };

    const extendDisputeTimer = async () => {
        if (!smartAccount) {
            openWalletConnect();
            return;
        } else if (isUsdrMarket && USDT_MOCK_VALUE > +smartAccountUsdrBalance) {
            notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
            return;
        }
        try {
            setStartProgressBar(true);
            setMessage(t(`Estimating ${NETWORK_FEES}`));
            setResubmitOrFinalizeSpinner(true)
            if (isMobile) {
                setShowResubmit(false);
                setShowMblProgress(true);
                setMblTitle("Resubmitting Appeal");
                setMblDescription("Please wait while your appeal is being processed.");
                handleShow7();
            }
            let gasFees;
            const timeSignature = await getExtendTimeAndSignature(
                publicPoolResolverAddress,
                smartAccount
            );
            const epochExtendTime = timeSignature?.epoch;
            const extendSignature = timeSignature?.signature;
            if (timeSignature) {
                const callArgs = [];
                callArgs.push({
                    to: publicPoolResolverAddress,
                    data: encodeFunctionData({
                        abi: OracleAbi,
                        functionName: "extendTime",
                        args: [epochExtendTime, extendSignature],
                    }),
                });
                callArgs.push(...gasFeeCallArg(USDT_MOCK_VALUE));
                gasFees = await getEstimatedTxGasFee(callArgs, false);
            }
            if (timeSignature) {
                const isSessionExists = await handleCheckSession();
                setMessage(
                    isSessionExists
                        ? "Confirm the transaction in your wallet"
                        : t("Resubmitting Appeal Timer")
                );
                const { userPermissions: permissions, userSessionKey: sessionKey } =
                    await grantPermissions();
                setMessage(t("Resubmitting Appeal Timer"));
                const callArgs = [];
                callArgs.push({
                    to: publicPoolResolverAddress,
                    data: encodeFunctionData({
                        abi: OracleAbi,
                        functionName: "extendTime",
                        args: [epochExtendTime, extendSignature],
                    }),
                });
                callArgs.push(...gasFeeCallArg(gasFees));
                const preparedCalls = await smartAccountClient.prepareCalls({
                    calls: callArgs,
                    from: smartAccount,
                    capabilities: { permissions },
                });
                const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
                const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
                    ...signedCalls,
                    capabilities: { permissions },
                });
                const txHash = await getTxHashAndReceipt({
                    preparedCallId: preparedCallIds[0],
                    smartAccountClient,
                    publicClient,
                });
                if (txHash) {
                    setStartProgressBar(false);
                    setResubmitOrFinalizeSpinner(false)
                    if (isMobile) {
                        handleClose7();
                        setMblTitle("Appeal Resubmitted");
                        setMblDescription("The market will be temporarily locked while the appeal is being reviewed by the human oracles.");
                        setShowMobileSuccess(true);
                        handleShow10();
                    } else {
                        setMessage(t("Appeal Resubmitted"));
                        setSuccessDescription(t("The market will be temporarily locked while the appeal is being reviewed by the human oracles."));
                        handleShow10();
                    }
                    setShowResubmit(false)
                }
            }
        } catch (error) {
            console.log("error: ", error);
            notifyError(DEFAULT_ERROR_HEADING, t("Time extension failed. Please try again."));
            setShowResubmit(false)
            setResubmitOrFinalizeSpinner(false)
            handleClose7();
            setMessage("");
        }
    };

    const revealWinner = async () => {
        if (!smartAccount) {
            openWalletConnect();
            return;
        } else if (isUsdrMarket && USDT_MOCK_VALUE > +smartAccountUsdrBalance) {
            notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
            return;
        }
        try {
            setResubmitOrFinalizeSpinner(true)
            if (isMobile) {
                setShowResubmit(false);
                setStartProgressBar(true);
                setShowMblProgress(true);
                setMblTitle("Finalizing Market Resolution");
                setMblDescription("Please confirm the final outcome. This action cannot be undone.");
                handleShow7();
            }
            const callArgsForFees = [
                {
                    to: publicPoolResolverAddress,
                    data: encodeFunctionData({ abi: OracleAbi, functionName: "calculateWinner" }),
                },
                ...gasFeeCallArg(USDT_MOCK_VALUE),
            ];
            const gasfees = await getEstimatedTxGasFee(callArgsForFees, false);
            const isSessionExists = await handleCheckSession();
            setMessage(
                isSessionExists
                    ? "Confirm the transaction in your wallet"
                    : t("Finalize answer")
            );
            const { userPermissions: permissions, userSessionKey: sessionKey } = await grantPermissions();
            const callArgs = [
                {
                    to: publicPoolResolverAddress,
                    data: encodeFunctionData({ abi: OracleAbi, functionName: "calculateWinner" }),
                },
                ...gasFeeCallArg(gasfees),
            ];
            const preparedCalls = await smartAccountClient.prepareCalls({
                calls: callArgs,
                from: smartAccount,
                capabilities: { permissions },
            });
            const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
            const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
                ...signedCalls,
                capabilities: { permissions },
            });
            const txHash = await getTxHashAndReceipt({
                preparedCallId: preparedCallIds[0],
                smartAccountClient,
                publicClient,
            });
            if (txHash) {
                setResubmitOrFinalizeSpinner(false)
                setStartProgressBar(false);
                setWinnerFinalizedBool(true);
                await getWinnerFinalizedBool();
                if (isMobile) {
                    handleClose7();
                    setMblTitle("Market Resolution Finalized.");
                    setMblDescription("This market has been resolution");
                    setShowMobileSuccess(true);
                    handleShow10();
                } else {
                    setMessage(t("Market Resolution Finalized."));
                    setSuccessDescription(t("Market Resolution has been successfully finalized."));
                    handleShow10();
                }
                setShowResubmit(false);
            }
        } catch (error) {
            setResubmitOrFinalizeSpinner(false)
            setStartProgressBar(false);
            handleClose7();
            console.log("error: ", error);
            notifyError(DEFAULT_ERROR_HEADING, t("Failed to reveal winner."));
        }
    };

    const calculateBuyingOptionValues = () => {
        if (!poolsdetail?.options || !swapbalance || !priceoption) return [];
        return poolsdetail.options.map((opt) => {
            const availableBuyingShares = swapbalance[opt._id]
                ? handleToFixedOnDecimals(swapbalance[opt._id])
                : "0";
            const PriceConversion =
                swapbalance[opt._id] && priceoption[opt._id]
                    ? swapbalance[opt._id] * priceoption[opt._id]
                    : 0;
            const optionName = opt?.optionName;
            return {
                availableBuyingShares,
                PriceConversion,
                optionName,
                optionId: opt?._id,
            };
        });
    };
    const buyingOptionValues = calculateBuyingOptionValues();

    const [mobiletabs, setMobileTabs] = useState(0);


    const getGeneratedPreviewData = async () => {
        const rawPayload = {
            poolId: poolId,
            title: poolsdetail?.question,
            accessCode: isPoolPrivate ? poolAccessCode : "",
            isPrivate: isPoolPrivate ? true : false,
            tokenSymbol: tokenLogo,
            tokenAddress: tokenAddress,
            tokenName: tokenName,
            volume: String(formatNumbers(+totalVolume || 0)),
            options:
                poolsdetail?.options?.map((option, index) => {
                    const latestPercentage = graph?.[index]?.percentages?.slice(-1)[0];
                    return {
                        optionName: option.optionName,
                        totalVolume: `${formatNumbers(+latestPercentage)}%`,
                    };
                }) || [],
        };
        const formattedPayload = preparePreviewPayload(rawPayload);
        const response = await getGeneratedPreview(formattedPayload);
        return response;
    };

    const getTokenToDollarPrice = async () => {
        try {
            const tokenPriceRes = await tokenToDollarConvertion(TOKEN_RAIN)
            setTokenPriceToUsd(tokenPriceRes)
        } catch (error) {
            console.log('error: ', error);

        }
    }

    useEffect(() => {
        if (hasAccess) return;
        if (isPoolPrivate && smartAccount?.toLowerCase() === poolsdetail?.poolOwnerWalletAddress?.toLowerCase()) {
            setHasAccess(true);
            setShowPrivatePollModal(false);
        }
        else if (isPoolPrivate) {
            setShowPrivatePollModal(true)
            setHasAccess(false);
        }
    }, [poolsdetail, smartAccount]);

    const gasEstimationCloseMarket = async () => {
        if (poolsdetail?.version > 2 && !ownermatch && +marketTokenBalance < +resolutionBondAmount) {
            notifyError(DEFAULT_ERROR_HEADING, `Insufficient balance. You need at least ${resolutionBondAmount?.toFixed(4)} ${TitleCaseConversion(tokenToDisplay)} to propose a resolution.`);
            return;
        }
        setGasFeesSpiner(true);
        const callArgs = [];
        let isAnyApprovalNeeded = false;
        if (poolsdetail?.version <= 2) {
            const closePoolData = encodeFunctionData({ abi: TradePoolAbi, functionName: "closePool" })
            callArgs.push({ to: address, data: closePoolData });
            callArgs.push(...gasFeeCallArg(USDT_MOCK_VALUE));
        }
        else {
            const bigNumberApproval = BIG_NUMBER_APPROVAL;
            const bondAmount = await resolverBond(poolsdetail?.contractAddress);
            const bondAmountInWei = convertToWeiEthers(bondAmount, tokenDecimals);
            const usdtAllowance = await getAllowanceByAddress(marketFeeToken.address, address);
            const rainAllowance = await getAllowanceByAddress(RAIN_ARBI_CONTRACT_ADDRESS, address);
            const isUsdtApprovalNeeded = +usdtAllowance < +bondAmountInWei;
            const isRainApprovalNeeded = +rainAllowance < +bondAmountInWei;
            isAnyApprovalNeeded = isUsdtApprovalNeeded || isRainApprovalNeeded;

            if (isUsdtApprovalNeeded) {
                callArgs.push({
                    to: marketFeeToken.address,
                    data: encodeFunctionData({ abi: BalanceOfAbi, functionName: "approve", args: [address, bigNumberApproval] }),
                });
            }
            if (isRainApprovalNeeded) {
                callArgs.push({
                    to: RAIN_ARBI_CONTRACT_ADDRESS,
                    data: encodeFunctionData({ abi: BalanceOfAbi, functionName: "approve", args: [address, bigNumberApproval] }),
                });
            }
            const closePoolData = isPublicPoolResolverAi
                ? encodeFunctionData({ abi: TradePoolAbi, functionName: "closePool" })
                : encodeFunctionData({ abi: TradePoolAbi, functionName: "closePool", args: [proposedOutcome?.choiceIndex ?? 0] });
            callArgs.push({ to: address, data: closePoolData });
            callArgs.push(...gasFeeCallArg(USDT_MOCK_VALUE));
        }
        await getEstimatedTxGasFee(callArgs, isAnyApprovalNeeded);
    };

    const handleProposeResolution = async () => {
        if (!smartAccount) {
            openWalletConnect();
            return;
        }
        const isAiCase = !isPoolPrivate && poolsdetail?.isAiResolver;
        if (isAiCase) {
            setShowAiResolutionCanvas(true)
            await gasEstimationCloseMarket();
        } else {
            setWinnerProposalMode(WINNER_PROPOSAL_MODE.RESOLUTION);
            setShowCreateDisputeOffCanvas(true);
        }
    };

    const optionsWithGraphPercentage = poolsdetail?.options?.map((opt, i) => ({
        ...opt,
        percentage: priceoption?.[opt?._id] ? handleToFixedOnDecimals(+priceoption[opt._id] * 100) : (graph?.[i]?.percentages?.[0] ?? opt.percentage ?? 0),
    }));
    const { visible: optionsToShow, extraCount: optionNumberToHide, moreCount } = getMobileStickyOptionsData(optionsWithGraphPercentage);

    const swipeRef = useSwipeClose(show, handleClose);
    const swipeRef1 = useSwipeClose(show1, handleClose1);
    const swipeRefcreatedispute = useSwipeClose(showcreatedispute, handleCloseCreateDispute);

    return (
        <>
            <SEO
                title={poolsdetail?.question || "Rain Market"}
                description={poolsdetail?.poolDescription || "Trade and predict outcomes for this market."}
                url={window?.location?.href}
            />
            {loader && <Loader text={message} />}

            <StickyHeadingMobile isMobile={isMobile} poolsdetail={poolsdetail} poolStatus={poolStatus} />
            {
                isPoolPrivate && !hasAccess ? null : (
                    <div className="wrapper-detailpage">
                        <section className="detailpage">
                            {
                                isMobile && (
                                    <div className="mobile-information">

                                        {/* TOP HEADER */}
                                        <div className="upper-head">
                                            <div className="left-side">
                                                <span className="status p-0">
                                                    <PoolStatusText poolstatus={poolStatus} />
                                                </span>
                                                <span className="other-text">
                                                    {!marketToken.isStable && "Altcoin, "}
                                                    {poolsdetail?.tags ? poolsdetail.tags.join(", ") : ""}
                                                </span>
                                            </div>

                                            <div className="right-side" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                {/* <a
                                                    className="btn-social-icon"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                        <path d="M12.2812 2.16699C12.6644 2.16699 13.0318 2.3192 13.3027 2.59012C13.5737 2.86105 13.7259 3.2285 13.7259 3.61165V14.4466C13.7258 14.5731 13.6926 14.6973 13.6294 14.8069C13.5663 14.9165 13.4755 15.0076 13.3661 15.0711C13.2566 15.1346 13.1325 15.1682 13.006 15.1687C12.8795 15.1691 12.7551 15.1363 12.6453 15.0736L9.38613 13.2114C9.16789 13.0867 8.92091 13.0212 8.66958 13.0212C8.41825 13.0212 8.17127 13.0867 7.95303 13.2114L4.69388 15.0736C4.58405 15.1363 4.45966 15.1691 4.33317 15.1687C4.20668 15.1682 4.08251 15.1346 3.9731 15.0711C3.86369 15.0076 3.77287 14.9165 3.70973 14.8069C3.64658 14.6973 3.61332 14.5731 3.61328 14.4466V3.61165C3.61328 3.2285 3.76549 2.86105 4.03641 2.59012C4.30734 2.3192 4.67479 2.16699 5.05794 2.16699H12.2812Z" stroke="black" stroke-width="1.44466" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </a> */}
                                                <a
                                                    onClick={() => setOpenSocialModal(true)}
                                                    className="btn-social-icon"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                                        <path d="M17.0003 7.55607C18.5651 7.55607 19.8337 6.28754 19.8337 4.72274C19.8337 3.15793 18.5651 1.8894 17.0003 1.8894C15.4355 1.8894 14.167 3.15793 14.167 4.72274C14.167 6.28754 15.4355 7.55607 17.0003 7.55607Z" stroke="#212121" strokeWidth="1.82143" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M5.66634 14.1669C7.23115 14.1669 8.49967 12.8984 8.49967 11.3336C8.49967 9.76877 7.23115 8.50024 5.66634 8.50024C4.10153 8.50024 2.83301 9.76877 2.83301 11.3336C2.83301 12.8984 4.10153 14.1669 5.66634 14.1669Z" stroke="#212121" strokeWidth="1.82143" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M17.0003 20.7778C18.5651 20.7778 19.8337 19.5092 19.8337 17.9444C19.8337 16.3796 18.5651 15.1111 17.0003 15.1111C15.4355 15.1111 14.167 16.3796 14.167 17.9444C14.167 19.5092 15.4355 20.7778 17.0003 20.7778Z" stroke="#212121" strokeWidth="1.82143" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M8.1123 12.7593L14.5629 16.5182" stroke="#212121" strokeWidth="1.82143" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M14.5534 6.14819L8.1123 9.90708" stroke="#212121" strokeWidth="1.82143" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </a>
                                            </div>
                                        </div>

                                        {/* QUESTION */}
                                        <div className="mid-title">
                                            <h4>{poolsdetail?.question}</h4>
                                        </div>

                                        {/* VOLUME + TIME */}
                                        <div className="last-part">
                                            <div className="volume-text">
                                                <h6>
                                                    <span>{t("Vol")}</span>{" "}
                                                    {`${formatNumberWithCommas(+totalSumLiquidity + +allliquidity)} ${tokenToDisplay}`}
                                                </h6>
                                                {
                                                    !marketToken.isStable && (
                                                        <h5>${formatSmartDecimal(tokenPriceToUsdt * (+totalSumLiquidity + +allliquidity))}</h5>
                                                    )
                                                }
                                            </div>

                                            <div className="left-time">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <g clipPath="url(#clip0_3126_4378)">
                                                        <path d="M7.9987 14.6666C11.6806 14.6666 14.6654 11.6818 14.6654 7.99992C14.6654 4.31802 11.6806 1.33325 7.9987 1.33325C4.3168 1.33325 1.33203 4.31802 1.33203 7.99992C1.33203 11.6818 4.3168 14.6666 7.9987 14.6666Z" stroke="#757575" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M8 4V8L10.6667 9.33333" stroke="#757575" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_3126_4378">
                                                            <rect width="16" height="16" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <p>
                                                    {t("Closes")} <span>{formatDates(poolend)}</span>
                                                </p>
                                            </div>
                                        </div>

                                        <div className="bottom-part">
                                            <div className="left-options-parent">
                                                {optionsToShow?.map((opt, i) => {
                                                    const optIndex = poolsdetail?.options?.findIndex(o => o._id === opt._id) ?? i;
                                                    return (
                                                        <React.Fragment key={opt._id || i}>
                                                            <div className="single-option">
                                                                <span className="dot-circle" style={{ backgroundColor: getBackgroundColor(optIndex, theme, poolsdetail?.options?.length) }}></span>
                                                                <p>{opt?.optionName}</p>
                                                                <h6>{opt?.percentage || 0}%</h6>
                                                            </div>
                                                            {i === 0 && <span className="divider" />}
                                                        </React.Fragment>
                                                    );
                                                })}
                                                {moreCount > 0 && (
                                                    <div className="single-option" onClick={() => setShowOutcomesModal(true)} style={{ cursor: 'pointer' }}>
                                                        <div className="multi-options">
                                                            {Array(optionNumberToHide).fill(0).map((_, idx) => (
                                                                <span key={idx} className="dot-circle" style={{ backgroundColor: getBackgroundColor(2 + idx, theme, poolsdetail?.options?.length) }}></span>
                                                            ))}
                                                        </div>
                                                        <p>+{moreCount} {t("More")}</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <a className="btn-detail" onClick={(e) => setShowMarketRulesModal(true)}>{t("Details")}</a>


                                    </div>
                                )
                            }
                            {isMobile && (
                                <div className="mobile-custom-tabs">
                                    <button
                                        className={mobiletabs === 0 ? "active" : ""}
                                        onClick={() => setMobileTabs(0)}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                        >
                                            <path
                                                d="M8 0.6875C6.55373 0.6875 5.13993 1.11637 3.9374 1.91988C2.73486 2.72339 1.7976 3.86544 1.24413 5.20163C0.690668 6.53781 0.545857 8.00811 0.828011 9.4266C1.11017 10.8451 1.80661 12.148 2.82928 13.1707C3.85196 14.1934 5.15492 14.8898 6.57341 15.172C7.99189 15.4541 9.46219 15.3093 10.7984 14.7559C12.1346 14.2024 13.2766 13.2651 14.0801 12.0626C14.8836 10.8601 15.3125 9.44628 15.3125 8C15.3105 6.06123 14.5394 4.20246 13.1685 2.83154C11.7975 1.46063 9.93877 0.689547 8 0.6875ZM8 14.1875C6.77623 14.1875 5.57994 13.8246 4.56241 13.1447C3.54488 12.4648 2.75182 11.4985 2.2835 10.3679C1.81518 9.23724 1.69265 7.99314 1.93139 6.79288C2.17014 5.59262 2.75944 4.49011 3.62478 3.62478C4.49012 2.75944 5.59262 2.17014 6.79288 1.93139C7.99314 1.69264 9.23724 1.81518 10.3679 2.2835C11.4985 2.75181 12.4648 3.54488 13.1447 4.56241C13.8246 5.57994 14.1875 6.77623 14.1875 8C14.1856 9.64046 13.5331 11.2132 12.3732 12.3732C11.2132 13.5331 9.64046 14.1856 8 14.1875ZM9.125 11.375C9.125 11.5242 9.06574 11.6673 8.96025 11.7727C8.85476 11.8782 8.71169 11.9375 8.5625 11.9375C8.26413 11.9375 7.97799 11.819 7.76701 11.608C7.55603 11.397 7.4375 11.1109 7.4375 10.8125V8C7.28832 8 7.14525 7.94074 7.03976 7.83525C6.93427 7.72976 6.875 7.58668 6.875 7.4375C6.875 7.28832 6.93427 7.14524 7.03976 7.03975C7.14525 6.93426 7.28832 6.875 7.4375 6.875C7.73587 6.875 8.02202 6.99353 8.233 7.2045C8.44398 7.41548 8.5625 7.70163 8.5625 8V10.8125C8.71169 10.8125 8.85476 10.8718 8.96025 10.9773C9.06574 11.0827 9.125 11.2258 9.125 11.375ZM6.875 4.90625C6.875 4.73937 6.92449 4.57624 7.0172 4.43749C7.10991 4.29873 7.24169 4.19059 7.39586 4.12673C7.55004 4.06287 7.71969 4.04616 7.88336 4.07871C8.04703 4.11127 8.19737 4.19163 8.31537 4.30963C8.43337 4.42763 8.51373 4.57797 8.54629 4.74164C8.57885 4.90531 8.56214 5.07496 8.49828 5.22914C8.43441 5.38331 8.32627 5.51509 8.18752 5.6078C8.04876 5.70052 7.88563 5.75 7.71875 5.75C7.49498 5.75 7.28037 5.66111 7.12213 5.50287C6.9639 5.34464 6.875 5.13003 6.875 4.90625Z"
                                                fill="#7A7A7A"
                                            />
                                        </svg>
                                        {t("Overview")}
                                    </button>
                                    {/* <button
                                        className={mobiletabs === 1 ? "active" : ""}
                                        onClick={() => setMobileTabs(1)}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                        >
                                            <path
                                                d="M16.3125 14.625C16.3125 14.7742 16.2532 14.9173 16.1477 15.0227C16.0423 15.1282 15.8992 15.1875 15.75 15.1875H2.25C2.10082 15.1875 1.95774 15.1282 1.85225 15.0227C1.74676 14.9173 1.6875 14.7742 1.6875 14.625V3.375C1.6875 3.22582 1.74676 3.08274 1.85225 2.97725C1.95774 2.87176 2.10082 2.8125 2.25 2.8125C2.39918 2.8125 2.54226 2.87176 2.64775 2.97725C2.75324 3.08274 2.8125 3.22582 2.8125 3.375V11.0173L6.35203 7.47703C6.40427 7.42473 6.46631 7.38324 6.5346 7.35494C6.60288 7.32663 6.67608 7.31206 6.75 7.31206C6.82392 7.31206 6.89712 7.32663 6.9654 7.35494C7.03369 7.38324 7.09573 7.42473 7.14797 7.47703L9 9.32977L12.7048 5.625H11.25C11.1008 5.625 10.9577 5.56574 10.8523 5.46025C10.7468 5.35476 10.6875 5.21168 10.6875 5.0625C10.6875 4.91332 10.7468 4.77024 10.8523 4.66475C10.9577 4.55926 11.1008 4.5 11.25 4.5H14.0625C14.2117 4.5 14.3548 4.55926 14.4602 4.66475C14.5657 4.77024 14.625 4.91332 14.625 5.0625V7.875C14.625 8.02418 14.5657 8.16726 14.4602 8.27275C14.3548 8.37824 14.2117 8.4375 14.0625 8.4375C13.9133 8.4375 13.7702 8.37824 13.6648 8.27275C13.5593 8.16726 13.5 8.02418 13.5 7.875V6.42023L9.39797 10.523C9.34573 10.5753 9.28369 10.6168 9.2154 10.6451C9.14712 10.6734 9.07392 10.6879 9 10.6879C8.92608 10.6879 8.85288 10.6734 8.7846 10.6451C8.71631 10.6168 8.65427 10.5753 8.60203 10.523L6.75 8.67023L2.8125 12.6077V14.0625H15.75C15.8992 14.0625 16.0423 14.1218 16.1477 14.2273C16.2532 14.3327 16.3125 14.4758 16.3125 14.625Z"
                                                fill="#7A7A7A"
                                            />
                                        </svg>
                                        {t("Charts")}
                                    </button> */}
                                    <button
                                        className={mobiletabs === 2 ? "active" : ""}
                                        onClick={() => {
                                            setMobileTabs(2);
                                            setKey("comments");
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="19"
                                            height="18"
                                            viewBox="0 0 19 18"
                                            fill="none"
                                        >
                                            <path
                                                d="M11.9375 3.75C11.675 3.75 11.453 3.65925 11.2715 3.47775C11.09 3.29625 10.9995 3.0745 11 2.8125C11.0005 2.5505 11.0913 2.3285 11.2723 2.1465C11.4533 1.9645 11.675 1.874 11.9375 1.875C12.2 1.876 12.422 1.96675 12.6035 2.14725C12.785 2.32775 12.8755 2.5495 12.875 2.8125C12.8745 3.0755 12.7838 3.2975 12.6027 3.4785C12.4218 3.6595 12.2 3.75 11.9375 3.75ZM11.9375 16.125C11.675 16.125 11.453 16.0342 11.2715 15.8527C11.09 15.6712 10.9995 15.4495 11 15.1875C11.0005 14.9255 11.0913 14.7035 11.2723 14.5215C11.4533 14.3395 11.675 14.249 11.9375 14.25C12.2 14.251 12.422 14.3418 12.6035 14.5223C12.785 14.7028 12.8755 14.9245 12.875 15.1875C12.8745 15.4505 12.7838 15.6725 12.6027 15.8535C12.4218 16.0345 12.2 16.125 11.9375 16.125ZM14.9375 6.375C14.675 6.375 14.453 6.28425 14.2715 6.10275C14.09 5.92125 13.9995 5.6995 14 5.4375C14.0005 5.1755 14.0913 4.9535 14.2723 4.7715C14.4533 4.5895 14.675 4.499 14.9375 4.5C15.2 4.501 15.422 4.59175 15.6035 4.77225C15.785 4.95275 15.8755 5.1745 15.875 5.4375C15.8745 5.7005 15.7838 5.9225 15.6028 6.1035C15.4218 6.2845 15.2 6.375 14.9375 6.375ZM14.9375 13.5C14.675 13.5 14.453 13.4092 14.2715 13.2277C14.09 13.0462 13.9995 12.8245 14 12.5625C14.0005 12.3005 14.0913 12.0785 14.2723 11.8965C14.4533 11.7145 14.675 11.624 14.9375 11.625C15.2 11.626 15.422 11.7168 15.6035 11.8973C15.785 12.0778 15.8755 12.2995 15.875 12.5625C15.8745 12.8255 15.7838 13.0475 15.6028 13.2285C15.4218 13.4095 15.2 13.5 14.9375 13.5ZM16.0625 9.9375C15.8 9.9375 15.578 9.84675 15.3965 9.66525C15.215 9.48375 15.1245 9.262 15.125 9C15.1255 8.738 15.2163 8.516 15.3973 8.334C15.5783 8.152 15.8 8.0615 16.0625 8.0625C16.325 8.0635 16.547 8.15425 16.7285 8.33475C16.91 8.51525 17.0005 8.737 17 9C16.9995 9.263 16.9088 9.485 16.7278 9.666C16.5468 9.847 16.325 9.9375 16.0625 9.9375ZM9.5 16.5C8.4625 16.5 7.4875 16.303 6.575 15.909C5.6625 15.515 4.86875 14.9808 4.19375 14.3063C3.51875 13.6318 2.9845 12.838 2.591 11.925C2.1975 11.012 2.0005 10.037 2 9C1.9995 7.963 2.1965 6.988 2.591 6.075C2.9855 5.162 3.51975 4.36825 4.19375 3.69375C4.86775 3.01925 5.6615 2.485 6.575 2.091C7.4885 1.697 8.4635 1.5 9.5 1.5V3C7.825 3 6.40625 3.58125 5.24375 4.74375C4.08125 5.90625 3.5 7.325 3.5 9C3.5 10.675 4.08125 12.0937 5.24375 13.2562C6.40625 14.4187 7.825 15 9.5 15V16.5ZM11.975 12.525L8.75 9.3V5.25H10.25V8.7L13.025 11.475L11.975 12.525Z"
                                                fill="#7A7A7A"
                                            />
                                        </svg>
                                        {t("Activity")}
                                    </button>
                                </div>
                            )}
                            {isMobile &&
                                !(isClaimWindowOpen && !claimNotDisputed) && (
                                    <div className={!poolsdetail?.poolFinalized &&
                                        new Date() > new Date(poolstart) &&
                                        pollStatus != POOL_ENDED ? "btn-trade-parent" : "btn-trade-parent without-propose-btn"}>
                                        <button
                                            id="btn-place-trade"
                                            onClick={handlePlaceTradeClick}
                                            disabled={isClaimWindowOpen && !claimNotDisputed}
                                        >
                                            {t("Place trade")}
                                        </button>
                                    </div>
                                )}
                            {isMobile && isClaimWindowOpen && !claimNotDisputed && poolsdetail?.poolFinalized && poolsdetail?.winnerOption && sumOfClaimvalue > 0 && (
                                <div className="btn-trade-parent claim-box-mobile">
                                    <div className="reward-show">
                                        <div className="inner-left">
                                            <h5>Share Rewards</h5>
                                            <h6>
                                                <span className="dot-color" style={{ backgroundColor: getBackgroundColor(poolsdetail?.options?.findIndex(opt => opt._id === winnerData?.winnerId), theme, poolsdetail?.options?.length) }}></span>
                                                {winnerData?.winnerOption}
                                            </h6>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <g clipPath="url(#clip0_3513_745)">
                                                    <path d="M8.00016 14.6666C11.6821 14.6666 14.6668 11.6818 14.6668 7.99992C14.6668 4.31802 11.6821 1.33325 8.00016 1.33325C4.31826 1.33325 1.3335 4.31802 1.3335 7.99992C1.3335 11.6818 4.31826 14.6666 8.00016 14.6666Z" stroke="#29B207" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M6 8.00008L7.33333 9.33341L10 6.66675" stroke="#29B207" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_3513_745">
                                                        <rect width="16" height="16" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                        <div className="inner-right">
                                            <h4>{getTokenSymbol(tokenSymbol)}{formatSmartDecimal(+sumOfClaimvalue || 0)}</h4>
                                        </div>
                                    </div>
                                    <button
                                        id="btn-place-trade"
                                        onClick={() => openClaimModal()}
                                        disabled={claimcheck}
                                    >
                                        {claimcheck ? t("Claimed") : t("Claim")}
                                    </button>
                                </div>
                            )}
                            <div className="custom-container">
                                <div className="bottom-content">
                                    <div className="left-side">
                                        {(isMobile ? false : true) && (
                                            <div className="parent-box">
                                                <div className="main-heading">
                                                    <div className="inside-left">
                                                        <div className="upper-twice-text">
                                                            <p>
                                                                <PoolStatusText
                                                                    poolstatus={poolStatus}
                                                                />
                                                                {!marketToken.isStable && <span className="incentiv-bg"><span className="incetiv-tag">Altcoin</span></span>} {" "}
                                                                {poolsdetail?.tags
                                                                    ? poolsdetail?.tags?.join(", ")
                                                                    : ""}
                                                            </p>
                                                            <a onClick={() => setOpenSocialModal(true)} className="btn-social-icon"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                                                <path d="M17.0003 7.55607C18.5651 7.55607 19.8337 6.28754 19.8337 4.72274C19.8337 3.15793 18.5651 1.8894 17.0003 1.8894C15.4355 1.8894 14.167 3.15793 14.167 4.72274C14.167 6.28754 15.4355 7.55607 17.0003 7.55607Z" stroke="#212121" stroke-width="1.82143" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M5.66634 14.1669C7.23115 14.1669 8.49967 12.8984 8.49967 11.3336C8.49967 9.76877 7.23115 8.50024 5.66634 8.50024C4.10153 8.50024 2.83301 9.76877 2.83301 11.3336C2.83301 12.8984 4.10153 14.1669 5.66634 14.1669Z" stroke="#212121" stroke-width="1.82143" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M17.0003 20.7778C18.5651 20.7778 19.8337 19.5092 19.8337 17.9444C19.8337 16.3796 18.5651 15.1111 17.0003 15.1111C15.4355 15.1111 14.167 16.3796 14.167 17.9444C14.167 19.5092 15.4355 20.7778 17.0003 20.7778Z" stroke="#212121" stroke-width="1.82143" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M8.1123 12.7593L14.5629 16.5182" stroke="#212121" stroke-width="1.82143" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M14.5534 6.14819L8.1123 9.90708" stroke="#212121" stroke-width="1.82143" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg></a>
                                                        </div>
                                                        <h2>{poolsdetail?.question}</h2>
                                                    </div>
                                                </div>
                                                <div className="bottom-inline-values">
                                                    <div className="single-value">
                                                        <p>{t("Total Volume")}</p>
                                                        <h6>{totalSumVolumn} {tokenToDisplay}</h6>
                                                        {
                                                            !marketToken.isStable && (
                                                                <h5>${formatSmartDecimal(+tokenPriceToUsdt * +parsedPoolVolumn)}</h5>
                                                            )
                                                        }

                                                    </div>
                                                    <div className="single-value">
                                                        <p>{t("Pot Size")}</p>
                                                        <h6>
                                                            {+allliquidity < 0
                                                                ? 0
                                                                : +totalSumLiquidity > 0
                                                                    ? formatNumberWithCommas(+totalSumLiquidity + +allliquidity)
                                                                    : formatNumberWithCommas(+allliquidity)} {tokenToDisplay}
                                                        </h6>
                                                        {
                                                            !marketToken.isStable && (
                                                                <h5>${formatSmartDecimal(tokenPriceToUsdt * (+totalSumLiquidity + +allliquidity))}</h5>
                                                            )
                                                        }

                                                    </div>
                                                    <div className="single-value">
                                                        <PoolTimerUI
                                                            poolstart={poolstart}
                                                            poolend={poolend}
                                                            poolsdetail={poolsdetail}
                                                            setPollStatus={setPollStatus}
                                                            setIsDisabled={setIsDisabled}
                                                        />
                                                    </div>
                                                    <div className="single-value">
                                                        <p>{t("Trade with")}</p>
                                                        <h6>{getTokenSymbol(tokenSymbol, true)}{tokenToDisplay}</h6>
                                                    </div>
                                                </div>
                                                {!poolsdetail?.poolFinalized &&
                                                    new Date(poolend) < new Date() &&
                                                    (
                                                        (poolsdetail?.version <= 2 && ownermatch) ||
                                                        (poolsdetail?.version > 2)
                                                    ) && (
                                                        <div className="closemarket-ui">
                                                            <div className="text">
                                                                <h6>{t("Market has ended")}</h6>
                                                                <p>{t("Close the market to decide the winner.")}</p>
                                                            </div>

                                                            <button
                                                                className="btnclosemarket"
                                                                onClick={handleProposeResolution}
                                                            >
                                                                {t("Close the market")}
                                                            </button>
                                                        </div>
                                                    )}
                                            </div>
                                        )}

                                        {youTubeId ? (
                                            <div className="livestreamvideo">
                                                <iframe
                                                    src={`https://www.youtube.com/embed/${youTubeId}?autoplay=1`}
                                                    title={t("YouTube video player")}
                                                    frameBorder="0"
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    allowFullScreen
                                                ></iframe>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        {(isMobile ? mobiletabs === 0 : true) && (
                                            <div className="graph-parent" style={{ marginTop: "20px" }}>
                                                <LineChart
                                                    options={poolsdetail?.options}
                                                    data={graph}
                                                    onFilterChange={getGraphData}
                                                    contractAddress={poolsdetail?.contractAddress}
                                                />
                                            </div>
                                        )}
                                        {(isMobile ? mobiletabs === 0 : true) && (
                                            <Accordion
                                                className="custom-option-list"
                                                defaultActiveKey={[]}
                                                alwaysOpen
                                                activeKey={isMobile ? [] : undefined}
                                                onSelect={isMobile ? () => { } : undefined}
                                            >
                                                {poolsdetail?.options?.length > 0 &&
                                                    poolsdetail?.options?.map((option, index) => {
                                                        const background = getBackgroundColor(
                                                            index,
                                                            theme,
                                                            poolsdetail?.options?.length
                                                        );
                                                        const { isWinner: isWinnerOption, isLoser: isLoserOption } = getOptionResolvedStatus(option, poolsdetail, winnerData);
                                                        const optionVolumeIndexes = volumn?.find(
                                                            (vol) => parseInt(vol.option) === index + 1
                                                        );
                                                        const optionVolume = convertFromWeiEthers(
                                                            optionVolumeIndexes?.totalVolume,
                                                            tokenDecimals
                                                        );
                                                        const matchedInvestments = messagesocketbuy.filter(
                                                            (item) =>
                                                                item.investments?.some(
                                                                    (investment) =>
                                                                        String(investment.option) === String(index + 1)
                                                                )
                                                        );
                                                        const matchedInvestmentSum = matchedInvestments.reduce(
                                                            (sum, item) =>
                                                                sum + parseFloat(item.totalInvestment || "0"),
                                                            0
                                                        );
                                                        const updatedTotalInvestment =
                                                            matchedInvestments.length > 0
                                                                ? matchedInvestmentSum + parseFloat(optionVolume)
                                                                : optionVolume;

                                                        const indivdualpercent = !isNaN(
                                                            parseFloat(percentageindiv[index])
                                                        )
                                                            ? parseFloat(
                                                                convertFromWeiEthers(
                                                                    String(parseFloat(percentageindiv[index])),
                                                                    tokenDecimals
                                                                )
                                                            )
                                                            : "0";

                                                        const priceoptionFixed = isNaN(
                                                            handleToFixedOnDecimals(priceoption[option?._id])
                                                        )
                                                            ? 0
                                                            : priceoption[option?._id];

                                                        const MySharesFixed = isNaN(
                                                            (swapbalance[option._id])
                                                        )
                                                            ? 0
                                                            : (swapbalance[option._id]);

                                                        const priceInCents = parseFloat(priceoptionFixed * 100);
                                                        const ChanceFixed = isNaN(priceInCents)
                                                            ? 0
                                                            : priceInCents % 1 === 0
                                                                ? handleToFixedOnDecimals(+priceInCents)
                                                                : handleToFixedOnDecimals(+priceInCents);

                                                        const LineFixed =
                                                            isNaN(parseFloat((1 / ChanceFixed) * 100)) ||
                                                                !isFinite(parseFloat((1 / ChanceFixed) * 100))
                                                                ? 0
                                                                : handleToFixedOnDecimals((1 / ChanceFixed) * 100);

                                                        const mySharesNum = parseFloat(MySharesFixed);
                                                        const individualPercentNum = parseFloat(indivdualpercent);
                                                        const calculatedPercentage =
                                                            (mySharesNum / individualPercentNum) * 100;

                                                        let SharesPercentage;
                                                        if (calculatedPercentage === 100) {
                                                            SharesPercentage = 100;
                                                        } else {
                                                            SharesPercentage =
                                                                isNaN(calculatedPercentage) ||
                                                                    !isFinite(calculatedPercentage)
                                                                    ? 0
                                                                    : calculatedPercentage > 100
                                                                        ? handleToFixedOnDecimals(calculatedPercentage)
                                                                        : handleToFixedOnDecimals(calculatedPercentage);
                                                        }

                                                        const initialpositionNum = parseFloat(initialposition);
                                                        const DP = dynamicPayout?.[index];
                                                        const Potentialpnl = isNaN(DP - initialpositionNum)
                                                            ? 0
                                                            : DP - initialpositionNum;

                                                        const openOptionDetailModal = (e) => {
                                                            if (!isMobile) return;
                                                            handleOpenOptionDetail({
                                                                option,
                                                                optionIndex: index,
                                                                optionName: option.optionName,
                                                                background,
                                                                chanceFixed: ChanceFixed,
                                                                updatedTotalInvestment,
                                                                lineFixed: LineFixed,
                                                                priceoptionFixed,
                                                                mySharesFixed: MySharesFixed,
                                                                sharePercentage: SharesPercentage,
                                                                dynamicPayout: DP,
                                                                potentialPnl: Potentialpnl,
                                                            });
                                                        };

                                                        return (
                                                            <Accordion.Item
                                                                key={index}
                                                                eventKey={String(index)}
                                                                style={{
                                                                    backgroundColor: background,
                                                                    ...(isWinnerOption && isClaimWindowOpen && !claimNotDisputed ? { outline: "4px solid rgba(0, 0, 0, 0.08)" } : {}),
                                                                    ...(isLoserOption && isClaimWindowOpen && !claimNotDisputed ? { opacity: 0.4 } : {}),
                                                                }}
                                                                onClick={(e) => {
                                                                    if (isMobile) {
                                                                        e.stopPropagation();
                                                                    }
                                                                }}
                                                            >
                                                                <Accordion.Header onClick={(e) => {
                                                                    if (isMobile) {
                                                                        e.preventDefault();
                                                                        openOptionDetailModal(e);
                                                                    }
                                                                }}>
                                                                    <div className="parent">
                                                                        <div className="left-content">
                                                                            <h4>
                                                                                {option.optionName}{" "}
                                                                                {option.optionName === NONE && (
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={
                                                                                            <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                                                                                <p> Covers cases where no single option or
                                                                                                    multiple options are correct, or where
                                                                                                    the event cannot be resolved as
                                                                                                    expected.</p>
                                                                                            </TooltipCustom>
                                                                                        }
                                                                                    >
                                                                                        <svg
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            width="24"
                                                                                            height="24"
                                                                                            viewBox="0 0 24 24"
                                                                                            fill="none"
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            <path
                                                                                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                                                                                stroke="#757575"
                                                                                                stroke-width="2"
                                                                                                stroke-linecap="round"
                                                                                                stroke-linejoin="round"
                                                                                            />
                                                                                            <path
                                                                                                d="M12 16V12"
                                                                                                stroke="#757575"
                                                                                                stroke-width="2"
                                                                                                stroke-linecap="round"
                                                                                                stroke-linejoin="round"
                                                                                            />
                                                                                            <path
                                                                                                d="M12 8H12.01"
                                                                                                stroke="#757575"
                                                                                                stroke-width="2"
                                                                                                stroke-linecap="round"
                                                                                                stroke-linejoin="round"
                                                                                            />
                                                                                        </svg>
                                                                                    </OverlayTrigger>
                                                                                )}
                                                                            </h4>
                                                                            {!(isMobile && option.optionName === NONE) && (
                                                                                <p>
                                                                                    {t("Vol")} {" "}
                                                                                    {!isNaN(updatedTotalInvestment) &&
                                                                                        updatedTotalInvestment !== null
                                                                                        ? formatNumberWithCommas(
                                                                                            updatedTotalInvestment
                                                                                        )
                                                                                        : "0"} {tokenToDisplay}
                                                                                    {tokenToDisplay === TOKEN_RAIN &&
                                                                                        <>
                                                                                            <span>${formatNumbers(updatedTotalInvestment * tokenPriceToUsdt)}</span>
                                                                                        </>
                                                                                    }
                                                                                </p>
                                                                            )}
                                                                        </div>
                                                                        <div className="right-content">
                                                                            <div className="text">
                                                                                <h3>{ChanceFixed}%</h3>
                                                                                <p>{t("Chance")}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Accordion.Header>

                                                                <Accordion.Body>
                                                                    <div className="inline-content">
                                                                        {!poolsdetail?.poolFinalized && (
                                                                            <div className="text">
                                                                                <p>{t("My Shares")}</p>
                                                                                <h6>{handleToFixedOnDecimals(MySharesFixed)}</h6>
                                                                            </div>
                                                                        )}
                                                                        <div className="text">
                                                                            <p>{t("Option Ownership")}</p>
                                                                            <h6>{SharesPercentage}%</h6>
                                                                        </div>
                                                                        <div className="text">
                                                                            <p>{t("Line")}</p>
                                                                            <h6>{LineFixed}</h6>
                                                                        </div>
                                                                        {smartAccount && (
                                                                            <div className="text">
                                                                                <p>
                                                                                    {poolsdetail?.poolFinalized
                                                                                        ? t("PnL")
                                                                                        : t("Potential PnL")}
                                                                                </p>
                                                                                <h6>
                                                                                    {
                                                                                        !marketToken.isStable
                                                                                            ? formatSmartDecimal(
                                                                                                (Number(Potentialpnl) || 0) * (Number(tokenPriceToUsdt) || 0)
                                                                                            )
                                                                                            : formatSmartDecimal(Number(Potentialpnl) || 0)
                                                                                    }
                                                                                </h6>
                                                                            </div>
                                                                        )}
                                                                        <div className="text">
                                                                            <p>
                                                                                {poolsdetail?.poolFinalized
                                                                                    ? t("Payout")
                                                                                    : t("Dynamic Payout")}
                                                                            </p>
                                                                            <h6>
                                                                                {!smartAccount
                                                                                    ? "0.00"
                                                                                    : handleToFixedOnDecimals(DP) || "0"} {tokenToDisplay}
                                                                            </h6>
                                                                            {
                                                                                !marketToken.isStable && (
                                                                                    <h5>${formatSmartDecimal(Number(DP * tokenPriceToUsdt || 0))}</h5>
                                                                                )
                                                                            }

                                                                        </div>
                                                                        <div className="text">
                                                                            <p>{t("Price Per Share")}</p>
                                                                            <h6>
                                                                                {handleToFixedOnDecimals(+priceoptionFixed)} {tokenToDisplay}
                                                                            </h6>
                                                                            {
                                                                                !marketToken.isStable && (
                                                                                    <h5>${formatSmartDecimal(Number(priceoptionFixed * tokenPriceToUsdt || 0))}</h5>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        );
                                                    })}
                                            </Accordion>
                                        )}
                                        {
                                            isMobile && (mobiletabs === 0) && (
                                                <>
                                                    <PoolFinalizationMobile
                                                        t={t}
                                                        poolsdetail={poolsdetail}
                                                        winnerData={winnerData}
                                                        isPoolPrivate={isPoolPrivate}
                                                        handleShowReasoning={handleShowReasoning}
                                                        publicPoolResolverText={publicPoolResolverText}
                                                        poolDisputed={poolDisputed}
                                                        isAppealed={isAppealed}
                                                        smartAccount={smartAccount}
                                                        handleShowCreateDispute={handleShowCreateDispute}
                                                        revealWinnerUi={revealWinnerUi}
                                                        revealWinner={revealWinner}
                                                        timeExtendUi={timeExtendUi}
                                                        poolUnderDisputeUi={poolUnderDisputeUi}
                                                        publicPoolResolverAddress={publicPoolResolverAddress}
                                                        disputeTimer={disputeTimer}
                                                        setDisputeTimer={setDisputeTimer}
                                                        extendDisputeTimer={extendDisputeTimer}
                                                        ownermatch={ownermatch}
                                                        handleShow14={handleShow14}
                                                        isClaimWindowOpen={isClaimWindowOpen}
                                                        claimNotDisputed={claimNotDisputed}
                                                        decideWinnerTime={decideWinnerTime}
                                                        claimEligibility={claimEligibility}
                                                        setClaimNotDisputed={setClaimNotDisputed}
                                                        userliquidity={userliquidity}
                                                        percentageindiv={percentageindiv}
                                                        web3={web3}
                                                        pair={pair}
                                                        price={price}
                                                        swapbalance={swapbalance}
                                                        poolDisputedWinner={poolDisputedWinner}
                                                        claimcheck={claimcheck}
                                                        claimvalue={claimvalue}
                                                        sumOfClaimvalue={sumOfClaimvalue}
                                                        getClaims={getClaims}
                                                        poolPnl={poolPnl}
                                                        theme={theme}
                                                        isPublicPoolResolverAi={isPublicPoolResolverAi}
                                                        disputeOrAppealText={disputeOrAppealText}
                                                        decidedByText={decidedByText}
                                                        setShowCreateDisputeOffCanvas={setShowCreateDisputeOffCanvas}
                                                        setShowEvidence={setShowEvidence}
                                                        setShowEvidenceHistory={setShowEvidenceHistory}
                                                        investedAmount={initialposition}
                                                        totalPayout={totalPayout}
                                                        tokenData={poolsdetail?.token}
                                                        setWinnerProposalMode={setWinnerProposalMode}
                                                        reSubmitOrFinalizeSpinner={reSubmitOrFinalizeSpinner}
                                                        showresubmit={showresubmit}
                                                        setShowResubmit={setShowResubmit}
                                                        oracleExtendedTimeNo={oracleExtendedTimeNo}
                                                        gasEstimateInUsdt={gasEstimateInUsdt}
                                                        gasFeesSpinner={gasFeesSpinner}
                                                        getEstimatedTxGasFee={getEstimatedTxGasFee}
                                                        setGasFeesSpiner={setGasFeesSpiner}
                                                        setPoolStatus={setPoolStatus}
                                                        openClaimModal={openClaimModal}
                                                        openWalletConnect={openWalletConnect}
                                                        hasTooEarlyHistory={hasTooEarlyHistory}
                                                    />
                                                </>
                                            )
                                        }
                                        {canShowProposeResolutionButton && isMobile && (mobiletabs === 0) && (
                                            <>
                                                <button
                                                    className="btnclosemarket btnclosemarketmbl mb-0"
                                                    onClick={() => smartAccount ? handleProposeResolution() : openWalletConnect()}
                                                    style={{ marginTop: "10px" }}
                                                >
                                                    {t("Close the market")}
                                                </button>
                                            </>
                                        )}
                                        {
                                            (isMobile ? false : true) && (
                                                <div className="market-info-parent">
                                                    <div className={marketinfo ? "main-heading" : "main-heading m-0"} onClick={() => {
                                                        if (window.innerWidth <= 991) {
                                                            setMarketInfo(!marketinfo);
                                                        }
                                                    }}>
                                                        <div className="inside-text">
                                                            <h4>Market Rules</h4>
                                                            {/* <p className="date-text">Created: {getDateNTimeInSlashes(poolsdetail?.createdAt)}</p> */}
                                                        </div>
                                                        {
                                                            window.innerWidth < 991 && (
                                                                <svg style={marketinfo ? { transform: "rotate(180deg)" } : {}} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                    <path d="M8.70956 11.71L11.2996 14.3C11.6896 14.69 12.3196 14.69 12.7096 14.3L15.2996 11.71C15.9296 11.08 15.4796 10 14.5896 10H9.40956C8.51956 10 8.07956 11.08 8.70956 11.71Z" fill="#DAD9D9" />
                                                                </svg>
                                                            )
                                                        }
                                                    </div>
                                                    {
                                                        marketinfo ? <><div className="bottom-part">
                                                            {poolsdetail?.poolDescription && <>
                                                                <h6 className="des-text">Description</h6>
                                                                <p className="para">{poolsdetail?.poolDescription}</p></>}
                                                            <div className="creator-box-parent">
                                                                <div className="creator" >
                                                                    <p>Created by</p>
                                                                    <h6><img src={poolsdetail?.poolOwnerprofilePic} alt="img" className="img-fluid" />
                                                                        <Link className="creator_link" to={`/user-profile?id=${poolsdetail?.creator}`}>
                                                                            {!isEthereumWalletAddress(poolsdetail?.poolOwnerNameOrWallet)
                                                                                ? poolsdetail?.poolOwnerNameOrWallet
                                                                                : `${poolsdetail?.poolOwnerWalletAddress?.slice(0, 5)}...${poolsdetail?.poolOwnerWalletAddress?.slice(-3)}`} <span className="divider" /> <span className="time-text">{poolsdetail?.createdAt ? `${formatDates(poolsdetail?.createdAt)} - ${formatTimeTo12Hour(poolsdetail?.createdAt)}` : ''}</span>
                                                                        </Link>
                                                                        {rainWalletFinder &&
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                                <path d="M10.9502 12.7L9.5002 11.275C9.31686 11.0917 9.08786 11 8.8132 11C8.53853 11 8.30086 11.1 8.1002 11.3C7.91686 11.4834 7.8252 11.7167 7.8252 12C7.8252 12.2834 7.91686 12.5167 8.1002 12.7L10.2502 14.85C10.4502 15.05 10.6835 15.15 10.9502 15.15C11.2169 15.15 11.4502 15.05 11.6502 14.85L15.9002 10.6C16.1002 10.4 16.1959 10.1667 16.1872 9.90004C16.1785 9.63337 16.0829 9.40004 15.9002 9.20004C15.7002 9.00004 15.4629 8.89604 15.1882 8.88804C14.9135 8.88004 14.6759 8.97571 14.4752 9.17504L10.9502 12.7ZM8.1502 21.75L6.7002 19.3L3.9502 18.7C3.7002 18.65 3.5002 18.521 3.3502 18.313C3.2002 18.105 3.14186 17.8757 3.1752 17.625L3.4502 14.8L1.5752 12.65C1.40853 12.4667 1.3252 12.25 1.3252 12C1.3252 11.75 1.40853 11.5334 1.5752 11.35L3.4502 9.20004L3.1752 6.37504C3.14186 6.12504 3.2002 5.89571 3.3502 5.68704C3.5002 5.47837 3.7002 5.34937 3.9502 5.30004L6.7002 4.70004L8.1502 2.25004C8.28353 2.03337 8.46686 1.88737 8.7002 1.81204C8.93353 1.73671 9.16686 1.74937 9.4002 1.85004L12.0002 2.95004L14.6002 1.85004C14.8335 1.75004 15.0669 1.73737 15.3002 1.81204C15.5335 1.88671 15.7169 2.03271 15.8502 2.25004L17.3002 4.70004L20.0502 5.30004C20.3002 5.35004 20.5002 5.47937 20.6502 5.68804C20.8002 5.89671 20.8585 6.12571 20.8252 6.37504L20.5502 9.20004L22.4252 11.35C22.5919 11.5334 22.6752 11.75 22.6752 12C22.6752 12.25 22.5919 12.4667 22.4252 12.65L20.5502 14.8L20.8252 17.625C20.8585 17.875 20.8002 18.1044 20.6502 18.313C20.5002 18.5217 20.3002 18.6507 20.0502 18.7L17.3002 19.3L15.8502 21.75C15.7169 21.9667 15.5335 22.1127 15.3002 22.188C15.0669 22.2634 14.8335 22.2507 14.6002 22.15L12.0002 21.05L9.4002 22.15C9.16686 22.25 8.93353 22.2627 8.7002 22.188C8.46686 22.1134 8.28353 21.9674 8.1502 21.75Z" fill="#2FB0FB" />
                                                                            </svg>}</h6>
                                                                </div>
                                                                <div className="resolver">
                                                                    <div className="upper-text">
                                                                        <p>Resolution Method</p>
                                                                        <h6>{poolsdetail?.isAiResolver ? <>{
                                                                            theme === DARK_THEME ? <img src='\assets\olympus-outcomedark.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px", width: "auto", height: "auto", borderRadius: "unset" }} /> :
                                                                                <img src='\assets\olympus-outcome.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px", width: "auto", height: "auto", borderRadius: "unset" }} />
                                                                        }</> : 'Manual Resolution'}</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {poolsdetail?.poolFinalized && poolsdetail?.winnerOption && winnerProposer && (
                                                                <div className="creator-box-parent" style={{ marginTop: "20px" }}>
                                                                    <div className="creator p-0" >
                                                                        <p>{isPublicPoolResolverAi ? "Triggered by" : "Closed by"}</p>
                                                                        <h6 className="creator_link">
                                                                            <img src={winnerProposer?.user?.profilePic} alt="img" className="img-fluid" style={{ width: "18px", height: "18px", borderRadius: "50%" }} /> {formatProposerName(winnerProposer)}
                                                                            <span className="divider" />
                                                                            <span className="time-text">{winnerProposer?.createdAt ? `${formatDates(winnerProposer.createdAt)} - ${formatTimeTo12Hour(winnerProposer.createdAt)}` : ''}</span>
                                                                        </h6>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div></> : ""
                                                    }
                                                </div>
                                            )
                                        }
                                        {(isMobile ? mobiletabs === 2 : true) && (
                                            <div className="bottom-tabs">
                                                <Tabs
                                                    activeKey={key}
                                                    onSelect={(k) => setKey(k)}
                                                    id="uncontrolled-tab-example"
                                                    className="left-side-tabs"
                                                >
                                                    <Tab
                                                        eventKey="comments"
                                                        title={`${t("Comments")} (${`${commentlist?.length}`})`}
                                                    >
                                                        <div className="comments-parent">
                                                            <h6 className="heading-text">
                                                                {t("Comments")} ({commentlist?.length})
                                                            </h6>
                                                            <div className="writecomment-field">
                                                                <div className="placeholder-icon ">
                                                                    <img
                                                                        src={
                                                                            userprofile?.profilePic ||
                                                                            "/assets/detailpage/placeholder.svg"
                                                                        }
                                                                        alt="img"
                                                                        className="img-fluid"
                                                                    />
                                                                </div>
                                                                <div className="option-textfield">
                                                                    <textarea
                                                                        value={comment}
                                                                        onChange={handleCommentChange}
                                                                        placeholder={t("What do you think?")}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="twice-btns">
                                                                <p>
                                                                    {comment.length}/300 {t("Characters")}
                                                                </p>
                                                                <a
                                                                    onClick={submitComment}
                                                                    className={`post-btn ${isSubmittingComment ? "disabled" : ""
                                                                        }`}
                                                                    style={{
                                                                        opacity: isSubmittingComment ? 0.6 : 1,
                                                                        cursor: isSubmittingComment
                                                                            ? "not-allowed"
                                                                            : "pointer",
                                                                    }}
                                                                >
                                                                    {isSubmittingComment ? t("Posting") : t("Post")}
                                                                </a>
                                                            </div>
                                                            {error && <p style={{ color: "red" }}>{error}</p>}
                                                        </div>
                                                        <div className="show-comments">
                                                            {commentlist?.map((item, index) => (
                                                                <div key={index} className="single-comment">
                                                                    <div className="new-inline-flex">
                                                                        <div className="user-img">
                                                                            <Link className="creator_link" to={`/user-profile?id=${item?.userId?._id}`}>

                                                                                <img
                                                                                    src={
                                                                                        item.userId.profilePic ||
                                                                                        "/assets/detailpage/placeholder.svg"
                                                                                    }
                                                                                    alt="img"
                                                                                    className="img-fluid"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="comment-info">
                                                                            <Link className="creator_link" to={`/user-profile?id=${item?.userId?._id}`}>
                                                                                <h6>
                                                                                    {item?.userId?.name !== ""
                                                                                        ? item?.userId?.name
                                                                                        : `${item?.userId?.displayName?.slice(
                                                                                            0,
                                                                                            5
                                                                                        )}...${item?.userId?.displayName?.slice(
                                                                                            -3
                                                                                        )}`}{" "}
                                                                                    <span>{formatTimeAgo(item.createdAt)}</span>
                                                                                </h6>
                                                                            </Link>
                                                                            <p>{item.comment}</p>
                                                                            <div className="inline-btns">
                                                                                <a
                                                                                    className="likes-btn"
                                                                                    onClick={() =>
                                                                                        handleLikeUnlike(
                                                                                            item?._id,
                                                                                            item.likes.some(
                                                                                                (like) => like.userId === userId
                                                                                            )
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    {item.likes &&
                                                                                        item.likes?.some(
                                                                                            (like) => like.userId === userId
                                                                                        ) ? (
                                                                                        <svg
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            width="20"
                                                                                            height="20"
                                                                                            viewBox="0 0 20 20"
                                                                                            fill="none"
                                                                                        >
                                                                                            <path
                                                                                                d="M18.2812 6.25938C18.1053 6.05994 17.8888 5.90023 17.6464 5.79086C17.4039 5.68148 17.141 5.62495 16.875 5.625H12.5V4.375C12.5 3.5462 12.1708 2.75134 11.5847 2.16529C10.9987 1.57924 10.2038 1.25 9.375 1.25C9.25889 1.24992 9.14505 1.28218 9.04625 1.34317C8.94744 1.40417 8.86758 1.49148 8.81562 1.59531L5.86406 7.5H2.5C2.16848 7.5 1.85054 7.6317 1.61612 7.86612C1.3817 8.10054 1.25 8.41848 1.25 8.75V15.625C1.25 15.9565 1.3817 16.2745 1.61612 16.5089C1.85054 16.7433 2.16848 16.875 2.5 16.875H15.9375C16.3943 16.8752 16.8354 16.7085 17.1781 16.4065C17.5208 16.1044 17.7413 15.6876 17.7984 15.2344L18.7359 7.73438C18.7692 7.47033 18.7458 7.20224 18.6674 6.94792C18.589 6.6936 18.4574 6.45888 18.2812 6.25938ZM2.5 8.75H5.625V15.625H2.5V8.75Z"
                                                                                                fill="#FE5C32"
                                                                                            />
                                                                                        </svg>
                                                                                    ) : (
                                                                                        <svg
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            width="20"
                                                                                            height="20"
                                                                                            viewBox="0 0 20 20"
                                                                                            fill="none"
                                                                                        >
                                                                                            <path
                                                                                                d="M18.2812 6.25938C18.1053 6.05994 17.8888 5.90023 17.6464 5.79086C17.4039 5.68148 17.141 5.62495 16.875 5.625H12.5V4.375C12.5 3.5462 12.1708 2.75134 11.5847 2.16529C10.9987 1.57924 10.2038 1.25 9.375 1.25C9.25889 1.24992 9.14505 1.28218 9.04625 1.34317C8.94744 1.40417 8.86758 1.49148 8.81562 1.59531L5.86406 7.5H2.5C2.16848 7.5 1.85054 7.6317 1.61612 7.86612C1.3817 8.10054 1.25 8.41848 1.25 8.75V15.625C1.25 15.9565 1.3817 16.2745 1.61612 16.5089C1.85054 16.7433 2.16848 16.875 2.5 16.875H15.9375C16.3943 16.8752 16.8354 16.7085 17.1781 16.4065C17.5208 16.1044 17.7413 15.6876 17.7984 15.2344L18.7359 7.73438C18.7692 7.47033 18.7458 7.20224 18.6674 6.94792C18.589 6.6936 18.4574 6.45888 18.2812 6.25938ZM2.5 8.75H5.625V15.625H2.5V8.75ZM17.4953 7.57812L16.5578 15.0781C16.5388 15.2292 16.4653 15.3681 16.351 15.4688C16.2368 15.5695 16.0898 15.6251 15.9375 15.625H6.875V8.27266L9.74297 2.53594C10.168 2.62101 10.5505 2.85075 10.8253 3.18605C11.1 3.52135 11.2501 3.9415 11.25 4.375V6.25C11.25 6.41576 11.3158 6.57473 11.4331 6.69194C11.5503 6.80915 11.7092 6.875 11.875 6.875H16.875C16.9637 6.87497 17.0514 6.89382 17.1322 6.93028C17.2131 6.96675 17.2852 7.02001 17.3439 7.08652C17.4026 7.15303 17.4464 7.23126 17.4725 7.31602C17.4986 7.40078 17.5064 7.49013 17.4953 7.57812Z"
                                                                                                fill="#7B7B7B"
                                                                                            />
                                                                                        </svg>
                                                                                    )}
                                                                                    {item.likes.length}
                                                                                </a>
                                                                                <a
                                                                                    className="reply-btn"
                                                                                    onClick={() => handleReplyClick(item._id)}
                                                                                >
                                                                                    <svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="20"
                                                                                        height="20"
                                                                                        viewBox="0 0 20 20"
                                                                                        fill="none"
                                                                                    >
                                                                                        <path
                                                                                            d="M18.125 15.625C18.125 15.7907 18.0592 15.9497 17.9419 16.0669C17.8247 16.1841 17.6658 16.25 17.5 16.25C17.3342 16.25 17.1753 16.1841 17.0581 16.0669C16.9408 15.9497 16.875 15.7907 16.875 15.625C16.8729 13.8023 16.1479 12.0548 14.8591 10.7659C13.5702 9.47704 11.8227 8.75205 10 8.74998H4.0086L6.69219 11.4328C6.80947 11.5501 6.87535 11.7091 6.87535 11.875C6.87535 12.0408 6.80947 12.1999 6.69219 12.3172C6.57492 12.4344 6.41586 12.5003 6.25 12.5003C6.08415 12.5003 5.92509 12.4344 5.80782 12.3172L2.05782 8.56717C1.99971 8.50912 1.95361 8.44019 1.92215 8.36432C1.8907 8.28845 1.87451 8.20712 1.87451 8.12498C1.87451 8.04285 1.8907 7.96152 1.92215 7.88564C1.95361 7.80977 1.99971 7.74084 2.05782 7.68279L5.80782 3.93279C5.92509 3.81552 6.08415 3.74963 6.25 3.74963C6.41586 3.74963 6.57492 3.81552 6.69219 3.93279C6.80947 4.05007 6.87535 4.20913 6.87535 4.37498C6.87535 4.54083 6.80947 4.69989 6.69219 4.81717L4.0086 7.49998H10C12.1542 7.50226 14.2195 8.35901 15.7427 9.88225C17.266 11.4055 18.1227 13.4708 18.125 15.625Z"
                                                                                            fill="#7B7B7B"
                                                                                        />
                                                                                    </svg>{" "}
                                                                                    {t("Reply")}
                                                                                </a>
                                                                            </div>
                                                                            {showReplyForm &&
                                                                                activeReplyId === item._id && (
                                                                                    <div className="reply-input-section mt-3">
                                                                                        <div className="writecomment-field">
                                                                                            <div className="placeholder-icon">
                                                                                                <img
                                                                                                    src="/assets/detailpage/placeholder.svg"
                                                                                                    alt="img"
                                                                                                    className="img-fluid"
                                                                                                />
                                                                                            </div>
                                                                                            <div className="option-textfield">
                                                                                                <textarea
                                                                                                    value={replyComment}
                                                                                                    onChange={handleReplyCommentChange}
                                                                                                    placeholder={t("Write a reply")}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="twice-btns">
                                                                                            <p>
                                                                                                {replyComment.length}/300{" "}
                                                                                                {t("Characters")}
                                                                                            </p>
                                                                                            <div>
                                                                                                <a
                                                                                                    onClick={() => {
                                                                                                        setShowReplyForm(false);
                                                                                                        setReplyComment("");
                                                                                                    }}
                                                                                                    className="cancel-btn me-2"
                                                                                                >
                                                                                                    {t("Cancel")}
                                                                                                </a>
                                                                                                <a
                                                                                                    onClick={submitComment}
                                                                                                    className="post-btn"
                                                                                                >
                                                                                                    {t("Reply")}
                                                                                                </a>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    </div>

                                                                    {item.replies && item.replies.length > 0 && (
                                                                        <div className="replies-section">
                                                                            {item?.replies?.map((reply, replyIndex) => (
                                                                                <div
                                                                                    key={reply._id}
                                                                                    className="single-comment child"
                                                                                >
                                                                                    <div className="user-img">
                                                                                        <Link className="creator_link" to={`/user-profile?id=${reply?.userId?._id}`}>

                                                                                            <img
                                                                                                src={reply.userId.profilePic}
                                                                                                alt="img"
                                                                                                className="img-fluid"
                                                                                            />
                                                                                        </Link>
                                                                                    </div>
                                                                                    <div className="comment-info">
                                                                                        <Link className="creator_link" to={`/user-profile?id=${reply?.userId?._id}`}>

                                                                                            <h6>
                                                                                                {reply?.userId?.name !== ""
                                                                                                    ? reply?.userId?.name
                                                                                                    : `${reply?.userId?.displayName?.slice(
                                                                                                        0,
                                                                                                        5
                                                                                                    )}...${reply?.userId?.displayName?.slice(
                                                                                                        -3
                                                                                                    )}`}{" "}
                                                                                                <span>
                                                                                                    {formatTimeAgo(reply.createdAt)}
                                                                                                </span>
                                                                                            </h6>
                                                                                        </Link>
                                                                                        <p>{reply.comment}</p>
                                                                                        <div className="inline-btns">
                                                                                            <a
                                                                                                className="likes-btn"
                                                                                                onClick={() =>
                                                                                                    handleLikeUnlike(
                                                                                                        reply._id,
                                                                                                        reply.likes.some(
                                                                                                            (like) => like.userId === userId
                                                                                                        )
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                {reply.likes &&
                                                                                                    reply.likes?.some(
                                                                                                        (like) => like.userId === userId
                                                                                                    ) ? (
                                                                                                    <svg
                                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                                        width="20"
                                                                                                        height="20"
                                                                                                        viewBox="0 0 20 20"
                                                                                                        fill="none"
                                                                                                    >
                                                                                                        <path
                                                                                                            d="M18.2812 6.25938C18.1053 6.05994 17.8888 5.90023 17.6464 5.79086C17.4039 5.68148 17.141 5.62495 16.875 5.625H12.5V4.375C12.5 3.5462 12.1708 2.75134 11.5847 2.16529C10.9987 1.57924 10.2038 1.25 9.375 1.25C9.25889 1.24992 9.14505 1.28218 9.04625 1.34317C8.94744 1.40417 8.86758 1.49148 8.81562 1.59531L5.86406 7.5H2.5C2.16848 7.5 1.85054 7.6317 1.61612 7.86612C1.3817 8.10054 1.25 8.41848 1.25 8.75V15.625C1.25 15.9565 1.3817 16.2745 1.61612 16.5089C1.85054 16.7433 2.16848 16.875 2.5 16.875H15.9375C16.3943 16.8752 16.8354 16.7085 17.1781 16.4065C17.5208 16.1044 17.7413 15.6876 17.7984 15.2344L18.7359 7.73438C18.7692 7.47033 18.7458 7.20224 18.6674 6.94792C18.589 6.6936 18.4574 6.45888 18.2812 6.25938ZM2.5 8.75H5.625V15.625H2.5V8.75Z"
                                                                                                            fill="#FE5C32"
                                                                                                        />
                                                                                                    </svg>
                                                                                                ) : (
                                                                                                    <svg
                                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                                        width="20"
                                                                                                        height="20"
                                                                                                        viewBox="0 0 20 20"
                                                                                                        fill="none"
                                                                                                    >
                                                                                                        <path
                                                                                                            d="M18.2812 6.25938C18.1053 6.05994 17.8888 5.90023 17.6464 5.79086C17.4039 5.68148 17.141 5.62495 16.875 5.625H12.5V4.375C12.5 3.5462 12.1708 2.75134 11.5847 2.16529C10.9987 1.57924 10.2038 1.25 9.375 1.25C9.25889 1.24992 9.14505 1.28218 9.04625 1.34317C8.94744 1.40417 8.86758 1.49148 8.81562 1.59531L5.86406 7.5H2.5C2.16848 7.5 1.85054 7.6317 1.61612 7.86612C1.3817 8.10054 1.25 8.41848 1.25 8.75V15.625C1.25 15.9565 1.3817 16.2745 1.61612 16.5089C1.85054 16.7433 2.16848 16.875 2.5 16.875H15.9375C16.3943 16.8752 16.8354 16.7085 17.1781 16.4065C17.5208 16.1044 17.7413 15.6876 17.7984 15.2344L18.7359 7.73438C18.7692 7.47033 18.7458 7.20224 18.6674 6.94792C18.589 6.6936 18.4574 6.45888 18.2812 6.25938ZM2.5 8.75H5.625V15.625H2.5V8.75ZM17.4953 7.57812L16.5578 15.0781C16.5388 15.2292 16.4653 15.3681 16.351 15.4688C16.2368 15.5695 16.0898 15.6251 15.9375 15.625H6.875V8.27266L9.74297 2.53594C10.168 2.62101 10.5505 2.85075 10.8253 3.18605C11.1 3.52135 11.2501 3.9415 11.25 4.375V6.25C11.25 6.41576 11.3158 6.57473 11.4331 6.69194C11.5503 6.80915 11.7092 6.875 11.875 6.875H16.875C16.9637 6.87497 17.0514 6.89382 17.1322 6.93028C17.2131 6.96675 17.2852 7.02001 17.3439 7.08652C17.4026 7.15303 17.4464 7.23126 17.4725 7.31602C17.4986 7.40078 17.5064 7.49013 17.4953 7.57812Z"
                                                                                                            fill="#7B7B7B"
                                                                                                        />
                                                                                                    </svg>
                                                                                                )}
                                                                                                {reply.likes.length}
                                                                                            </a>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="activity" title={t("Activity")}>
                                                        <ActivityTab
                                                            loadertable={loadertable}
                                                            poolactivity={poolactivity}
                                                            poolsdetail={poolsdetail}
                                                            tokenDecimals={tokenDecimals}
                                                            tokenToDisplay={tokenToDisplay}
                                                            currentPage={currentPage}
                                                            totalPages={totalPages}
                                                            handlePageChange={handlePageChange}
                                                            isMobile={isMobile}

                                                        />
                                                    </Tab>
                                                    <Tab
                                                        eventKey="holders"
                                                        title={`${t("Top Holders")}(${`${topholders?.total}`})`}
                                                    >
                                                        <TopHolders
                                                            loadertable={loadertable}
                                                            poolsdetail={poolsdetail}
                                                            setSelectedIndex={setSelectedIndex}
                                                            getTopHolders={getTopHolders}
                                                            selectedIndex={selectedIndex}
                                                            topholders={topholders}
                                                            tokenDecimals={tokenDecimals}
                                                            isMobile={isMobile}
                                                        />
                                                    </Tab>
                                                    <Tab eventKey="sellorders" title={t("Orders")}>
                                                        <div className="sellorders-data">
                                                            <Tabs
                                                                id="uncontrolled-tab-example"
                                                                className="orderlisttabs"
                                                            >
                                                                <Tab
                                                                    eventKey="open"
                                                                    title={`${t("Open Orders")} (${openOrders?.filter(
                                                                        (order) => order.user === userId
                                                                    )?.length || 0
                                                                        })`}
                                                                >
                                                                    {openOrders?.length > 1 && (
                                                                        <button
                                                                            onClick={handleCancelAll}
                                                                            className="btn-cancelall"
                                                                        >
                                                                            {t("Cancel All")}
                                                                        </button>
                                                                    )}
                                                                    <OpenOrderList
                                                                        userId={userId}
                                                                        CancelingPoolOrders={CancelingPoolOrders}
                                                                        openOrders={openOrders}
                                                                        tokenSymbol={tokenToDisplay}
                                                                    />
                                                                </Tab>
                                                                <Tab
                                                                    eventKey="orderHistory"
                                                                    title={`${t("Order History")} (${ordersHistory?.filter(
                                                                        (order) => order.user === userId
                                                                    )?.length || 0
                                                                        })`}
                                                                >
                                                                    <OrderHistory
                                                                        userId={userId}
                                                                        ordersHistory={ordersHistory}
                                                                        tokenSymbol={tokenToDisplay}
                                                                    />
                                                                </Tab>
                                                            </Tabs>
                                                        </div>
                                                    </Tab>
                                                </Tabs>
                                            </div>
                                        )}
                                        {!isMobile && !isPoolPrivate && <MarketRelated />}
                                    </div>
                                    <div className="right-side rightsidescrollsticky">
                                        {(isMobile ? true : true) && (
                                            <Social
                                                poolQuestion={poolQuestion}
                                                poolId={poolId}
                                                poolAccessCode={poolAccessCode}
                                                isPoolPrivate={isPoolPrivate}
                                                copyPoolLinks={copyPoolLinks}
                                                isCopied={isCopied}
                                                totalVolume={totalVolume}
                                                poolOptions={poolOptions}
                                                token={poolsdetail?.token}
                                                tokenLogo={tokenLogo}
                                                tokenAddress={tokenAddress}
                                                tokenName={tokenName}
                                                graph={graph}
                                                opensocialmodal={opensocialmodal}
                                                setOpenSocialModal={setOpenSocialModal}
                                                isMobile={isMobile}
                                                copyMarketShareLink={handleCopyClickLink}
                                                isCopiedLink={isCopiedLink}
                                            />
                                        )}
                                        {!isMobile && (
                                            <PoolFinalization
                                                t={t}
                                                poolsdetail={poolsdetail}
                                                winnerData={winnerData}
                                                isPoolPrivate={isPoolPrivate}
                                                handleShowReasoning={handleShowReasoning}
                                                publicPoolResolverText={publicPoolResolverText}
                                                poolDisputed={poolDisputed}
                                                isAppealed={isAppealed}
                                                smartAccount={smartAccount}
                                                handleShowCreateDispute={handleShowCreateDispute}
                                                revealWinnerUi={revealWinnerUi}
                                                revealWinner={revealWinner}
                                                timeExtendUi={timeExtendUi}
                                                poolUnderDisputeUi={poolUnderDisputeUi}
                                                publicPoolResolverAddress={publicPoolResolverAddress}
                                                disputeTimer={disputeTimer}
                                                setDisputeTimer={setDisputeTimer}
                                                extendDisputeTimer={extendDisputeTimer}
                                                ownermatch={ownermatch}
                                                handleShow14={handleShow14}
                                                isClaimWindowOpen={isClaimWindowOpen}
                                                claimNotDisputed={claimNotDisputed}
                                                decideWinnerTime={decideWinnerTime}
                                                claimEligibility={claimEligibility}
                                                setClaimNotDisputed={setClaimNotDisputed}
                                                userliquidity={userliquidity}
                                                percentageindiv={percentageindiv}
                                                web3={web3}
                                                pair={pair}
                                                price={price}
                                                swapbalance={swapbalance}
                                                poolDisputedWinner={poolDisputedWinner}
                                                claimcheck={claimcheck}
                                                claimvalue={claimvalue}
                                                sumOfClaimvalue={sumOfClaimvalue}
                                                getClaims={getClaims}
                                                poolPnl={poolPnl}
                                                theme={theme}
                                                isPublicPoolResolverAi={isPublicPoolResolverAi}
                                                disputeOrAppealText={disputeOrAppealText}
                                                decidedByText={decidedByText}
                                                setShowCreateDisputeOffCanvas={setShowCreateDisputeOffCanvas}
                                                setShowEvidence={setShowEvidence}
                                                setShowEvidenceHistory={setShowEvidenceHistory}
                                                investedAmount={initialposition}
                                                totalPayout={totalPayout}
                                                tokenData={poolsdetail?.token}
                                                setWinnerProposalMode={setWinnerProposalMode}
                                                reSubmitOrFinalizeSpinner={reSubmitOrFinalizeSpinner}
                                                showresubmit={showresubmit}
                                                setShowResubmit={setShowResubmit}
                                                oracleExtendedTimeNo={oracleExtendedTimeNo}
                                                gasEstimateInUsdt={gasEstimateInUsdt}
                                                gasFeesSpinner={gasFeesSpinner}
                                                getEstimatedTxGasFee={getEstimatedTxGasFee}
                                                setGasFeesSpiner={setGasFeesSpiner}
                                                setPoolStatus={setPoolStatus}
                                                openClaimModal={openClaimModal}
                                                hasTooEarlyHistory={hasTooEarlyHistory}
                                            />
                                        )}

                                        {!isMobile && (
                                            <>
                                                {(!poolsdetail?.winnerOption || !isClaimWindowOpen || claimNotDisputed || poolUnderDisputeUi) && (
                                                    <>
                                                        <div className="tab-style-parent">
                                                            <Tabs
                                                                defaultActiveKey="buy"
                                                                id="uncontrolled-tab-example"
                                                                className="orderbook-tabs"
                                                                activeKey={buyOrSellTabActive}
                                                                onSelect={(k) => setBuyOrSellTabActive(k)}
                                                            >
                                                                {/* tab of buy on web when pool is live */}
                                                                <Tab eventKey="buy" title={t("Buy")}>
                                                                    <div className="dropdown buylimit">
                                                                        <button
                                                                            className="dropdown-toggle"
                                                                            type="button"
                                                                            id="dropdownMenuButton1"
                                                                            data-bs-toggle="dropdown"
                                                                            aria-expanded="false"
                                                                        >
                                                                            {limittab === "marketbuy"
                                                                                ? t("Market")
                                                                                : t("Limit")}{" "}
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="18"
                                                                                height="18"
                                                                                viewBox="0 0 18 18"
                                                                                fill="none"
                                                                            >
                                                                                <path
                                                                                    d="M8.60172 15.5855L3.53922 10.523C3.43367 10.4174 3.37437 10.2743 3.37437 10.125C3.37437 9.97573 3.43367 9.83258 3.53922 9.72703C3.64477 9.62148 3.78792 9.56219 3.93719 9.56219C4.08645 9.56219 4.22961 9.62148 4.33516 9.72703L8.43719 13.8298L8.43719 2.8125C8.43719 2.66332 8.49645 2.52024 8.60194 2.41475C8.70743 2.30926 8.8505 2.25 8.99969 2.25C9.14887 2.25 9.29195 2.30926 9.39743 2.41475C9.50292 2.52024 9.56219 2.66332 9.56219 2.8125L9.56219 13.8298L13.6642 9.72703C13.7698 9.62148 13.9129 9.56219 14.0622 9.56219C14.2115 9.56219 14.3546 9.62148 14.4602 9.72703C14.5657 9.83258 14.625 9.97573 14.625 10.125C14.625 10.2743 14.5657 10.4174 14.4602 10.523L9.39766 15.5855C9.34541 15.6378 9.28338 15.6793 9.21509 15.7076C9.1468 15.7359 9.07361 15.7504 8.99969 15.7504C8.92577 15.7504 8.85257 15.7359 8.78428 15.7076C8.716 15.6793 8.65396 15.6378 8.60172 15.5855Z"
                                                                                    fill="#DAD9D9"
                                                                                />
                                                                            </svg>
                                                                        </button>

                                                                        <ul
                                                                            className="dropdown-menu"
                                                                            aria-labelledby="dropdownMenuButton1"
                                                                        >
                                                                            <li>
                                                                                <a
                                                                                    className={`dropdown-item ${limittab === "marketbuy" ? "active" : ""
                                                                                        }`}
                                                                                    onClick={() => setlimittab("marketbuy")}
                                                                                >
                                                                                    {t("Market")}
                                                                                </a>
                                                                            </li>
                                                                            <li>
                                                                                <a
                                                                                    className={`dropdown-item ${limittab === "limitbuy" ? "active" : ""
                                                                                        }`}
                                                                                    onClick={() => setlimittab("limitbuy")}
                                                                                >
                                                                                    {t("Limit")}
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div className="right-side-tabs">
                                                                        {!poolStartCheck && (
                                                                            <div
                                                                                className="disabled-message mt-2 poolnotstartinfo"
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: "50%",
                                                                                    left: "50%",
                                                                                    transform: "translate(-50%, -50%)",
                                                                                    textAlign: "center",
                                                                                    fontSize: "28px",
                                                                                    color: "var(--heading-text)",
                                                                                    zIndex: 10,
                                                                                }}
                                                                            >
                                                                                <p>{t("Trading")}</p>
                                                                                <PoolTimerUI
                                                                                    poolstart={poolstart}
                                                                                    poolend={poolend}
                                                                                    poolsdetail={poolsdetail}
                                                                                    setPollStatus={setPollStatus}
                                                                                    setIsDisabled={setIsDisabled}
                                                                                />
                                                                            </div>
                                                                        )}

                                                                        <div
                                                                            className={`tab-parent ${!poolStartCheck ? "disabled-section" : ""
                                                                                }`}
                                                                        >
                                                                            <div className="dropdown chooseprediction-dropdown">
                                                                                <button
                                                                                    className="dropdown-toggle"
                                                                                    type="button"
                                                                                    id="dropdownMenuButton1"
                                                                                    data-bs-toggle="dropdown"
                                                                                    aria-expanded="false"
                                                                                >
                                                                                    {!selectedOption ? (
                                                                                        <span>{t("Choose a prediction")}</span>
                                                                                    ) : (
                                                                                        <div className="when-select">
                                                                                            <div className="text">
                                                                                                <span
                                                                                                    style={{
                                                                                                        backgroundColor: selectedColor,
                                                                                                    }}
                                                                                                ></span>
                                                                                                <h6>{selectedOption.optionName}</h6>
                                                                                            </div>
                                                                                            <div className="myshares-div">
                                                                                                <div className="common-flex">
                                                                                                    <p>My Shares</p>
                                                                                                    <h5>
                                                                                                        {smartAccount
                                                                                                            ? handleToFixedOnDecimals(
                                                                                                                selectedOptionBalancebuy
                                                                                                            )
                                                                                                            : 0}
                                                                                                    </h5>
                                                                                                </div>
                                                                                                <span className="divider-line">|</span>
                                                                                                <div className="common-flex">
                                                                                                    <p>{TitleCaseConversion(tokenToDisplay)} Invested:</p>
                                                                                                    <h5>
                                                                                                        {getTokenSymbol(tokenSymbol)}
                                                                                                        {smartAccount
                                                                                                            ? formatNumbers(+selectedswapconversionbuy) ||
                                                                                                            "0"
                                                                                                            : 0}
                                                                                                    </h5>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                    <svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="19"
                                                                                        height="18"
                                                                                        viewBox="0 0 19 18"
                                                                                        fill="none"
                                                                                    >
                                                                                        <path
                                                                                            d="M9.10172 15.5855L4.03922 10.523C3.93367 10.4174 3.87437 10.2743 3.87437 10.125C3.87437 9.97573 3.93367 9.83258 4.03922 9.72703C4.14477 9.62148 4.28792 9.56219 4.43719 9.56219C4.58645 9.56219 4.72961 9.62148 4.83516 9.72703L8.93719 13.8298L8.93719 2.8125C8.93719 2.66332 8.99645 2.52024 9.10194 2.41475C9.20743 2.30926 9.3505 2.25 9.49969 2.25C9.64887 2.25 9.79195 2.30926 9.89743 2.41475C10.0029 2.52024 10.0622 2.66332 10.0622 2.8125L10.0622 13.8298L14.1642 9.72703C14.2698 9.62148 14.4129 9.56219 14.5622 9.56219C14.7115 9.56219 14.8546 9.62148 14.9602 9.72703C15.0657 9.83258 15.125 9.97573 15.125 10.125C15.125 10.2743 15.0657 10.4174 14.9602 10.523L9.89766 15.5855C9.84541 15.6378 9.78338 15.6793 9.71509 15.7076C9.6468 15.7359 9.57361 15.7504 9.49969 15.7504C9.42577 15.7504 9.35257 15.7359 9.28428 15.7076C9.216 15.6793 9.15396 15.6378 9.10172 15.5855Z"
                                                                                            fill="#DAD9D9"
                                                                                        />
                                                                                    </svg>
                                                                                </button>

                                                                                <ul
                                                                                    className="dropdown-menu"
                                                                                    aria-labelledby="dropdownMenuButton1"
                                                                                >
                                                                                    {poolsdetail?.options?.map(
                                                                                        (option, index) => {
                                                                                            const totalSupplyLP =
                                                                                                percentageindiv &&
                                                                                                    percentageindiv[index]
                                                                                                    ? parseFloat(percentageindiv[index])
                                                                                                    : 0;
                                                                                            const background = getBackgroundColor(
                                                                                                index,
                                                                                                theme,
                                                                                                poolsdetail?.options?.length
                                                                                            );
                                                                                            const {
                                                                                                availableBuyingShares,
                                                                                                PriceConversion,
                                                                                            } = buyingOptionValues[index] || {
                                                                                                availableBuyingShares: "0",
                                                                                                PriceConversion: 0,
                                                                                            };

                                                                                            return (
                                                                                                <li key={option._id}>
                                                                                                    <a
                                                                                                        className={`dropdown-item ${selectedOption?.choiceIndex ===
                                                                                                            option.choiceIndex
                                                                                                            ? "active"
                                                                                                            : ""
                                                                                                            }`}
                                                                                                        onClick={() =>
                                                                                                            handleSelectOption(
                                                                                                                option,
                                                                                                                index,
                                                                                                                background,
                                                                                                                totalSupplyLP,
                                                                                                                PriceConversion
                                                                                                            )
                                                                                                        }
                                                                                                        style={{ cursor: "pointer" }}
                                                                                                    >
                                                                                                        <div className="text">
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    backgroundColor: background,
                                                                                                                }}
                                                                                                            ></span>
                                                                                                            <h6>{option.optionName}</h6>
                                                                                                        </div>
                                                                                                        <div className="myshares-div">
                                                                                                            <div className="common-flex">
                                                                                                                <p>My Shares</p>
                                                                                                                <h5>
                                                                                                                    {" "}
                                                                                                                    {formatNumbers(+availableBuyingShares)}
                                                                                                                </h5>
                                                                                                            </div>
                                                                                                            <div className="common-flex">
                                                                                                                <p>{TitleCaseConversion(tokenToDisplay)} Invested:</p>
                                                                                                                <h5>
                                                                                                                    {getTokenSymbol(tokenSymbol)}
                                                                                                                    {smartAccount
                                                                                                                        ? formatNumbers(+PriceConversion)
                                                                                                                        : 0}
                                                                                                                </h5>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </a>
                                                                                                </li>
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                                </ul>
                                                                            </div>

                                                                            <div className="option-parent set-custom-colorhere">
                                                                                {limittab === "marketbuy" ? (
                                                                                    <>
                                                                                        <div className="option-field">
                                                                                            <div className="inside-left">
                                                                                                <p>{t("Amount")}</p>
                                                                                                <input
                                                                                                    id="input-trade-amount"
                                                                                                    value={buy}
                                                                                                    onChange={(e) =>
                                                                                                        setBuy(e.target.value)
                                                                                                    }
                                                                                                    type="number"
                                                                                                    placeholder="0.00"
                                                                                                />
                                                                                                <p>
                                                                                                    <span>{t("Balance")}:</span> {" "}
                                                                                                    {handleToFixedOnDecimals(
                                                                                                        marketTokenBalance
                                                                                                    )} {tokenToDisplay} {!marketToken.isStable && (<span>${formatSmartDecimal(tokenPriceToUsdt * smartAccountRainBalance)}</span>)}
                                                                                                </p>
                                                                                            </div>
                                                                                            <div className="inside-right" >
                                                                                                <div className="dropdown">
                                                                                                    <button
                                                                                                        className="dropdown-toggle"
                                                                                                        type="button"
                                                                                                        aria-expanded="false"
                                                                                                        style={{ cursor: "default" }}
                                                                                                    >
                                                                                                        <img
                                                                                                            width={22}
                                                                                                            height={22}
                                                                                                            src={marketToken.icon}
                                                                                                            alt="img"
                                                                                                            className="img-fluid"
                                                                                                        />{" "}
                                                                                                        {marketToken.label}
                                                                                                    </button>
                                                                                                    <ul className="dropdown-menu">
                                                                                                        {tokens?.map((token) => (
                                                                                                            <a
                                                                                                                className={`dropdown-item ${selectedToken?.id ===
                                                                                                                    token.id
                                                                                                                    ? "activeitem"
                                                                                                                    : ""
                                                                                                                    }`}
                                                                                                                key={token.id}
                                                                                                                onClick={() =>
                                                                                                                    handleSelecttoken(token)
                                                                                                                }
                                                                                                            >
                                                                                                                {token.name}
                                                                                                            </a>
                                                                                                        ))}
                                                                                                    </ul>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="twice-btns-new">
                                                                                            <p>{t(`Estimated ${NETWORK_FEES}`)}</p>
                                                                                            <h6 style={{ color: "#6D6D6D" }}>
                                                                                                {gasFeesSpinner ? (
                                                                                                    <span className="spinner m-0" />
                                                                                                ) : (
                                                                                                    <>
                                                                                                        $
                                                                                                        {handleToFixedOnDecimals(gasEstimateInUsdt)}
                                                                                                    </>
                                                                                                )}

                                                                                            </h6>
                                                                                        </div>
                                                                                        <div className="twice-btns-new">
                                                                                            <p>{t("Min Shares You Receive")}</p>
                                                                                            <h6>
                                                                                                {selectedOption
                                                                                                    ? handleToFixedOnDecimals(
                                                                                                        shareWeReceive
                                                                                                    )
                                                                                                    : "0"}
                                                                                            </h6>
                                                                                        </div>

                                                                                        <div className="twice-btns-new">
                                                                                            <p>{t("Dynamic Payout")}</p>
                                                                                            <div className="multi-text">
                                                                                                <h6 style={{ textAlign: "end", color: "var(--green-text)" }}>
                                                                                                    {selectedOption
                                                                                                        ? handleToFixedOnDecimals(
                                                                                                            finalDynamicpay
                                                                                                        )
                                                                                                        : "0"}{" "} {tokenToDisplay}
                                                                                                </h6>
                                                                                                {
                                                                                                    !marketToken.isStable && (
                                                                                                        <h5 style={{ color: "var(--green-text)" }}>${formatSmartDecimal(finalDynamicpay * tokenPriceToUsdt)}</h5>
                                                                                                    )
                                                                                                }

                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <div className="option-field mb-0">
                                                                                            <div className="inside-left">
                                                                                                <p>{t("Price per share")}</p>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    placeholder="0.00"
                                                                                                    onChange={(e) => handlePriceChange(e.target.value)}
                                                                                                    value={pricePerShare}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                        <p className="para mb-3">
                                                                                            {t(
                                                                                                "Price should be between 0.01 - 0.99"
                                                                                            )}
                                                                                        </p>

                                                                                        <div className={`option-field${orderValueError ? ' error-border' : ''}`}>
                                                                                            <div className="inside-left">
                                                                                                <p>{t("Amount to buy")}</p>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    placeholder="0.00"
                                                                                                    onChange={(e) =>
                                                                                                        setSharesAmount(e.target.value)
                                                                                                    }
                                                                                                    value={sharesAmount}
                                                                                                />
                                                                                                <p>
                                                                                                    {t("Balance")}: {getTokenSymbol(tokenSymbol)}
                                                                                                    {handleToFixedOnDecimals(
                                                                                                        marketTokenBalance
                                                                                                    )}
                                                                                                </p>
                                                                                            </div>
                                                                                            <div className="inside-right">
                                                                                                <div className="dropdown">
                                                                                                    <button
                                                                                                        className="dropdown-toggle"
                                                                                                        type="button"
                                                                                                        aria-expanded="false"
                                                                                                        disabled={isDisabled}
                                                                                                    >
                                                                                                        <img
                                                                                                            width={22}
                                                                                                            height={22}
                                                                                                            src={marketToken.icon}
                                                                                                            alt="img"
                                                                                                            className="img-fluid"
                                                                                                        />{" "}
                                                                                                        {marketToken.label}

                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        {orderValueError && <p className="warn-text">{orderValueError}</p>}
                                                                                        {/* <div className="option-field">
                                                                                    <div className="inside-left">
                                                                                        <p>{t("Estimated Shares")}</p>
                                                                                        <input
                                                                                            disabled
                                                                                            type="number"
                                                                                            placeholder="0.00"
                                                                                            value={handleToFixedOnDecimals(
                                                                                                totalLimitBuying
                                                                                            )}
                                                                                            onChange={(e) =>
                                                                                                setTotalLimitBuying(
                                                                                                    e.target.value
                                                                                                )
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                </div> */}
                                                                                        <div className="twice-btns-new">
                                                                                            <p style={{ textTransform: "capitalize" }}>{`Estimated ${NETWORK_FEES}`}</p>
                                                                                            <h6 style={{ color: "#6D6D6D" }}> {gasFeesSpinner ? (
                                                                                                <span
                                                                                                    className="spinner m-0"
                                                                                                    style={{
                                                                                                        width: "12px",
                                                                                                        height: "12px",
                                                                                                    }}
                                                                                                />
                                                                                            ) : (
                                                                                                `$${handleToFixedOnDecimals(
                                                                                                    gasEstimateInUsdt
                                                                                                )}`
                                                                                            )}</h6>
                                                                                        </div>
                                                                                        <div className="twice-btns-new">
                                                                                            <p>Estimated Shares</p>
                                                                                            <h6>{handleToFixedOnDecimals(
                                                                                                totalLimitBuying
                                                                                            )}</h6>
                                                                                        </div>
                                                                                        {/* <p
                                                                                    className="para mb-3"
                                                                                    style={{
                                                                                        minHeight: "40px",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        gap: "5px",
                                                                                    }}
                                                                                >
                                                                                    {`Estimated ${NETWORK_FEES}`}{" "}
                                                                                    {gasFeesSpinner ? (
                                                                                        <span
                                                                                            className="spinner m-0"
                                                                                            style={{
                                                                                                width: "12px",
                                                                                                height: "12px",
                                                                                            }}
                                                                                        />
                                                                                    ) : (
                                                                                        `$${handleToFixedOnDecimals(
                                                                                            gasEstimateInUsdt
                                                                                        )}`
                                                                                    )}
                                                                                </p> */}
                                                                                    </>
                                                                                )}

                                                                                <div
                                                                                    onClick={() =>
                                                                                        gasFeesSpinner
                                                                                            ? null
                                                                                            : getSignOfBuy(limittab)
                                                                                    }
                                                                                >
                                                                                    <a
                                                                                        id="btn-place-trade"
                                                                                        className="btn-trade"
                                                                                        style={{
                                                                                            opacity: gasFeesSpinner ? 0.5 : 1,
                                                                                            pointerEvents: gasFeesSpinner
                                                                                                ? "none"
                                                                                                : "auto",
                                                                                            cursor: gasFeesSpinner
                                                                                                ? "not-allowed"
                                                                                                : "pointer",
                                                                                        }}
                                                                                    >
                                                                                        {t("Place trade")}
                                                                                    </a>
                                                                                </div>
                                                                                {canShowProposeResolutionButton && !isMobile && (
                                                                                    <div className="propose-resolution-btn">
                                                                                        <button onClick={handleProposeResolution}>
                                                                                            {t("Close the market")}
                                                                                        </button>
                                                                                        {
                                                                                            hasTooEarlyHistory ? <p className="bottom-para review-link-styling mt-2">
                                                                                                <a onClick={() => { setShowEvidence(true); setShowEvidenceHistory(true); }}>View Proposed Resolutions History</a>
                                                                                            </p> : hasEvidenHistory ? <p className="bottom-para review-link-styling mt-2">
                                                                                                Review full resolution history.{' '}
                                                                                                <a onClick={() => { setShowEvidence(true); setShowEvidenceHistory(true); }}>View History</a>
                                                                                            </p> : ""
                                                                                        }

                                                                                        {
                                                                                            hasTooEarlyHistory && (
                                                                                                <div className="too-early-case-box">
                                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                                                                        <g clip-path="url(#clip0_3917_4189)">
                                                                                                            <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke="#797979" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                            <path d="M9 12V9" stroke="#797979" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                            <path d="M9 6H9.0075" stroke="#797979" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                        </g>
                                                                                                        <defs>
                                                                                                            <clipPath id="clip0_3917_4189">
                                                                                                                <rect width="18" height="18" fill="white" />
                                                                                                            </clipPath>
                                                                                                        </defs>
                                                                                                    </svg>
                                                                                                    <p>The last resolution attempt was submitted too early. The market remains open and available for resolution.</p>
                                                                                                </div>
                                                                                            )
                                                                                        }
                                                                                    </div>

                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Tab>
                                                                {/* tab of sell on web when pool is live */}
                                                                <Tab
                                                                    eventKey={allSharesZero ? "disable" : SELL}
                                                                    title={t("Sell")}
                                                                    disabled={allSharesZero}
                                                                >
                                                                    <div className="right-side-tabs">
                                                                        {!poolStartCheck && (
                                                                            <div
                                                                                className="disabled-message mt-2 poolnotstartinfo"
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: "50%",
                                                                                    left: "50%",
                                                                                    transform: "translate(-50%, -50%)",
                                                                                    textAlign: "center",
                                                                                    color: "var(--heading-text)",
                                                                                    zIndex: 10,
                                                                                }}
                                                                            >
                                                                                <p>{t("Trading")}</p>
                                                                                <PoolTimerUI
                                                                                    poolstart={poolstart}
                                                                                    poolend={poolend}
                                                                                    poolsdetail={poolsdetail}
                                                                                    setPollStatus={setPollStatus}
                                                                                    setIsDisabled={setIsDisabled}
                                                                                />
                                                                            </div>
                                                                        )}

                                                                        <div
                                                                            className={`tab-parent ${!poolStartCheck ? "disabled-section" : ""
                                                                                }`}
                                                                        >
                                                                            <div className="dropdown chooseprediction-dropdown">
                                                                                <button
                                                                                    className="dropdown-toggle"
                                                                                    type="button"
                                                                                    id="sellDropdown"
                                                                                    data-bs-toggle="dropdown"
                                                                                    aria-expanded="false"
                                                                                >
                                                                                    {!selectedOptionSelling ? (
                                                                                        <span>{t("Choose a prediction")}</span>
                                                                                    ) : (
                                                                                        <div className="when-select">
                                                                                            <div className="text">
                                                                                                <span
                                                                                                    style={{
                                                                                                        backgroundColor: selectedColor,
                                                                                                    }}
                                                                                                ></span>
                                                                                                <h6>
                                                                                                    {selectedOptionSelling?.optionName}
                                                                                                </h6>
                                                                                            </div>
                                                                                            {selectedOptionSelling && (
                                                                                                <div className="myshares-div">
                                                                                                    <div className="common-flex">
                                                                                                        <p>My Shares</p>
                                                                                                        <h5>
                                                                                                            {smartAccount
                                                                                                                ? handleToFixedOnDecimals(
                                                                                                                    selectedOptionBalancesell
                                                                                                                )
                                                                                                                : 0}
                                                                                                        </h5>
                                                                                                    </div>
                                                                                                    <span className="divider-line">|</span>
                                                                                                    <div className="common-flex">
                                                                                                        <p>{TitleCaseConversion(tokenToDisplay)} Invested:</p>
                                                                                                        <h5>
                                                                                                            {getTokenSymbol(tokenSymbol)}
                                                                                                            {smartAccount
                                                                                                                ? selectedConversionDollarSell ||
                                                                                                                "0"
                                                                                                                : 0}
                                                                                                        </h5>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    )}
                                                                                    <svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="19"
                                                                                        height="18"
                                                                                        viewBox="0 0 19 18"
                                                                                        fill="none"
                                                                                    >
                                                                                        <path
                                                                                            d="M9.10172 15.5855L4.03922 10.523C3.93367 10.4174 3.87437 10.2743 3.87437 10.125C3.87437 9.97573 3.93367 9.83258 4.03922 9.72703C4.14477 9.62148 4.28792 9.56219 4.43719 9.56219C4.58645 9.56219 4.72961 9.62148 4.83516 9.72703L8.93719 13.8298L8.93719 2.8125C8.93719 2.66332 8.99645 2.52024 9.10194 2.41475C9.20743 2.30926 9.3505 2.25 9.49969 2.25C9.64887 2.25 9.79195 2.30926 9.89743 2.41475C10.0029 2.52024 10.0622 2.66332 10.0622 2.8125L10.0622 13.8298L14.1642 9.72703C14.2698 9.62148 14.4129 9.56219 14.5622 9.56219C14.7115 9.56219 14.8546 9.62148 14.9602 9.72703C15.0657 9.83258 15.125 9.97573 15.125 10.125C15.125 10.2743 15.0657 10.4174 14.9602 10.523L9.89766 15.5855C9.84541 15.6378 9.78338 15.6793 9.71509 15.7076C9.6468 15.7359 9.57361 15.7504 9.49969 15.7504C9.42577 15.7504 9.35257 15.7359 9.28428 15.7076C9.216 15.6793 9.15396 15.6378 9.10172 15.5855Z"
                                                                                            fill="#DAD9D9"
                                                                                        />
                                                                                    </svg>
                                                                                </button>

                                                                                <ul
                                                                                    className="dropdown-menu"
                                                                                    aria-labelledby="sellDropdown"
                                                                                >
                                                                                    {poolsdetail?.options?.map(
                                                                                        (option, index) => {
                                                                                            const totalSupplyLP =
                                                                                                percentageindiv &&
                                                                                                    percentageindiv[index]
                                                                                                    ? parseFloat(percentageindiv[index])
                                                                                                    : 0;
                                                                                            const priceoptionFixed = isNaN(
                                                                                                handleToFixedOnDecimals(
                                                                                                    priceoption[option?._id]
                                                                                                )
                                                                                            )
                                                                                                ? 0
                                                                                                : handleToFixedOnDecimals(
                                                                                                    priceoption[option?._id]
                                                                                                );
                                                                                            const background = getBackgroundColor(
                                                                                                index,
                                                                                                theme,
                                                                                                poolsdetail?.options?.length
                                                                                            );
                                                                                            const updatedSharesNumber = Number(
                                                                                                updatedShares[index]
                                                                                            );
                                                                                            const PriceConversion = isNaN(
                                                                                                updatedSharesNumber * priceoptionFixed
                                                                                            )
                                                                                                ? 0
                                                                                                : handleToFixedOnDecimals(
                                                                                                    updatedSharesNumber *
                                                                                                    priceoptionFixed
                                                                                                );
                                                                                            const isSelectable =
                                                                                                updatedSharesNumber > 0;
                                                                                            return (
                                                                                                <li key={option._id}>
                                                                                                    <a
                                                                                                        href="#"
                                                                                                        className={`dropdown-item ${selectedOptionSelling?.choiceIndex ===
                                                                                                            option.choiceIndex
                                                                                                            ? "active"
                                                                                                            : ""
                                                                                                            }`}
                                                                                                        onClick={(e) => {
                                                                                                            e.preventDefault();
                                                                                                            if (isSelectable) {
                                                                                                                handleSelectOptionSelling(
                                                                                                                    option,
                                                                                                                    index,
                                                                                                                    background,
                                                                                                                    totalSupplyLP,
                                                                                                                    PriceConversion,
                                                                                                                    updatedSharesNumber
                                                                                                                );
                                                                                                            }
                                                                                                        }}
                                                                                                        style={{
                                                                                                            cursor: isSelectable
                                                                                                                ? "pointer"
                                                                                                                : "not-allowed",
                                                                                                        }}
                                                                                                    >
                                                                                                        <div className="text">
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    backgroundColor: background,
                                                                                                                }}
                                                                                                            ></span>
                                                                                                            <h6>{option.optionName}</h6>
                                                                                                        </div>
                                                                                                        <div className="myshares-div">
                                                                                                            <div className="common-flex">
                                                                                                                <p>My Shares</p>
                                                                                                                <h5>
                                                                                                                    {smartAccount
                                                                                                                        ? handleToFixedOnDecimals(
                                                                                                                            updatedSharesNumber
                                                                                                                        )
                                                                                                                        : "0"}
                                                                                                                </h5>
                                                                                                            </div>
                                                                                                            <div className="common-flex">
                                                                                                                <p>{TitleCaseConversion(tokenToDisplay)} Invested:</p>
                                                                                                                <h5>
                                                                                                                    {getTokenSymbol(tokenSymbol)}
                                                                                                                    {smartAccount
                                                                                                                        ? PriceConversion
                                                                                                                        : 0}
                                                                                                                </h5>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </a>
                                                                                                </li>
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                                </ul>
                                                                            </div>
                                                                            <div className="option-parent set-custom-colorhere">
                                                                                <div className={`option-field${orderValueError ? ' error-border' : ''}`}>
                                                                                    <div className="inside-left">
                                                                                        <p>{t("Amount of shares")}</p>
                                                                                        <input
                                                                                            value={sharesAmount}
                                                                                            onChange={(e) =>
                                                                                                setSharesAmount(e.target.value)
                                                                                            }
                                                                                            type="number"
                                                                                            placeholder="0.00"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                {orderValueError && <p className="warn-text">{orderValueError}</p>}
                                                                                <div className="option-field">
                                                                                    <div className="inside-left">
                                                                                        <p>{t("Price per share")}</p>
                                                                                        <input
                                                                                            value={pricePerShare}
                                                                                            onChange={(e) => handlePriceChange(e.target.value)}
                                                                                            type="number"
                                                                                            placeholder="0.00"
                                                                                        />
                                                                                    </div>
                                                                                    <div className="inside-right">
                                                                                        <div className="dropdown">
                                                                                            <button
                                                                                                className="dropdown-toggle"
                                                                                                type="button"
                                                                                                aria-expanded="false"
                                                                                            >
                                                                                                <img
                                                                                                    width={22}
                                                                                                    height={22}
                                                                                                    src={marketToken.icon}
                                                                                                    alt="img"
                                                                                                    className="img-fluid"
                                                                                                />{" "}
                                                                                                {marketToken.label}
                                                                                            </button>
                                                                                            <ul className="dropdown-menu">
                                                                                                {tokens?.map((token) => (
                                                                                                    <a
                                                                                                        className={`dropdown-item ${selectedToken?.id === token.id
                                                                                                            ? "activeitem"
                                                                                                            : ""
                                                                                                            }`}
                                                                                                        key={token.id}
                                                                                                        onClick={() =>
                                                                                                            handleSelecttoken(token)
                                                                                                        }
                                                                                                    >
                                                                                                        {token.name}
                                                                                                    </a>
                                                                                                ))}
                                                                                            </ul>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <p className="para">
                                                                                    {t("Price should be between 0.01 - 0.99")}
                                                                                </p>
                                                                                <div className="twice-btns-new">
                                                                                    <p style={{ textTransform: "capitalize" }}>{`Estimated ${NETWORK_FEES}`}</p>
                                                                                    <h6>{gasFeesSpinner ? (
                                                                                        <span
                                                                                            className="spinner m-0"
                                                                                            style={{
                                                                                                width: "12px",
                                                                                                height: "12px",
                                                                                            }}
                                                                                        />
                                                                                    ) : (
                                                                                        `$${handleToFixedOnDecimals(
                                                                                            gasEstimateInUsdt
                                                                                        )}`
                                                                                    )}</h6>
                                                                                </div>
                                                                                <div className="twice-btns-new">
                                                                                    <p>Estimated {TitleCaseConversion(tokenToDisplay)}</p>
                                                                                    <h6>{handleToFixedOnDecimals(
                                                                                        totalLimitBuying
                                                                                    )}</h6>
                                                                                </div>
                                                                                <div onClick={() => handlePlaceSellOrder()}>
                                                                                    <a
                                                                                        id="btn-place-trade"
                                                                                        className="btn-trade"
                                                                                        style={{
                                                                                            opacity: gasFeesSpinner ? 0.5 : 1,
                                                                                            pointerEvents: gasFeesSpinner
                                                                                                ? "none"
                                                                                                : "auto",
                                                                                            cursor: gasFeesSpinner
                                                                                                ? "not-allowed"
                                                                                                : "pointer",
                                                                                        }}
                                                                                    >
                                                                                        {t("Place trade")}
                                                                                    </a>
                                                                                </div>
                                                                                {canShowProposeResolutionButton && !isMobile && (
                                                                                    <div className="propose-resolution-btn">
                                                                                        <button onClick={handleProposeResolution}>
                                                                                            {t("Close the market")}
                                                                                        </button>
                                                                                        {hasEvidenHistory && (
                                                                                            <p className="bottom-para review-link-styling">
                                                                                                Review full resolution history.{' '}
                                                                                                <a onClick={() => { setShowEvidence(true); setShowEvidenceHistory(true); }}>View History</a>
                                                                                            </p>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Tab>
                                                            </Tabs>
                                                        </div>
                                                    </>
                                                )}


                                            </>
                                        )}
                                        {(isMobile ? mobiletabs === 0 : true) && (
                                            <>
                                                <MyPosition
                                                    buyingOptionValues={buyingOptionValues}
                                                    investedAmount={initialposition}
                                                    theme={theme}
                                                    tokenToDisplay={tokenToDisplay}
                                                    tokenSymbol={tokenSymbol}
                                                    tokenPriceToUsdt={tokenPriceToUsdt}
                                                    winnerOptionId={poolsdetail?.winnerOption?.optionId}
                                                    isClaimWindowOpen={isClaimWindowOpen}
                                                    claimNotDisputed={claimNotDisputed}
                                                    winnerData={winnerData}
                                                />
                                            </>
                                        )}
                                        {(isMobile ? mobiletabs === 0 : true) && (
                                            <>
                                                <OrderBook
                                                    setOrderBookData={setOrderBookData}
                                                    handleOrderFilled={handleOrderFilled}
                                                    priceoption={priceoption}
                                                    poolsdetail={poolsdetail}
                                                    tokenToDisplay={tokenToDisplay}
                                                />
                                            </>
                                        )}

                                        {(isMobile ? mobiletabs === 0 : true) &&
                                            (!poolsdetail?.winnerOption && !poolsdetail?.poolFinalized ? (
                                                <div
                                                    className={`right-side ${isDisabled ? "liquidity-disabled-section" : ""
                                                        }`}
                                                >
                                                    <div className="liquidity-side">
                                                        <Accordion className="myposition-box mt-0">
                                                            <Accordion.Item eventKey="0">
                                                                <Accordion.Header>{t("Liquidity")}</Accordion.Header>
                                                                <Accordion.Body>
                                                                    <p className="para">Liquidity providers receive <span>1.2%</span> of the trading volume.</p>
                                                                    {smartAccount && userliquidity !== "0" && (
                                                                        <div className="mid-content">
                                                                            <p>{t("My Liquidity  Position")}</p>
                                                                            <div className="twice-text">
                                                                                <h6>{formatNumbers(+userliquidity)} {tokenToDisplay}</h6>
                                                                                {
                                                                                    !marketToken.isStable && (
                                                                                        <h5>${formatSmartDecimal(userliquidity * tokenPriceToUsdt)}</h5>
                                                                                    )
                                                                                }

                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    <div onClick={isDisabled ? null : () => smartAccount ? CheckPoolTime() : openWalletConnect()}>
                                                                        <a
                                                                            id="btn-add-liquidity"
                                                                            className="btn-liquidity"
                                                                            style={{
                                                                                opacity: isDisabled ? 0.5 : 1,
                                                                                pointerEvents: isDisabled ? "none" : "auto",
                                                                                cursor: isDisabled
                                                                                    ? "not-allowed"
                                                                                    : "pointer",
                                                                            }}
                                                                        >
                                                                            {t("Add Liquidity")}
                                                                            {
                                                                                isMobile ? <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                                                    <path d="M3.75 9H14.25" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    <path d="M9 3.75V14.25" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                </svg> : <svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width="18"
                                                                                    height="18"
                                                                                    viewBox="0 0 18 18"
                                                                                    fill="none"
                                                                                >
                                                                                    <path
                                                                                        d="M15.5855 9.39804L10.523 14.4605C10.4174 14.5661 10.2743 14.6254 10.125 14.6254C9.97573 14.6254 9.83258 14.5661 9.72703 14.4605C9.62148 14.355 9.56219 14.2118 9.56219 14.0626C9.56219 13.9133 9.62148 13.7701 9.72703 13.6646L13.8298 9.56257H2.8125C2.66332 9.56257 2.52024 9.50331 2.41475 9.39782C2.30926 9.29233 2.25 9.14925 2.25 9.00007C2.25 8.85088 2.30926 8.70781 2.41475 8.60232C2.52024 8.49683 2.66332 8.43757 2.8125 8.43757H13.8298L9.72703 4.33554C9.62148 4.22999 9.56219 4.08684 9.56219 3.93757C9.56219 3.7883 9.62148 3.64515 9.72703 3.5396C9.83258 3.43405 9.97573 3.37476 10.125 3.37476C10.2743 3.37476 10.4174 3.43405 10.523 3.5396L15.5855 8.6021C15.6378 8.65434 15.6793 8.71638 15.7076 8.78466C15.7359 8.85295 15.7504 8.92615 15.7504 9.00007C15.7504 9.07399 15.7359 9.14719 15.7076 9.21547C15.6793 9.28376 15.6378 9.3458 15.5855 9.39804Z"
                                                                                        fill="#111111"
                                                                                    />
                                                                                </svg>
                                                                            }

                                                                        </a>
                                                                    </div>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        </Accordion>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="right-side"></div>
                                            ))}

                                        {/* <a href="#" className='btn-report-pool'>Report this Pool</a> */}
                                        {(isMobile ? mobiletabs === 0 : true) &&
                                            (poolsdetail?.poolOwnerWalletAddress?.toLowerCase() ===
                                                smartAccount?.toLowerCase() ? (
                                                <div className="livestream-box">
                                                    <h4>{t("Live Stream")}</h4>
                                                    <p>
                                                        {t(
                                                            "Bring your YouTube Live streams to Rain and engage with your audience"
                                                        )}
                                                        .
                                                    </p>
                                                    <div className="bottom-url-area">
                                                        {youTubeId ? (
                                                            ""
                                                        ) : (
                                                            <h6>{t("Enter Link to your YouTube live stream")}</h6>
                                                        )}
                                                        <div className="option-field">
                                                            {youTubeId ? (
                                                                <button
                                                                    onClick={() => handleLiveStream("stop")}
                                                                    className="btn-start"
                                                                >
                                                                    {t("Stop")}
                                                                </button>
                                                            ) : (
                                                                <>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="https://www.youtube.com/watch?v=ucAdXFy7z18"
                                                                        value={getLiveId}
                                                                        onChange={(e) => setGetLiveId(e.target.value)}
                                                                    />
                                                                    <button
                                                                        onClick={() => handleLiveStream("start")}
                                                                        disabled={!getLiveId}
                                                                        className="btn-start"
                                                                    >
                                                                        {t("Start")}
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                ""
                                            ))}
                                    </div>
                                    {isMobile && !isPoolPrivate && (mobiletabs === 0) && <MarketRelated />}
                                </div>
                            </div>
                        </section>
                        <Footer />
                    </div>
                )
            }
            <Modal id="dialog-liquidity" className="liquidity new-modal-style overflowhiddenformobile" show={show} onHide={handleClose} centered animation={false}>
                {
                    !isMobile ? <Modal.Header closeButton>
                        <Modal.Title>{t("Add Liquidity")}</Modal.Title>
                    </Modal.Header> : <Modal.Header ref={swipeRef} onClick={handleClose}>
                        <div className="close-div d-none"></div>
                    </Modal.Header>
                }
                <Modal.Body>
                    <div className="amountbox">
                        <div className="left">
                            <p>{t("Amount")}</p>
                            <input
                                id="dialog-liquidity-amount"
                                value={buyaddliq}
                                onChange={(e) => setBuyAddLiq(e.target.value)}
                                type="number"
                                inputMode="numeric"
                                placeholder="0.00"
                                className="maininputs"
                            />
                        </div>
                        <div className="right">
                            <div class="dropdown">
                                <button
                                    class="dropdown-toggle"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <img
                                        width={22}
                                        height={22}
                                        src={marketToken.icon}
                                        alt="img"
                                        className="img-fluid"
                                    />{" "}
                                    {marketToken.label}
                                </button>
                            </div>
                        </div>
                    </div>
                    <p className="lastpara">
                        {t(
                            "The liquidity you add will be distributed into all options according to their chances"
                        )}
                    </p>
                    <button disabled={+buyaddliq <= 0} className="endbutton" onClick={() => CheckAmount()}>
                        {t("Continue")}
                    </button>
                </Modal.Body>
            </Modal>

            <Modal id="dialog-liquidity-confirm" className="liquidity new-modal-style overflowhiddenformobile" show={show1} onHide={handleClose1} centered animation={false}>
                {
                    !isMobile ? <Modal.Header closeButton>
                        <Modal.Title>{t("Add Liquidity")}</Modal.Title>
                    </Modal.Header> : <Modal.Header ref={swipeRef1} onClick={handleClose1}>
                        <div className="close-div d-none"></div>
                    </Modal.Header>
                }
                <Modal.Body>
                    <div className="amountbox">
                        <div className="left">
                            <p>{t("Amount")}</p>
                            <input
                                id="dialog-liquidity-amount"
                                value={buyaddliq}
                                onChange={(e) => setBuyAddLiq(e.target.value)}
                                type="number"
                                inputMode="numeric"
                                placeholder="0.00"
                                className="maininputs"
                            />
                        </div>
                        <div className="right">
                            <div class="dropdown">
                                <button
                                    class="dropdown-toggle"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <img
                                        width={22}
                                        height={22}
                                        src={marketToken.icon}
                                        alt="img"
                                        className="img-fluid"
                                    />{" "}
                                    {tokenToDisplay}
                                </button>
                            </div>
                        </div>
                    </div>
                    <p className="lastpara">
                        {t(
                            "The liquidity you add will be distributed into all options according to their chances"
                        )}
                    </p>
                    <div className="new-liquidity-box">
                        <div className="single">
                            <p>{t("You Add")}</p>
                            <h6>{formatNumbers(+buyaddliq)} {tokenToDisplay}</h6>
                        </div>
                        <div className="single">
                            <p>Network Fee</p>
                            <h6>{gasFeesSpinner ? (
                                <span className="spinner" />
                            ) : (
                                `$${handleToFixedOnDecimals(gasEstimateInUsdt)}`
                            )}</h6>
                        </div>

                        <div className="single">
                            <p>{t("Total")}</p>
                            {tokenToDisplay === TOKEN_RAIN ? (
                                <h6>{handleToFixedOnDecimals(+buyaddliq)} {tokenToDisplay} + ${handleToFixedOnDecimals(gasEstimateInUsdt)} </h6>

                            ) : (
                                <h6>{handleToFixedOnDecimals(+buyaddliq + +gasEstimateInUsdt)} {tokenToDisplay}</h6>
                            )}
                        </div>
                    </div>
                    <button
                        className="endbutton"
                        disabled={gasFeesSpinner}
                        onClick={AddLiquidity}
                    >
                        {t("Continue")}
                    </button>
                </Modal.Body>
            </Modal>
            <Modal
                className="liquidity"
                show={show11}
                onHide={handleClose11}
                centered
            >
                <Modal.Body>
                    <div className="innercontent">
                        <div className="upperimg">
                            {theme === "dark" ? (
                                <img
                                    src="\assets\greentick.png"
                                    alt="img"
                                    className="img-fluid tickimg"
                                />
                            ) : (
                                <img src='\assets\lightcheckmark.svg' alt='img' className='img-fluid tickimg' />
                            )}
                        </div>
                        <h2 className="upperheading">{t("Claimed Successfully")}!</h2>
                        <button
                            className="ok"
                            onClick={() => {
                                handleClose11();
                            }}
                        >
                            {t("OK")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal id="dialog-liquidity-confirmed" className="liquidity" show={show2} onHide={handleClose2} centered>
                <Modal.Body>
                    <div className="innercontent">
                        <div className="upperimg">
                            {theme === "dark" ? (
                                <img
                                    src="\assets\greentick.png"
                                    alt="img"
                                    className="img-fluid tickimg"
                                />
                            ) : (
                                <img src='\assets\lightcheckmark.svg' alt='img' className='img-fluid tickimg' />
                            )}
                        </div>
                        <h2 className="upperheading">
                            {t("Liquidity added. nice & humid here!")}
                        </h2>
                        <button
                            className="ok"
                            onClick={() => {
                                handleClose2();
                            }}
                        >
                            {t("OK")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                id={message === TRADE_PLACED_SUCCESS ? "popup-trade-success" : undefined}
                className="liquidity"
                show={show10 && !(isMobile && (!!mblSuccessInfo || showMobileSuccess))}
                onHide={handleClose10}
                centered
            >
                <Modal.Body>
                    <div className="innercontent">
                        <div className="upperimg">
                            {theme === "dark" ? (
                                <img
                                    src="\assets\greentick.png"
                                    alt="img"
                                    className="img-fluid tickimg"
                                />
                            ) : (
                                <img src='\assets\lightcheckmark.svg' alt='img' className='img-fluid tickimg' />
                            )}
                        </div>

                        <h2 className="upperheading">{message}</h2>
                        {isSellTransactionSucceed && (
                            <p className="para">{t("Check My Orders to view details")}</p>
                        )}
                        {successDescription && (
                            <p className="para" style={{ maxWidth: "100%" }}>{successDescription}</p>
                        )}

                        {isSellTransactionSucceed ? (
                            <>
                                <div className="inline-btns">
                                    <button
                                        onClick={() => {
                                            handleClose10();
                                        }}
                                        className="btn-closee"
                                    >
                                        {t("Close")}
                                    </button>
                                    <button onClick={scrollToSellOrders} className="btn-white">
                                        {t("My Orders")}
                                    </button>
                                </div>
                            </>
                        ) : (
                            <button
                                className="ok"
                                onClick={() => {
                                    handleClose10();
                                }}
                            >
                                {t("OK")}
                            </button>
                        )}
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="claim" show={show8} onHide={handleClose8} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Claim")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="claimupper">
                        <div className="heading">
                            <h6>{winnerData?.winnerOption}</h6>
                        </div>
                        <div className="parentinput">
                            <input type="text" readOnly placeholder={NETWORK_FEES} />
                            <p>{gasPrice}</p>
                        </div>
                        <div className="parentinput">
                            <input type="text" placeholder="Platform Fee" />
                            <p>{platformfee}</p>
                        </div>
                    </div>
                    <div className="lastbutton">
                        <button onClick={() => getClaims(poolsdetail?.contractAddress)}>
                            {t("Continue")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="detail" show={show33} onHide={handleClose33} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Select Option")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="uppercontent">
                        <div className="mainboxxx">
                            {poolsdetail?.options?.map((option, index) => {
                                const totalSupplyLP =
                                    percentageindiv && percentageindiv[index]
                                        ? parseFloat(percentageindiv[index])
                                        : 0;
                                const background = getBackgroundColor(
                                    index,
                                    theme,
                                    poolsdetail?.options?.length
                                );
                                return (
                                    <div
                                        key={option._id}
                                        onClick={() =>
                                            handleSelectOption(
                                                option,
                                                index,
                                                background,
                                                totalSupplyLP
                                            )
                                        }
                                        className={
                                            selectedOption?.choiceIndex === option.choiceIndex
                                                ? "activeitem innermainbox"
                                                : "innermainbox"
                                        }
                                    >
                                        <div className="left">
                                            <h6>
                                                <span
                                                    style={{
                                                        backgroundColor: background,
                                                    }}
                                                ></span>
                                                {option.optionName}
                                            </h6>
                                        </div>
                                        <div className="right">
                                            <h6>{t("My shares")}</h6>
                                            <h4>{swapbalance[option._id]}</h4>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="detail" show={show5} onHide={handleClose5} centered>
                <Modal.Body>
                    <div className="innercontent">
                        <div className="upperimg">
                            {theme === "dark" ? (
                                <img
                                    src="\assets\greentick.png"
                                    alt="img"
                                    className="img-fluid tickimg"
                                />
                            ) : (
                                <img src='\assets\lightcheckmark.svg' alt='img' className='img-fluid tickimg' />
                            )}
                        </div>
                        <h2 className="upperheading">
                            {t("Option Switched successfully")}
                        </h2>
                        <button
                            className="ok"
                            onClick={() => {
                                handleClose5();
                            }}
                        >
                            {t("OK")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                id="popup-trade-confirm"
                className="round"
                show={show7 && !(isMobile && showMblProgress)}
                onHide={handleClose7}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Body style={{ padding: "30px 20px" }}>
                    <div className="maincontent">
                        <h4 className="m-0">{message}</h4>
                        {
                            message === 'Finalize answer' ? <p /> : <p className="paraplacing">
                                Transaction in progress! <br /> Blockchain validation is underway. This
                                may take a few moments.
                            </p>
                        }
                        <ProgressiveProgressBar active={startProgressBar} />
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={show9} onHide={handleClose9} centered className="pollmodal">
                <Modal.Body>
                    <h6 className="modalhead">{t("Share This Market")}</h6>
                    <div className="parent-poll">
                        <div className="pollmain">
                            <div className="pollleft">
                                <p className="idpara">{t("Market Id")}</p>
                                <h6 className="idnumber">
                                    {poolsdetail?._id?.slice(0, 5)}...
                                    {poolsdetail?._id?.slice(-3)}
                                </h6>
                            </div>
                            <div onClick={handleCopyClickId}>
                                {isCopiedId ? (
                                    <svg
                                        className="copysvg"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="14"
                                        height="14"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                    >
                                        <path
                                            d="M13 3L4.75 11L1 7.36364"
                                            stroke="#E6FF00"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className="setcustomsvgstroke"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="25"
                                        viewBox="0 0 24 25"
                                        fill="none"
                                    >
                                        <path
                                            d="M20.25 3.5H8.25C8.05109 3.5 7.86032 3.57902 7.71967 3.71967C7.57902 3.86032 7.5 4.05109 7.5 4.25V8H3.75C3.55109 8 3.36032 8.07902 3.21967 8.21967C3.07902 8.36032 3 8.55109 3 8.75V20.75C3 20.9489 3.07902 21.1397 3.21967 21.2803C3.36032 21.421 3.55109 21.5 3.75 21.5H15.75C15.9489 21.5 16.1397 21.421 16.2803 21.2803C16.421 21.1397 16.5 20.9489 16.5 20.75V17H20.25C20.4489 17 20.6397 16.921 20.7803 16.7803C20.921 16.6397 21 16.4489 21 16.25V4.25C21 4.05109 20.921 3.86032 20.7803 3.71967C20.6397 3.57902 20.4489 3.5 20.25 3.5ZM15 20H4.5V9.5H15V20ZM19.5 15.5H16.5V8.75C16.5 8.55109 16.421 8.36032 16.2803 8.21967C16.1397 8.07902 15.9489 8 15.75 8H9V5H19.5V15.5Z"
                                            fill="#DAD9D9"
                                        />
                                    </svg>
                                )}
                            </div>
                        </div>
                        <div className="pollmain">
                            <div className="pollleft">
                                <p className="idpara">{t("Poll Link")}</p>
                                <h6 className="idnumber">
                                    {shiftStringToSubstring(
                                        `https://${SHARE_MARKET}/?id=${poolsdetail?._id}&theme=${theme}`,
                                        24,
                                        8
                                    )}

                                </h6>
                            </div>
                            {isCopiedLink ? (
                                <svg
                                    className="copysvg"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                >
                                    <path
                                        d="M13 3L4.75 11L1 7.36364"
                                        stroke="#E6FF00"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            ) : (
                                <a onClick={handleCopyClickLink}>
                                    <svg
                                        className="setcustomsvgstroke"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="25"
                                        viewBox="0 0 24 25"
                                        fill="none"
                                    >
                                        <path
                                            d="M20.25 3.5H8.25C8.05109 3.5 7.86032 3.57902 7.71967 3.71967C7.57902 3.86032 7.5 4.05109 7.5 4.25V8H3.75C3.55109 8 3.36032 8.07902 3.21967 8.21967C3.07902 8.36032 3 8.55109 3 8.75V20.75C3 20.9489 3.07902 21.1397 3.21967 21.2803C3.36032 21.421 3.55109 21.5 3.75 21.5H15.75C15.9489 21.5 16.1397 21.421 16.2803 21.2803C16.421 21.1397 16.5 20.9489 16.5 20.75V17H20.25C20.4489 17 20.6397 16.921 20.7803 16.7803C20.921 16.6397 21 16.4489 21 16.25V4.25C21 4.05109 20.921 3.86032 20.7803 3.71967C20.6397 3.57902 20.4489 3.5 20.25 3.5ZM15 20H4.5V9.5H15V20ZM19.5 15.5H16.5V8.75C16.5 8.55109 16.421 8.36032 16.2803 8.21967C16.1397 8.07902 15.9489 8 15.75 8H9V5H19.5V15.5Z"
                                            fill="#DAD9D9"
                                        />
                                    </svg>
                                </a>
                            )}
                        </div>
                        {isPoolPrivate && (
                            <div className="pollmain">
                                <div className="pollleft">
                                    <p className="idpara">{t("Access Code")}:</p>
                                    <h6 className="idnumber">{poolsdetail?.accessCode}</h6>
                                </div>
                                {isCopiedCode ? (
                                    <svg
                                        className="copysvg"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="14"
                                        height="14"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                    >
                                        <path
                                            d="M13 3L4.75 11L1 7.36364"
                                            stroke="#E6FF00"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                ) : (
                                    <a onClick={handleCopyClickCode}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                        >
                                            <path
                                                d="M20.25 3.5H8.25C8.05109 3.5 7.86032 3.57902 7.71967 3.71967C7.57902 3.86032 7.5 4.05109 7.5 4.25V8H3.75C3.55109 8 3.36032 8.07902 3.21967 8.21967C3.07902 8.36032 3 8.55109 3 8.75V20.75C3 20.9489 3.07902 21.1397 3.21967 21.2803C3.36032 21.421 3.55109 21.5 3.75 21.5H15.75C15.9489 21.5 16.1397 21.421 16.2803 21.2803C16.421 21.1397 16.5 20.9489 16.5 20.75V17H20.25C20.4489 17 20.6397 16.921 20.7803 16.7803C20.921 16.6397 21 16.4489 21 16.25V4.25C21 4.05109 20.921 3.86032 20.7803 3.71967C20.6397 3.57902 20.4489 3.5 20.25 3.5ZM15 20H4.5V9.5H15V20ZM19.5 15.5H16.5V8.75C16.5 8.55109 16.421 8.36032 16.2803 8.21967C16.1397 8.07902 15.9489 8 15.75 8H9V5H19.5V15.5Z"
                                                fill="#DAD9D9"
                                            />
                                        </svg>
                                    </a>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="socialicons">
                        <div
                            onClick={() => {
                                sharePoolToSocials(
                                    twitter_url,
                                    poolQuestion,
                                    poolId,
                                    poolAccessCode,
                                    isPoolPrivate,
                                    totalVolume,
                                    volumn,
                                    poolOptions,
                                    poolsdetail?.token,
                                    theme
                                );
                            }}
                            className="socialinner"
                        >
                            <span className="socialimg">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                >
                                    <path
                                        d="M13.6829 1.6875H16.1639L10.7437 7.8825L17.1202 16.3125H12.1274L8.21693 11.1997L3.74243 16.3125H1.25993L7.05743 9.68625L0.94043 1.6875H6.05993L9.59468 6.36075L13.6829 1.6875ZM12.8122 14.8275H14.1869L5.31293 3.0945H3.83768L12.8122 14.8275Z"
                                        fill="#DAD9D9"
                                    />
                                </svg>
                            </span>
                            <p className="socialpara">{t("X")}</p>
                        </div>
                        <div
                            onClick={() =>
                                sharePoolToSocials(
                                    facebook_url,
                                    poolQuestion,
                                    poolId,
                                    poolAccessCode,
                                    isPoolPrivate,
                                    totalVolume,
                                    volumn,
                                    poolOptions,
                                    poolsdetail?.token,
                                    theme
                                )
                            }
                            className="socialinner"
                        >
                            <span className="socialimg">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="18"
                                    viewBox="0 0 19 18"
                                    fill="none"
                                >
                                    <path
                                        d="M10.8941 18V9.78996H13.6487L14.062 6.58941H10.8941V4.54632C10.8941 3.61998 11.1503 2.98869 12.4801 2.98869L14.1735 2.98799V0.125307C13.8807 0.0872508 12.8754 0 11.7054 0C9.2623 0 7.58968 1.49127 7.58968 4.22934V6.58941H4.82666V9.78996H7.58968V18H10.8941Z"
                                        fill="#DAD9D9"
                                    />
                                </svg>
                            </span>
                            <p className="socialpara">{t("Facebook")}</p>
                        </div>
                        <div
                            onClick={() =>
                                sharePoolToSocials(
                                    telegram_url,
                                    poolQuestion,
                                    poolId,
                                    poolAccessCode,
                                    isPoolPrivate,
                                    totalVolume,
                                    volumn,
                                    poolOptions,
                                    poolsdetail?.token,
                                    theme
                                )
                            }
                            className="socialinner"
                        >
                            <span className="socialimg">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                >
                                    <path
                                        d="M12.4312 7.06158C12.8912 6.58786 13.3479 5.4825 11.4311 6.82472C9.64055 8.09375 7.83781 9.34449 6.02317 10.5768C5.74685 10.7054 5.44812 10.7753 5.14493 10.7821C4.84174 10.7888 4.54035 10.7325 4.25886 10.6163C3.10877 10.261 1.76615 9.78724 1.76615 9.78724C1.76615 9.78724 0.849412 9.19422 2.41871 8.56259C2.41871 8.56259 9.05341 5.75884 11.3544 4.77105C12.2362 4.37628 15.2273 3.11301 15.2273 3.11301C15.2273 3.11301 16.6082 2.55947 16.4932 3.90255C16.4549 4.45523 16.1482 6.39133 15.8415 8.48363C15.3806 11.4453 14.8822 14.6841 14.8822 14.6841C14.8822 14.6841 14.8056 15.5921 14.1538 15.75C13.4562 15.7378 12.7821 15.4879 12.237 15.0394C12.0837 14.921 9.36094 13.1437 8.36336 12.2752C8.26185 12.2044 8.17942 12.1083 8.12367 11.9959C8.068 11.8835 8.04075 11.7583 8.04458 11.6322C8.04841 11.506 8.08317 11.383 8.14559 11.2743C8.20801 11.1658 8.2961 11.0751 8.40169 11.011C9.76997 9.72193 11.1133 8.40519 12.4312 7.06158Z"
                                        fill="#DAD9D9"
                                    />
                                </svg>
                            </span>
                            <p className="socialpara">{t("Telegram")}</p>
                        </div>
                        <div
                            onClick={() =>
                                sharePoolToSocials(
                                    whatsapp_url,
                                    poolQuestion,
                                    poolId,
                                    poolAccessCode,
                                    isPoolPrivate,
                                    totalVolume,
                                    volumn,
                                    poolOptions,
                                    poolsdetail?.token,
                                    theme
                                )
                            }
                            className="socialinner"
                        >
                            <span className="socialimg">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="19"
                                    viewBox="0 0 18 19"
                                    fill="none"
                                >
                                    <path
                                        d="M8.99978 1.22021C4.43426 1.22021 0.71978 4.93469 0.71978 9.50021C0.71978 10.9258 1.08806 12.3277 1.78646 13.5646L0.7331 17.323C0.69854 17.4465 0.73202 17.579 0.8213 17.6708C0.89006 17.7417 0.98366 17.7802 1.07978 17.7802C1.10858 17.7802 1.13774 17.7766 1.16618 17.7698L5.08874 16.7981C6.28646 17.4411 7.63538 17.7802 8.99978 17.7802C13.5653 17.7802 17.2798 14.0657 17.2798 9.50021C17.2798 4.93469 13.5653 1.22021 8.99978 1.22021ZM13.165 12.422C12.9879 12.9123 12.1383 13.3598 11.73 13.4199C11.3635 13.4735 10.8999 13.4966 10.3908 13.3367C10.0823 13.2395 9.6863 13.1107 9.17906 12.8943C7.04678 11.9849 5.6543 9.86489 5.54774 9.72485C5.44154 9.58482 4.67978 8.58689 4.67978 7.55405C4.67978 6.52121 5.22878 6.01325 5.4239 5.80301C5.61902 5.59277 5.84906 5.54021 5.9909 5.54021C6.13274 5.54021 6.27422 5.54201 6.39842 5.54777C6.5291 5.55425 6.70442 5.49845 6.87686 5.90813C7.05398 6.32861 7.47914 7.36145 7.5317 7.46693C7.58498 7.57205 7.62026 7.69481 7.5497 7.83485C7.47914 7.97489 7.44386 8.06237 7.3373 8.18513C7.23074 8.30789 7.1141 8.45873 7.01834 8.55305C6.91178 8.65781 6.80126 8.77121 6.9251 8.98145C7.04894 9.19169 7.47554 9.87893 8.1077 10.4355C8.9195 11.1505 9.60458 11.3722 9.81698 11.4773C10.0294 11.5825 10.1536 11.5648 10.2774 11.4248C10.4013 11.2844 10.8088 10.8117 10.9503 10.6018C11.0917 10.3919 11.2336 10.4265 11.4287 10.4967C11.6238 10.5665 12.6689 11.0741 12.8813 11.1793C13.0937 11.2844 13.2355 11.3369 13.2888 11.4244C13.3421 11.5115 13.3421 11.932 13.165 12.422Z"
                                        fill="#DAD9D9"
                                    />
                                </svg>
                            </span>
                            <p className="socialpara">{t("Whatsapp")}</p>
                        </div>
                        <div
                            onClick={() =>
                                sharePoolEmail(
                                    poolQuestion,
                                    poolId,
                                    tokenLogo,
                                    tokenAddress,
                                    tokenName,
                                    poolAccessCode,
                                    isPoolPrivate,
                                    totalVolume,
                                    volumn,
                                    poolOptions,
                                    theme
                                )
                            }
                            className="socialinner"
                        >
                            <span className="socialimg">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                >
                                    <g clip-path="url(#clip0_77_470)">
                                        <path
                                            d="M10.5043 11.0283C10.0565 11.3268 9.53631 11.4847 9 11.4847C8.46373 11.4847 7.94355 11.3268 7.49573 11.0283L0.119848 6.11089C0.0789258 6.08361 0.0390586 6.05516 0 6.02591V14.0836C0 15.0075 0.749707 15.7406 1.65702 15.7406H16.3429C17.2668 15.7406 18 14.9909 18 14.0836V6.02588C17.9608 6.0552 17.9209 6.08371 17.8799 6.11103L10.5043 11.0283Z"
                                            fill="#DAD9D9"
                                        />
                                        <path
                                            d="M0.704883 5.23321L8.08077 10.1507C8.35998 10.3368 8.67997 10.4299 8.99996 10.4299C9.31999 10.4299 9.64002 10.3368 9.91923 10.1507L17.2951 5.23321C17.7365 4.93913 18 4.44694 18 3.91573C18 3.00234 17.2569 2.25928 16.3435 2.25928H1.65646C0.743098 2.25931 0 3.00237 0 3.91661C0 4.44694 0.263531 4.93913 0.704883 5.23321Z"
                                            fill="#DAD9D9"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_77_470">
                                            <rect width="18" height="18" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                            <p className="socialpara">{t("Email")}</p>
                        </div>
                        <div onClick={copyPoolLinks} className="socialinner">
                            <span className="socialimg">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19"
                                    height="18"
                                    viewBox="0 0 19 18"
                                    fill="none"
                                >
                                    <g clip-path="url(#clip0_77_476)">
                                        <path
                                            d="M11.4823 7.01593C11.2691 6.80145 11.0327 6.61132 10.7774 6.44903C10.1014 6.01616 9.31556 5.78614 8.51284 5.78614C7.3987 5.78407 6.32982 6.22674 5.54338 7.01593L1.72806 10.8342C0.942953 11.6209 0.50168 12.6866 0.500977 13.798C0.499501 16.1172 2.37834 17.9985 4.69753 17.9999C5.80995 18.0038 6.87784 17.5632 7.66401 16.7762L10.8134 13.6267C10.8707 13.57 10.9026 13.4926 10.9022 13.412C10.9012 13.2464 10.7661 13.1129 10.6005 13.1138H10.4805C9.8225 13.1161 9.17036 12.9898 8.56086 12.7419C8.44855 12.6957 8.31948 12.7217 8.23393 12.8079L5.96932 15.0755C5.26611 15.7787 4.12599 15.7787 3.42278 15.0755C2.71957 14.3722 2.71957 13.2321 3.42278 12.5289L7.25311 8.70162C7.95575 7.99985 9.09401 7.99985 9.79666 8.70162C10.2702 9.14728 11.0088 9.14728 11.4823 8.70162C11.6861 8.49771 11.8096 8.22727 11.8303 7.93974C11.8522 7.59615 11.7255 7.25966 11.4823 7.01593Z"
                                            fill="#DAD9D9"
                                        />
                                        <path
                                            d="M17.2688 1.22999C15.6288 -0.409998 12.9699 -0.409998 11.3299 1.22999L8.18345 4.37342C8.09705 4.46024 8.07213 4.59082 8.12046 4.70337C8.16823 4.81624 8.27986 4.88868 8.4024 4.88632H8.51337C9.1706 4.88513 9.82168 5.01248 10.43 5.26127C10.5423 5.30749 10.6714 5.28141 10.757 5.19529L13.0155 2.93969C13.7188 2.23648 14.8589 2.23648 15.5621 2.93969C16.2653 3.64289 16.2653 4.78302 15.5621 5.48623L12.7486 8.29671L12.7246 8.32371L11.7408 9.30154C11.0381 10.0033 9.89985 10.0033 9.19721 9.30154C8.72367 8.85588 7.98503 8.85588 7.51152 9.30154C7.30649 9.50699 7.18287 9.77979 7.16357 10.0694C7.14164 10.413 7.26836 10.7495 7.51152 10.9932C7.8587 11.3419 8.26489 11.6262 8.71129 11.8331C8.77428 11.8631 8.83727 11.8871 8.90026 11.9141C8.96325 11.9411 9.02923 11.962 9.09221 11.986C9.1552 12.0101 9.22118 12.031 9.28417 12.049L9.46115 12.097C9.58112 12.127 9.70112 12.151 9.82407 12.172C9.97219 12.194 10.1214 12.208 10.271 12.214H10.481H10.499L10.6789 12.193C10.7449 12.19 10.8139 12.175 10.8919 12.175H10.9939L11.2008 12.145L11.2968 12.127L11.4708 12.091H11.5038C12.2406 11.906 12.9133 11.5245 13.4504 10.9872L17.2687 7.16893C18.9088 5.52893 18.9088 2.86998 17.2688 1.22999Z"
                                            fill="#DAD9D9"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_77_476">
                                            <rect
                                                width="18"
                                                height="18"
                                                fill="white"
                                                transform="translate(0.5)"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                            {isCopied ? (
                                <p className="socialpara">{t("Copied")}</p>
                            ) : (
                                <p className="socialpara">{t("Copy Link")}</p>
                            )}
                        </div>
                    </div>
                    <button onClick={handleClose9} className="okaybtn">
                        {t("OK")}
                    </button>
                </Modal.Body>
            </Modal>

            <Modal
                className="liquidity"
                show={show12}
                onHide={handleClose12}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t("Kill Market")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="innercontent">
                        <div className="upperimg">
                            <img
                                src="\assets\cross.svg"
                                alt="img"
                                className="img-fluid tickimg"
                            />
                        </div>
                        <h2 className="upperheading">{t("Are you sure?")}</h2>
                        <p className="para">
                            {t("You want to close your Market? This is irreversible")}
                        </p>
                        <p className="para">
                            Estimated {NETWORK_FEES}
                            {gasFeesSpinner ? (
                                <span className="spinner" />
                            ) : (
                                `$${handleToFixedOnDecimals(gasEstimateInUsdt)}`
                            )}
                        </p>
                    </div>
                    <div className="twice-btns">
                        <a onClick={handleClose12} className="btn-cancel">
                            {t("Cancel")}
                        </a>
                        {gasFeesSpinner ? (
                            <a className="btn-save">{t("Loading")}</a>
                        ) : (
                            <a
                                onClick={handleConfirmCloseMarket}
                                className="btn-save"
                            >
                                {t("Yes I'm Sure")}
                            </a>
                        )}
                    </div>
                </Modal.Body>
            </Modal>


            <Modal className="detail" show={show14} onHide={handleClose14} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Select Winner")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="upper-heading">
                        <h5>{t("Question")}</h5>
                        <p>{poolsdetail?.question}</p>
                    </div>
                    <div className="uppercontent">
                        <div className="mainboxxx">
                            {poolsdetail?.options?.map((option, index) => {
                                return (
                                    <div
                                        key={option._id}
                                        className={`innermainbox ${selectedOption === option.choiceIndex ? "active" : ""
                                            }`}
                                        onClick={() =>
                                            handleOptionClick(option.choiceIndex, option?.optionName)
                                        }
                                    >
                                        <div className="left">
                                            <h6>{option.optionName}</h6>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <p
                            style={{
                                minHeight: "40px",
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                color: "var(--heading-text)",
                            }}
                        >
                            Estimated {NETWORK_FEES}
                            {gasFeesSpinner ? (
                                <span
                                    className="spinner m-0"
                                    style={{ width: "12px", height: "12px" }}
                                />
                            ) : (
                                ` $${handleToFixedOnDecimals(gasEstimateInUsdt)}`
                            )}
                        </p>
                    </div>
                    <div className="lastbutton">
                        <button disabled={gasFeesSpinner} onClick={() => handleContinue()}>
                            {t("Continue")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal className="detail" show={show15} onHide={handleClose15} centered>
                <Modal.Body>
                    <div className="innercontent">
                        <div className="upperimg">
                            {theme === "dark" ? (
                                <img
                                    src="\assets\greentick.png"
                                    alt="img"
                                    className="img-fluid tickimg"
                                />
                            ) : (
                                <img src='\assets\lightcheckmark.svg' alt='img' className='img-fluid tickimg' />
                            )}
                        </div>
                        <h2 className="upperheading">{t("Winning option chosen. prepare your umbrellas!")}</h2>
                        <div className="winner-area">
                            <p>{t("Winner")}</p>
                            <h4>{selectedname}</h4>
                            {/* <h6>38%</h6> */}
                        </div>
                        <button
                            className="ok"
                            onClick={() => {
                                handleClose15();
                            }}
                        >
                            {t("OK")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal className="detail" show={show16} onHide={handleClose16} centered>
                <Modal.Body>
                    <div className="innercontent">
                        <div className="upperimg">
                            {theme === "dark" ? (
                                <img
                                    src="\assets\greentick.png"
                                    alt="img"
                                    className="img-fluid tickimg"
                                />
                            ) : (
                                <img src='\assets\lightcheckmark.svg' alt='img' className='img-fluid tickimg' />
                            )}
                        </div>
                        <h2 className="upperheading">{t("Market Closed")}</h2>
                        <button
                            className="ok"
                            onClick={() => {
                                handleClose16();
                            }}
                        >
                            {t("OK")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                style={{ zIndex: "999999999999999" }}
                className="detail endpoolmodal"
                show={showendpool}
                onHide={handleCloseEndPool}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t("Want to end the Market?")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="upper-heading">
                        <p>
                            {t(
                                "Select how you want to decide the winning option for this Market?"
                            )}
                        </p>
                    </div>
                    <div className="uppercontent">
                        <div className="mainboxxx">
                            <div
                                onClick={() => {
                                    setSelectedClosePoolOption(CLOSE_POOL_OPTIONS.INSTANT);
                                    setResolutionTime(null);
                                }}
                                className={
                                    selectedClosePoolOption === CLOSE_POOL_OPTIONS.INSTANT
                                        ? "innermainbox active"
                                        : "innermainbox "
                                }
                            >
                                <div className="left">
                                    <h6>{t("Decide Winner Instantly")}</h6>
                                    <p>{t("Estimated Time: 1-2 Minutes")}</p>
                                </div>
                                {selectedClosePoolOption === CLOSE_POOL_OPTIONS.INSTANT ? (
                                    <div className="right">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M12 21.5C13.1819 21.5 14.3522 21.2672 15.4442 20.8149C16.5361 20.3626 17.5282 19.6997 18.364 18.864C19.1997 18.0282 19.8626 17.0361 20.3149 15.9442C20.7672 14.8522 21 13.6819 21 12.5C21 11.3181 20.7672 10.1478 20.3149 9.05585C19.8626 7.96392 19.1997 6.97177 18.364 6.13604C17.5282 5.30031 16.5361 4.63738 15.4442 4.18508C14.3522 3.73279 13.1819 3.5 12 3.5C9.61305 3.5 7.32387 4.44821 5.63604 6.13604C3.94821 7.82387 3 10.1131 3 12.5C3 14.8869 3.94821 17.1761 5.63604 18.864C7.32387 20.5518 9.61305 21.5 12 21.5ZM11.768 16.14L16.768 10.14L15.232 8.86L10.932 14.019L8.707 11.793L7.293 13.207L10.293 16.207L11.067 16.981L11.768 16.14Z"
                                                fill="#E6FF00"
                                            />
                                        </svg>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div
                                className={
                                    selectedClosePoolOption === CLOSE_POOL_OPTIONS.SCHEDULE
                                        ? "innermainbox lastinnermainbox active"
                                        : "innermainbox lastinnermainbox"
                                }
                            >
                                <div
                                    className="inline-parent"
                                    onClick={() => {
                                        setSelectedClosePoolOption(CLOSE_POOL_OPTIONS.SCHEDULE);
                                    }}
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className="left">
                                        <h6>Schedule Decision Time</h6>
                                        <p>
                                            Select a specific date and time when the winner will be
                                            decided.
                                        </p>
                                        <p>
                                            (This time cannot be earlier than the market's end time.)
                                        </p>
                                    </div>
                                    {selectedClosePoolOption === CLOSE_POOL_OPTIONS.SCHEDULE && (
                                        <div className="right">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="25"
                                                viewBox="0 0 24 25"
                                                fill="none"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M12 21.5C13.1819 21.5 14.3522 21.2672 15.4442 20.8149C16.5361 20.3626 17.5282 19.6997 18.364 18.864C19.1997 18.0282 19.8626 17.0361 20.3149 15.9442C20.7672 14.8522 21 13.6819 21 12.5C21 11.3181 20.7672 10.1478 20.3149 9.05585C19.8626 7.96392 19.1997 6.97177 18.364 6.13604C17.5282 5.30031 16.5361 4.63738 15.4442 4.18508C14.3522 3.73279 13.1819 3.5 12 3.5C9.61305 3.5 7.32387 4.44821 5.63604 6.13604C3.94821 7.82387 3 10.1131 3 12.5C3 14.8869 3.94821 17.1761 5.63604 18.864C7.32387 20.5518 9.61305 21.5 12 21.5ZM11.768 16.14L16.768 10.14L15.232 8.86L10.932 14.019L8.707 11.793L7.293 13.207L10.293 16.207L11.067 16.981L11.768 16.14Z"
                                                    fill="#E6FF00"
                                                />
                                            </svg>
                                        </div>
                                    )}
                                </div>
                                {selectedClosePoolOption === CLOSE_POOL_OPTIONS.SCHEDULE && (
                                    <DateTimePicker
                                        value={resolutionTime}
                                        onChange={(data) => setResolutionTime(data)}
                                        minDateTime={poolend}
                                        label="Select Date/Time"
                                        placeholder="dd/MM/yy hh:mm"
                                        format="dd/MM/yy hh:mm aa"
                                        oneTap={false}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="lastbutton">
                        <button
                            disabled={false}
                            onClick={() => killSwitchPool(poolsdetail?.contractAddress)}
                        >
                            {t("END MARKET")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                className="detail openadispute-modal"
                show={showresolveearly}
                onHide={handleCloseResolveEarly}
                centered
            >
                <Modal.Body>
                    <div className="innercontent">
                        <div className="upperimg">
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="23" viewBox="0 0 5 23" fill="none">
                                <path d="M5 20.5C5 20.9945 4.85338 21.4778 4.57868 21.8889C4.30397 22.3001 3.91353 22.6205 3.45671 22.8097C2.9999 22.9989 2.49723 23.0484 2.01228 22.952C1.52732 22.8555 1.08187 22.6174 0.732234 22.2678C0.382603 21.9181 0.144501 21.4727 0.0480379 20.9877C-0.0484251 20.5028 0.00108321 20.0001 0.190302 19.5433C0.379521 19.0865 0.699953 18.696 1.11108 18.4213C1.5222 18.1466 2.00555 18 2.5 18C3.16304 18 3.79893 18.2634 4.26777 18.7322C4.73661 19.2011 5 19.837 5 20.5ZM2.5 15.5C2.89783 15.5 3.27936 15.342 3.56066 15.0607C3.84197 14.7794 4 14.3978 4 14V1.5C4 1.10218 3.84197 0.720644 3.56066 0.43934C3.27936 0.158035 2.89783 0 2.5 0C2.10218 0 1.72065 0.158035 1.43934 0.43934C1.15804 0.720644 1 1.10218 1 1.5V14C1 14.3978 1.15804 14.7794 1.43934 15.0607C1.72065 15.342 2.10218 15.5 2.5 15.5Z" fill="#212121" />
                            </svg>
                        </div>

                        <h2 className='upperheading'>
                            Resolve Early?
                        </h2>

                        <p className="para">
                            You’re about to resolve this market before its scheduled end time. Only proceed if the final outcome is publicly available
                        </p>



                        <h5 className="last-text">Are you sure the market should be resolved now?</h5>

                        <div className="twice-btns">
                            <button className="btn-cancel" onClick={handleCloseResolveEarly}>Cancel</button>
                            <button
                                className="ok"
                                onClick={() => killSwitchPool(poolsdetail?.contractAddress)}
                            >
                                {t(`Yes`)}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                className="detail privatepollmodal dispute-create-modal new-modal-style"
                show={showcreatedispute}
                onHide={handleCloseCreateDispute}
                centered
                animation={isMobile ? false : true}
            >
                <Modal.Header className="m-0" ref={swipeRefcreatedispute} onClick={handleCloseCreateDispute}>
                    <div className="close-div d-none"></div>
                </Modal.Header>
                <Modal.Body>
                    {disputeOrAppealText === APPEAL ? <><div className="dispute-create-parent p-0">
                        <div className="upper-icon icongrey">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                <path d="M31.5 22.8765C32.2667 21.8842 32.7419 20.6979 32.8722 19.4507C33.0025 18.2034 32.7827 16.9445 32.2376 15.8152C31.6925 14.6858 30.8435 13.7307 29.7859 13.0568C28.7283 12.3829 27.5039 12.017 26.25 12H23.565C23.1377 10.5738 22.412 9.25472 21.436 8.13036C20.46 7.00599 19.2561 6.10205 17.9041 5.4785C16.5521 4.85496 15.0829 4.52607 13.5941 4.51367C12.1053 4.50127 10.6309 4.80563 9.26866 5.40657C7.90645 6.00751 6.68762 6.89127 5.69304 7.99922C4.69846 9.10717 3.95088 10.414 3.49991 11.8329C3.04893 13.2518 2.90488 14.7504 3.0773 16.2293C3.24972 17.7081 3.73468 19.1334 4.49999 20.4105" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10.5 16.5V22.5H16.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 28.5C12.9445 29.7593 14.2612 30.6895 15.7637 31.1589C17.2663 31.6282 18.8784 31.6129 20.3717 31.1151C21.865 30.6173 23.1639 29.6623 24.0843 28.3853C25.0047 27.1083 25.5 25.5741 25.5 24C25.5 22.2098 24.7888 20.4929 23.523 19.227C22.2571 17.9612 20.5402 17.25 18.75 17.25C17.8003 17.2493 16.8597 17.4357 15.9821 17.7986C15.1044 18.1615 14.3069 18.6938 13.635 19.365L10.5 22.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <h4>Request a Human Review</h4>
                        <p className="para">Decentralized human oracles will review the decision and determine the final outcome.</p>
                        <div className="outcomes-parent">
                            <div className="single">
                                <div className="upper">
                                    <p>Appeal Bond</p>
                                    <h6> {getTokenSymbol(tokenSymbol)}{Number(requiredDisputeAmount)?.toFixed(2)}</h6>
                                </div>
                                <div className="bottom">
                                    <p>Estimated network fee</p>
                                    <h6>{gasFeesSpinner ? (
                                        <span className="spinner" />
                                    ) : (
                                        `$${handleToFixedOnDecimals(gasEstimateInUsdt)}`
                                    )}</h6>
                                </div>

                            </div>
                        </div>
                        <div className="twice-btns">
                            <button className="btn-cancel" onClick={handleCloseCreateDispute}>Cancel</button>
                            <button className="btn-dispute" disabled={gasFeesSpinner}
                                onClick={() => {
                                    createPublicPoolDispute();
                                }}>Submit Appeal</button>
                        </div>

                    </div></> : <> <div className="dispute-create-parent">
                        <div className="upper-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                <path d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z" stroke="#FE5C32" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13.635 13.4999C13.9877 12.4974 14.6837 11.652 15.5999 11.1136C16.5161 10.5751 17.5934 10.3783 18.6408 10.5579C19.6882 10.7376 20.6382 11.2822 21.3226 12.0952C22.007 12.9082 22.3816 13.9372 22.38 14.9999C22.38 17.9999 17.88 19.4999 17.88 19.4999" stroke="#FE5C32" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18 25.5H18.0113" stroke="#FE5C32" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <h4>You are about to create a dispute</h4>
                        <div className="outcomes-parent">
                            <div className="single">
                                <p>Proposed Outcome</p>
                                <h6><span style={{ backgroundColor: getBackgroundColor(poolsdetail?.options?.findIndex(opt => opt._id === winnerData?.winnerId), theme, poolsdetail?.options?.length) }} className="circle-dot"></span>{winnerData?.winnerOption}</h6>
                            </div>
                            <div className="single">
                                <div className="upper">
                                    <p>Dispute Bond  <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                                <p>You will be charged with 0.1% bond fee of the market's volume - the minimum amount is 25$ and the maximum is 500$</p>
                                            </TooltipCustom>
                                        }
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <g clipPath="url(#clip0_10136_49160)">
                                                <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M7 9.33333V7" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M7 4.6665H7.01" stroke="#9F9F9F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_10136_49160">
                                                    <rect width="14" height="14" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </OverlayTrigger></p>
                                    <h6> {getTokenSymbol(tokenSymbol)}{Number(requiredDisputeAmount)?.toFixed(2)}</h6>
                                </div>
                                <div className="bottom">
                                    <p>Estimated network fee</p>
                                    <h6>{gasFeesSpinner ? (
                                        <span className="spinner" />
                                    ) : (
                                        `$${handleToFixedOnDecimals(gasEstimateInUsdt)}`
                                    )}</h6>
                                </div>

                            </div>
                        </div>
                        <button className="btn-dispute" disabled={gasFeesSpinner}
                            onClick={() => {
                                createPublicPoolDispute();
                            }}>Create Dispute</button>
                    </div></>}

                </Modal.Body>
            </Modal>

            <Modal
                className="detail poolclosed-modal"
                show={showpoolclosed}
                onHide={handleClosePoolClosed}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t("Market successfully closed")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="innercontent">
                        <div className="poolclosed-content">
                            <h6>{t("Winner Being decided by")}</h6>
                            <h5>{t("Olympus AI")}</h5>
                            <p>{t("Remaining Time")}</p>
                            <div className="timer">
                                <h4>1D</h4>
                                <h4>18H</h4>
                                <h4>36M</h4>
                                <h4>05S</h4>
                            </div>
                        </div>
                        <button
                            className="ok"
                            onClick={() => {
                                handleCloseCreateDispute();
                            }}
                        >
                            {t("OK")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                className="detail poolclosed-modal"
                show={showdisputecreated}
                onHide={handleCloseDisputeCreated}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t(`${disputeOrAppealText} Created Succesfully`)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="innercontent">
                        <div className="poolclosed-content">
                            <p style={{ color: "#FE5C32" }}>{t(`Remaining Time For ${disputeOrAppealText} Resolution`)}</p>
                            <div className="timer">
                                <h4>1D</h4>
                                <h4>18H</h4>
                                <h4>36M</h4>
                                <h4>05S</h4>
                            </div>
                        </div>
                        <button
                            className="ok"
                            onClick={() => {
                                handleCloseCreateDispute();
                            }}
                        >
                            {t("OK")}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                className="detail"
                show={showclaimedsuccess}
                onHide={handleCloseClaimedSuccess}
                centered
            >
                <Modal.Body>
                    <div className="innercontent pt-0">
                        <div className="upperimg" style={{ width: "auto", height: "auto" }}>
                            <img
                                src="\assets\usdt_coin.gif"
                                alt="img"
                                className="img-fluid tickimg"
                            />
                        </div>
                        <h2 className="upperheading">Position claimed</h2>
                        <button
                            className="ok"
                            onClick={() => {
                                handleCloseClaimedSuccess();
                            }}
                        >
                            OK
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

            <Offcanvas
                placement="end"
                className="reasoningoffcanvas"
                show={showreasoning}
                onHide={handleCloseReasoning}
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Reasoning for this answer</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="upper-box">
                        <p>Determined Answer </p>
                        <h6>{winnerData?.winnerOption}</h6>
                    </div>
                    <div className="bottom-box">
                        <h6>Description</h6>
                        <div
                            style={{ color: "var(--text-color1)" }}
                            dangerouslySetInnerHTML={{
                                __html: poolsdetail?.consensusExplanation,
                            }}
                        ></div>
                    </div>
                    <div className="bottom-btn">
                        <button onClick={handleCloseReasoning}>Close</button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            <CreateDisputeMenu showcreatedisputeOffCanvas={showcreatedisputeOffCanvas && (!isMobile || winnerProposalMode === WINNER_PROPOSAL_MODE.RESOLUTION)} setShowCreateDisputeOffCanvas={setShowCreateDisputeOffCanvas} handleShowCreateDispute={winnerProposalMode === WINNER_PROPOSAL_MODE.DISPUTE || winnerProposalMode === WINNER_PROPOSAL_MODE.APPEAL ? () => { setShowCreateDisputeOffCanvas(false); createPublicPoolDispute(); } : handleShowCreateDispute} title={title} setTitle={setTitle} description={description} setDescription={setDescription} files={files} setFiles={setFiles} isCreatorResponding={isCreatorResponding} poolsdetail={poolsdetail} mode={winnerProposalMode} smartAccount={smartAccount} proposedOutcome={proposedOutcome} setProposedOutcome={setProposedOutcome} handleConfirmCloseMarket={handleConfirmCloseMarket} disputeOrAppealText={disputeOrAppealText} evidenceType={evidenceType} setEvidenceType={setEvidenceType} contractAddress={address} tokenDecimals={tokenDecimals} tokenSymbol={tokenSymbol} bondAmount={winnerProposalMode === WINNER_PROPOSAL_MODE.DISPUTE || winnerProposalMode === WINNER_PROPOSAL_MODE.APPEAL ? requiredDisputeAmount : resolutionBondAmount} gasEstimateInUsdt={gasEstimateInUsdt} gasFeesSpinner={gasFeesSpinner} gasEstimationCloseMarket={gasEstimationCloseMarket} ownermatch={ownermatch} gasEstimationDispute={gasEstimationDispute} winnerData={winnerData} />
            <ProposedResolutionCanvas
                show={showAiResolutionCanvas}
                onHide={() => { setShowAiResolutionCanvas(false); setGasEstimateInUsdt(0); }}
                bondAmount={resolutionBondAmount}
                tokenSymbol={tokenSymbol}
                onSubmit={async () => {
                    await handleConfirmCloseMarket();
                    setShowAiResolutionCanvas(false);
                    setGasEstimateInUsdt(0);
                }}
                gasEstimateInUsdt={gasEstimateInUsdt}
                gasFeesSpinner={gasFeesSpinner}

                ownermatch={ownermatch}
                isAiResolver={isPublicPoolResolverAi}
            />
            <EvidenceFileMenu poolId={poolId} poolOwnerWalletAddress={poolsdetail?.poolOwnerWalletAddress} setShowCreateDisputeOffCanvas={setShowCreateDisputeOffCanvas} showevidence={showevidence} setShowEvidence={setShowEvidence} setIsCreatorResponding={setIsCreatorResponding} showevidenHistory={showevidenHistory} profilePic={poolsdetail?.poolOwnerprofilePic} resolverAddress={poolsdetail?.poolOwnerWalletAddress} claimNotDisputed={claimNotDisputed} decideWinnerEndTime={decideWinnerTime} claimEligibility={claimEligibility} setClaimNotDisputed={setClaimNotDisputed} disputeOrAppealText={disputeOrAppealText} handleShowCreateDispute={handleShowCreateDispute} setWinnerProposalMode={setWinnerProposalMode} decideWinnerTime={decideWinnerTime} isClaimWindowOpen={isClaimWindowOpen} poolsdetail={poolsdetail} isUnderDispute={isUnderDispute}
            />
            <Modal
                className="detail privatepollmodal"
                show={showPrivatePollModal}
                centered
            >
                <Modal.Body>
                    <PrivateMarketModal
                        onSuccess={() => {
                            setHasAccess(true);
                            setShowPrivatePollModal(false);
                        }} />
                </Modal.Body>
            </Modal>

            <Modal className="token liquiditymodal succes-dispute-modal" show={show13}
                onHide={handleClose13} centered>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img">
                                <svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47" fill="none">
                                    <path d="M39.063 11.7188L17.5795 33.2023L7.81421 23.4371" stroke="white" strokeWidth="2.70423" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <h2>Resolution Proposed</h2>
                            <p className="para">The market remains open for the duration of the dispute window.</p>
                        </div>
                        <div className="inner_side_modal1">
                            <button onClick={() => {
                                handleClose13();
                            }} className="close" >Done</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <OptionDetailMobileModal
                show={!!selectedOptionDetail}
                onHide={() => setSelectedOptionDetail(null)}
                tokenToDisplay={tokenToDisplay}
                selectedOptionDetail={selectedOptionDetail}
                setMblTradeModalOpen={setMblTradeModalOpen}
                setBuyOrSellTabActive={setBuyOrSellTabActive}
                setlimittab={setlimittab}
                tokenSymbol={tokenSymbol}
                tokenPriceToUsdt={tokenPriceToUsdt}
                isPoolFinalized={poolsdetail?.poolFinalized}
                setSkipPrediction={setSkipPrediction}
                onSelectBuyOption={(option) => setSelectedOption(option)}
                poolstart={poolstart}
                openWalletConnect={openWalletConnect}
                isClaimOpen={isClaimWindowOpen && !claimNotDisputed}
                initialposition={initialposition}
                dynamicPayoutArray={dynamicPayout}
            />
            <MarketRulesMobileModal
                show={showMarketRulesModal}
                onHide={() => setShowMarketRulesModal(false)}
                totalSumVolumn={totalSumVolumn}
                tokenToDisplay={tokenToDisplay}
                tokenSymbol={tokenSymbol}
                parsedPoolVolumn={parsedPoolVolumn}
                tokenPriceToUsdt={tokenPriceToUsdt}
                allliquidity={allliquidity}
                totalSumLiquidity={totalSumLiquidity}
                poolstart={poolstart}
                poolend={poolend}
                poolsdetail={poolsdetail}
                setPollStatus={setPollStatus}
                setIsDisabled={setIsDisabled}
            />
            <TradePlaceModals
                isMblTradeModalOpen={isMblTradeModalOpen}
                setMblTradeModalOpen={setMblTradeModalOpen}
                limittab={limittab}
                setlimittab={setlimittab}
                buyOrSellTabActive={buyOrSellTabActive}
                setBuyOrSellTabActive={setBuyOrSellTabActive}
                poolOptions={poolsdetail?.options}
                selectedOption={selectedOption}
                selectedOptionSelling={selectedOptionSelling}
                onSelectBuyOption={(option) => setSelectedOption(option)}
                onSelectSellOption={(option) => {
                    setSelectedOptionSelling(option);
                    setSelectedOptionBalanceSell(swapbalance?.[option._id] || 0);
                }}
                buy={buy}
                setBuy={setBuy}
                sharesAmount={sharesAmount}
                setSharesAmount={setSharesAmount}
                pricePerShare={pricePerShare}
                setPricePerShare={setPricePerShare}
                marketTokenBalance={marketTokenBalance}
                selectedOptionBalancesell={selectedOptionBalancesell}
                finalDynamicpay={finalDynamicpay}
                shareWeReceive={shareWeReceive}
                gasEstimateInUsdt={gasEstimateInUsdt}
                gasFeesSpinner={gasFeesSpinner}
                getSignOfBuy={getSignOfBuy}
                handlePlaceSellOrder={handlePlaceSellOrder}
                isButtonDisabled={isButtonDisabled}
                totalLimitBuying={totalLimitBuying}
                theme={theme}
                orderValueError={orderValueError}
                onBeforeTrade={(info) => { setMblSuccessInfo(info); }}
                tokenToDisplay={tokenToDisplay}
                priceoption={priceoption}
                volumn={volumn}
                tokenDecimals={tokenDecimals}
                skipPrediction={skipPrediction}
                isDisabled={isDisabled}
            />
            <SuccessModalMobile
                show={show10 && isMobile && (!!mblSuccessInfo || showMobileSuccess)}
                onHide={handleClose10}
                message={mblTitle || message}
                description={mblDescription || successDescription}
                isSellTransactionSucceed={isSellTransactionSucceed}
                mblSuccessInfo={mblSuccessInfo}
                showShare={!!mblSuccessInfo}
                shareSocialsModal={() => setOpenSocialModal(true)}
            />
            <ProgressModalMobile
                show={showMblProgress && isMobile}
                message={mblTitle || message}
                description={mblDescription}
                active={startProgressBar}
            />
            {!smartAccount && <WalletConnect onConnectCallback={setOpenWalletConnect} />}
            <ClaimModal
                show={showClaimModal}
                onHide={() => setShowClaimModal(false)}
                poolsdetail={poolsdetail}
                winnerData={winnerData}
                claimvalue={claimvalue}
                sumOfClaimvalue={sumOfClaimvalue}
                gasEstimateInUsdt={gasEstimateInUsdt}
                gasFeesSpinner={gasFeesSpinner}
                canClaim={!claimcheck && smartAccount && isClaimWindowOpen && !claimNotDisputed}
                claimcheck={claimcheck}
                getClaims={getClaims}
                tokenData={poolsdetail?.token}
                swapbalance={swapbalance}
                priceoption={priceoption}
                investedAmount={initialposition}
            />
            <DisputeOffcanvasMobile
                show={showcreatedisputeOffCanvas && isMobile && winnerProposalMode === WINNER_PROPOSAL_MODE.DISPUTE}
                onHide={() => setShowCreateDisputeOffCanvas(false)}
                poolsdetail={poolsdetail}
                winnerData={winnerData}
                proposedOutcome={proposedOutcome}
                setProposedOutcome={setProposedOutcome}
                title={title}
                setTitle={setTitle}
                description={description}
                setDescription={setDescription}
                files={files}
                setFiles={setFiles}
                bondAmount={requiredDisputeAmount}
                gasEstimateInUsdt={gasEstimateInUsdt}
                gasFeesSpinner={gasFeesSpinner}
                handleShowCreateDispute={() => { setShowCreateDisputeOffCanvas(false); createPublicPoolDispute(); }}
                theme={theme}
                tokenSymbol={tokenSymbol}
            />
            <MarketOutcomesMobileModal
                show={showOutcomesModal}
                onHide={() => setShowOutcomesModal(false)}
                options={optionsWithGraphPercentage}
                poolsdetail={poolsdetail}
                theme={theme}
                getBackgroundColor={getBackgroundColor} />
            <SolvencyLimitModal show={showSolvencyModal} onHide={() => setShowSolvencyModal(false)} />
        </>
    );
};

export default DetailPage;